<template>
  <v-app style="background-color: #f8f9fb">
    <!-- Dialog de Alerta para mensagens gerais -->
    <v-dialog v-model="alertDialog.show" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{ alertDialog.title }}</v-card-title>
        <v-card-text class="d-flex justify-center">
          {{ alertDialog.message }}
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn small color="primary" @click="alertDialog.show = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showFilter" persistent max-width="300">
      <v-card>
        <v-card-title> Mensagem </v-card-title>
        <v-card-text class="d-flex justify-center">
          A Diferença entre as datas não pode ser superior a 30 dias.
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Centraliza horizontalmente -->
          <v-btn color="primary" @click="showFilter = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Atribuição -->
    <v-dialog v-model="dialogAtribuir" max-width="400px" persistent>
      <v-card>
        <v-card-title class="headline">Confirmação de Atribuição</v-card-title>
        <v-card-text>
          <div class="mb-2">
            <strong>Falecido:</strong> {{ atribuirNomeFalecido }}<br />
            <strong>Etapa:</strong> {{ atribuirNomeEtapa }}
          </div>
          <div class="mt-2">
            Deseja se atribuir como responsável por esta atividade?
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small text color="grey" @click="fecharDialogAtribuir"
            >Cancelar</v-btn
          >
          <v-btn
            color="primary"
            @click="confirmarAtribuicao"
            small
            :disabled="!hasPermissionEdit"
            >Confirmar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Conclusão -->
    <v-dialog v-model="dialogConcluir" max-width="400px" persistent>
      <v-card>
        <v-card-title class="headline">Finalizar Atendimento</v-card-title>
        <v-card-text class="pb-0">
          <div class="mb-2">
            <strong>Falecido:</strong> {{ servicoAtual?.nomeFalecido }}
          </div>
          <div class="mt-2">Como deseja finalizar este atendimento?</div>
          <div class="d-flex justify-center mt-2">
            <v-btn
              color="red"
              small
              @click="concluirTicket('com-pedencia', servicoAtual)"
              >Com pedência</v-btn
            >
            <v-btn
              color="green"
              small
              @click="concluirTicket('concluido', servicoAtual)"
              >Concluído</v-btn
            >
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small text color="grey" @click="dialogConcluir = false"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Edição -->
    <v-dialog v-model="dialogEdicao" persistent max-width="1000">
      <v-card>
        <v-card-title class="text-h3">
          Serviço Cemitérial #{{ servicoEditando?.idAtendimento }}
          <p v-if="servicoEditando?.contrato">
            Contrato: {{ servicoEditando?.contrato }}
          </p>
          <v-spacer></v-spacer>
          <v-chip small :color="servicoEditando?.etapa?.cor" text-color="white">
            {{ servicoEditando?.etapa?.nome }}
          </v-chip>
        </v-card-title>
        <v-tabs v-model="tab" centered show-arrows class="custom-tabs">
          <v-tab>Geral</v-tab>
          <v-tab>Itens</v-tab>
          <v-tab>Operacional</v-tab>
          <v-tab>Histórico</v-tab>
        </v-tabs>

        <v-tabs-slider></v-tabs-slider>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-container>
                  <!-- 1. DADOS DO ATENDIMENTO -->
                  <v-row>
                    <v-col cols="12" class="my-2 pb-0">
                      <h3 class="mb-2 primary--text">Dados do Atendimento</h3>
                      <v-divider></v-divider>
                      <p class="text-caption grey--text mb-2">
                        Informações do atendimento.
                      </p>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.dataAtendimento"
                        label="Data do Atendimento"
                        type="datetime-local"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.valorAtendimento"
                        label="Valor (R$)"
                        type="number"
                        step="0.01"
                        prefix="R$"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.origem"
                        label="Local de Origem"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.destino"
                        label="Local de Destino"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-autocomplete
                        v-model="servicoEditando.donoAtendimento"
                        label="Dono do Atendimento"
                        :items="todosColaboradoresOrdenados"
                        item-text="nome"
                        item-value="id"
                        outlined
                        dense
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" class="my-2 pb-0">
                      <h3 class="mb-2 primary--text">Velório e Sepultamento</h3>
                      <v-divider></v-divider>
                      <p class="text-caption grey--text mb-2">
                        Informações sobre velório e sepultamento.
                      </p>
                    </v-col>

                    <!-- Local do Velório -->
                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.localVelorio"
                        label="Local do Velório"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <!-- Data do Velório -->
                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.dataVelorio"
                        label="Data e Hora do Velório"
                        type="datetime-local"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <!-- Local do Sepultamento -->
                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.localSepultamento"
                        label="Local do Sepultamento"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <!-- Data do Sepultamento -->
                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.dataSepultamento"
                        label="Data e Hora do Sepultamento"
                        type="datetime-local"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" class="py-0">
                      <v-textarea
                        v-model="servicoEditando.obs"
                        label="Observações"
                        outlined
                        dense
                        rows="4"
                      ></v-textarea>
                    </v-col>
                  </v-row>

                  <!-- 2. DADOS DO CLIENTE -->
                  <v-row>
                    <v-col cols="12" class="my-2 pb-0">
                      <h3 class="mb-2 primary--text">Dados do Cliente</h3>
                      <v-divider></v-divider>
                      <p class="text-caption grey--text mb-2">
                        Informações do cliente.
                      </p>
                    </v-col>

                    <v-col cols="12" md="8" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.cliente"
                        label="Nome do Cliente"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.cpfCliente"
                        label="CPF"
                        v-mask="'###.###.###-##'"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.atendente"
                        label="Atendente Responsável"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.cpfAtendente"
                        label="CPF do Atendente"
                        v-mask="'###.###.###-##'"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.contrato"
                        label="Nº Contrato"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.tipoContrato"
                        label="Tipo Contrato"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.empresa"
                        label="Tipo Contrato"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <!-- 2. Dados do Declarante -->
                  <v-row>
                    <v-col cols="12" class="mt-6 pb-0">
                      <h3 class="mb-2 primary--text">Dados do Declarante</h3>
                      <v-divider></v-divider>
                      <p class="text-caption grey--text mb-2">
                        Informações do declarante responsável pelo atendimento.
                      </p>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.declarante"
                        label="Nome do Declarante"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.cpfDeclarante"
                        label="CPF do Declarante"
                        v-mask="'###.###.###-##'"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.parentescoDeclarante"
                        label="Parentesco com o Falecido"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.contatoDeclarante"
                        label="Contato do Declarante"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <!-- 3. DADOS DO FALECIDO -->
                  <v-row>
                    <v-col cols="12" class="my-2 pb-0">
                      <h3 class="mb-2 primary--text">Dados do Falecido</h3>
                      <v-divider></v-divider>
                      <p class="text-caption grey--text mb-2">
                        Informações do falecido.
                      </p>
                    </v-col>

                    <v-col cols="12" md="8" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.nomeFalecido"
                        label="Nome Completo"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4" class="py-0">
                      <v-select
                        v-model="servicoEditando.etapa.id"
                        label="Etapa"
                        :items="colunas"
                        item-text="nome"
                        item-value="id"
                        outlined
                        dense
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="4" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.cpfFalecido"
                        label="CPF"
                        v-mask="'###.###.###-##'"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.causaMorte"
                        label="Causa da Morte"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.causaPrincipal"
                        label="Causa Principal"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.dtFalecido"
                        label="Data do Falecimento"
                        type="datetime-local"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.nascimentoFalecido"
                        label="Data de Nascimento"
                        type="date"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.religiao"
                        label="Religião"
                        type="text"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.alturaFalecido"
                        label="Altura (m)"
                        type="number"
                        step="0.01"
                        suffix="m"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="2" class="py-0">
                      <v-text-field
                        v-model="servicoEditando.pesoFalecido"
                        label="Peso (kg)"
                        type="number"
                        step="0.1"
                        suffix="kg"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" class="my-2 pb-0">
                      <div
                        class="d-flex justify-space-between align-center mb-2"
                      >
                        <h3 class="mb-2 primary--text">Itens do atendimento</h3>
                        <v-btn
                          color="primary"
                          small
                          outlined
                          @click="sincronizarItens(servicoEditando.id)"
                          v-if="hasPermissionEdit"
                        >
                          <v-icon small left>mdi-sync</v-icon>
                          Sincronizar itens
                        </v-btn>
                      </div>
                      <v-divider></v-divider>
                      <p class="text-caption grey--text mb-2">
                        Itens selecionados no atendimento.
                      </p>
                    </v-col>
                  </v-row>

                  <v-data-table
                    :headers="headersItens"
                    :items="servicoEditando.itens"
                    :items-per-page="10"
                    class="mt-2"
                    :footer-props="{
                      'items-per-page-options': [10, 25, 50, 100],
                      'items-per-page-text': 'Registros por página',
                    }"
                    fixed-header
                    :loading="servicoEditando.itens == null"
                    loading-text="Carregando itens..."
                    no-data-text="Nenhum item encontrado"
                  >
                    <template v-slot:item="{ item, index }">
                      <tr :class="[index % 2 === 0 ? 'cor-row' : '']">
                        <td
                          class="linha"
                          style="
                            font-size: 12px !important;
                            font-weight: normal;
                          "
                        >
                          {{ item.nomeItem }}
                          <v-chip
                            v-if="item.isUrna"
                            small
                            color="primary"
                            text-color="white"
                            class="ml-2"
                          >
                            Urna
                          </v-chip>
                        </td>
                        <td class="linha">
                          {{ item.nomeGradeItem }}
                        </td>
                        <td class="linha">
                          {{
                            item.valorOriginal.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })
                          }}
                        </td>
                        <td class="linha">{{ item.quantidade }}</td>
                        <td class="linha">
                          {{
                            item.valorUnitario.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })
                          }}
                        </td>
                        <td class="linha">
                          {{
                            item.descontoAplicado.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })
                          }}
                        </td>
                        <td class="linha">
                          {{
                            item.valorTotal.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })
                          }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" class="my-2 pb-0">
                      <h3 class="mb-2 primary--text">Gestão Operacional</h3>
                      <v-divider></v-divider>
                      <p class="text-caption grey--text mb-2">
                        Horários e colaboradores responsáveis pelo serviço.
                      </p>
                    </v-col>

                    <v-col cols="12" md="12" class="py-0">
                      <v-expansion-panels v-model="panel" accordion>
                        <v-expansion-panel
                          v-for="(coluna, index) in colunas.filter(
                            (c) => c.tipo === 'Em andamento',
                          )"
                          :key="coluna.id"
                          class="mb-2 rounded-lg"
                        >
                          <v-expansion-panel-header class="font-weight-medium">
                            <template v-slot:actions>
                              <v-icon color="primary">$expand</v-icon>
                            </template>
                            {{ coluna.nome }}
                          </v-expansion-panel-header>

                          <v-expansion-panel-content>
                            <v-card class="pa-1" flat>
                              <v-row v-if="coluna.nome === 'Preparação'">
                                <v-col cols="12" class="my-2 py-0">
                                  <h3 class="mb-2 primary--text">
                                    Somatoconservação
                                  </h3>
                                  <v-divider></v-divider>
                                  <p class="text-caption grey--text mb-2">
                                    Informações sobre somatoconservação.
                                  </p>
                                </v-col>

                                <!-- Uso de Somatoconservação -->
                                <v-col cols="12" md="6" class="py-0">
                                  <v-select
                                    v-model="
                                      servicoEditando.usoSomatoConservacao
                                    "
                                    :items="[
                                      { text: 'Sim', value: true },
                                      { text: 'Não', value: false },
                                    ]"
                                    item-text="text"
                                    item-value="value"
                                    label="Uso de Somatoconservação"
                                    outlined
                                    dense
                                  ></v-select>
                                </v-col>

                                <!-- Data de Início da Somatoconservação -->
                                <v-col cols="12" md="6" class="py-0">
                                  <v-text-field
                                    v-model="servicoEditando.dataInicioSomato"
                                    label="Data de Início da Somatoconservação"
                                    type="datetime-local"
                                    outlined
                                    dense
                                    :disabled="
                                      !servicoEditando.usoSomatoConservacao
                                    "
                                  ></v-text-field>
                                </v-col>

                                <!-- Data de Fim da Somatoconservação -->
                                <v-col cols="12" md="6" class="py-0">
                                  <v-text-field
                                    v-model="servicoEditando.dataFimSomato"
                                    label="Data de Fim da Somatoconservação"
                                    type="datetime-local"
                                    outlined
                                    dense
                                    :disabled="
                                      !servicoEditando.usoSomatoConservacao
                                    "
                                  ></v-text-field>
                                </v-col>

                                <v-col
                                  cols="12"
                                  md="6"
                                  class="py-0"
                                  v-if="
                                    servicoEditando.dataInicioSomato &&
                                    servicoEditando.dataFimSomato
                                  "
                                >
                                  <v-text-field
                                    label="Duração da Somatoconservação"
                                    type="text"
                                    outlined
                                    dense
                                    v-model="duracaoSomatoConservacao"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="6" md="6" class="py-0">
                                  <v-autocomplete
                                    v-model="
                                      servicoEditando.colaboradoresSomato
                                    "
                                    :items="listaColaboradores"
                                    item-text="nome"
                                    item-value="id"
                                    :label="`Colaboradores`"
                                    multiple
                                    clearable
                                    chips
                                    small-chips
                                    deletable-chips
                                    outlined
                                    dense
                                    height="60px"
                                  >
                                    <template
                                      v-slot:selection="{ item, index }"
                                    >
                                      <v-chip
                                        small
                                        v-if="index < 2"
                                        class="mr-1 mt-2"
                                      >
                                        {{ item.nome }}
                                      </v-chip>
                                      <span
                                        v-if="index === 2"
                                        class="grey--text text-caption ml-1 mt-2 d-inline-block"
                                      >
                                        (+{{
                                          servicoEditando.colaboradoresSomato
                                            .length - 2
                                        }})
                                      </span>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                              <v-row dense>
                                <v-col
                                  cols="12"
                                  class="my-2 py-0"
                                  v-if="coluna.nome === 'Preparação'"
                                >
                                  <h3 class="mb-2 primary--text">Preparação</h3>
                                  <v-divider></v-divider>
                                  <p class="text-caption grey--text mb-2">
                                    Informações sobre início e fim da etapa.
                                  </p>
                                </v-col>

                                <!-- Data Início -->
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="
                                      getEtapaRef(servicoEditando, coluna.id)
                                        .dtInicio
                                    "
                                    label="Início"
                                    type="datetime-local"
                                    dense
                                    outlined
                                    hide-details
                                  />
                                </v-col>

                                <!-- Data Fim -->
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="
                                      getEtapaRef(servicoEditando, coluna.id)
                                        .dtFim
                                    "
                                    label="Fim"
                                    type="datetime-local"
                                    dense
                                    outlined
                                    hide-details
                                  />
                                </v-col>
                                
                                <v-col
                                  cols="6"
                                  v-if="coluna.nome === 'Preparação'"
                                >
                                  <v-text-field
                                    v-model="
                                      getEtapaRef(servicoEditando, coluna.id)
                                        .salaPreparacao
                                    "
                                    label="Sala de Preparação"
                                    dense
                                    outlined
                                    hide-details
                                  />
                                </v-col>

                                <!-- Colaboradores -->
                                <v-col cols="12" class="pb-2">
                                  <v-autocomplete
                                    :items="listaColaboradores"
                                    item-text="nome"
                                    item-value="id"
                                    :label="`Colaboradores - ${coluna.nome}`"
                                    multiple
                                    clearable
                                    chips
                                    small-chips
                                    deletable-chips
                                    outlined
                                    dense
                                    hide-details
                                    height="60px"
                                    :value="
                                      getEtapaRef(servicoEditando, coluna.id)
                                        .colaboradores
                                    "
                                    @input="
                                      (val) => updateEtapa(coluna.id, val)
                                    "
                                  >
                                    <template
                                      v-slot:selection="{ item, index }"
                                    >
                                      <v-chip
                                        small
                                        v-if="index < 2"
                                        class="mr-1 mt-2"
                                      >
                                        {{ item.nome }}
                                      </v-chip>
                                      <span
                                        v-if="index === 2"
                                        class="grey--text text-caption ml-1 mt-2 d-inline-block"
                                      >
                                        (+{{
                                          getEtapaRef(
                                            servicoEditando,
                                            coluna.id,
                                          ).colaboradores.length - 2
                                        }})
                                      </span>
                                    </template>
                                  </v-autocomplete>
                                </v-col>

                                <!-- Supervisores -->
                                <v-col cols="12" class="pb-2">
                                  <v-autocomplete
                                    :items="listaColaboradores"
                                    item-text="nome"
                                    item-value="id"
                                    :label="`Supervisores - ${coluna.nome}`"
                                    multiple
                                    clearable
                                    chips
                                    small-chips
                                    deletable-chips
                                    outlined
                                    dense
                                    hide-details
                                    :value="
                                      getEtapaRef(servicoEditando, coluna.id)
                                        .supervisores
                                    "
                                    @input="
                                      (val) =>
                                        updateEtapaSupervisores(coluna.id, val)
                                    "
                                  >
                                    <template
                                      v-slot:selection="{ item, index }"
                                    >
                                      <v-chip
                                        small
                                        v-if="index < 2"
                                        class="mr-1 mt-2"
                                      >
                                        {{ item.nome }}
                                      </v-chip>
                                      <span
                                        v-if="index === 2"
                                        class="grey--text text-caption ml-1 mt-2 d-inline-block"
                                      >
                                        (+{{
                                          getEtapaRef(
                                            servicoEditando,
                                            coluna.id,
                                          ).supervisores.length - 2
                                        }})
                                      </span>
                                    </template>
                                  </v-autocomplete>
                                </v-col>

                                <!-- Observações -->
                                <v-col cols="12" class="pb-0">
                                  <v-textarea
                                    v-model="
                                      getEtapaRef(servicoEditando, coluna.id)
                                        .observacoes
                                    "
                                    label="Observações"
                                    outlined
                                    dense
                                    rows="3"
                                    auto-grow
                                    hide-details
                                  ></v-textarea>
                                </v-col>

                                <!-- Toggle para Ocorrência -->
                                <v-col cols="12" class="d-flex">
                                  <v-btn
                                    text
                                    small
                                    color="primary"
                                    @click="toggleOcorrenciaEdicao(coluna.id)"
                                    class="mr-2"
                                  >
                                    <v-icon left>
                                      {{
                                        etapasComOcorrencia.includes(coluna.id)
                                          ? "mdi-chevron-up"
                                          : "mdi-chevron-down"
                                      }}
                                    </v-icon>
                                    {{
                                      etapasComOcorrencia.includes(coluna.id)
                                        ? "Ocultar"
                                        : "Mostrar"
                                    }}
                                    Ocorrência
                                  </v-btn>

                                  <!-- Toggle para Atividades -->
                                  <v-btn
                                    text
                                    small
                                    color="success"
                                    @click="toggleAtividades(coluna.id)"
                                  >
                                    <v-icon left>
                                      {{
                                        etapasComAtividades.includes(coluna.id)
                                          ? "mdi-chevron-up"
                                          : "mdi-chevron-down"
                                      }}
                                    </v-icon>
                                    {{
                                      etapasComAtividades.includes(coluna.id)
                                        ? "Ocultar"
                                        : "Mostrar"
                                    }}
                                    Atividades
                                  </v-btn>
                                </v-col>

                                <!-- Campos de Ocorrência (condicionais) -->
                                <template
                                  v-if="etapasComOcorrencia.includes(coluna.id)"
                                >
                                  <!-- Ocorrência -->
                                  <v-col cols="12" md="8" class="pt-0">
                                    <v-textarea
                                      v-model="
                                        getEtapaRef(servicoEditando, coluna.id)
                                          .ocorrenciaJustificativa
                                      "
                                      label="Ocorrência"
                                      outlined
                                      dense
                                      rows="2"
                                      auto-grow
                                      placeholder="Descreva a ocorrência..."
                                    ></v-textarea>
                                  </v-col>

                                  <!-- Tempo da Ocorrência -->
                                  <v-col cols="12" md="4">
                                    <v-text-field
                                      v-model="
                                        getEtapaRef(servicoEditando, coluna.id)
                                          .tempoOcorrenciaFormatted
                                      "
                                      label="Tempo (hh:mm)"
                                      outlined
                                      dense
                                      type="time"
                                      step="60"
                                      placeholder="00:00"
                                      @input="
                                        updateTempoOcorrencia(coluna.id, $event)
                                      "
                                    ></v-text-field>
                                  </v-col>
                                </template>

                                <!-- Campos de Atividades (condicionais) -->
                                <template
                                  v-if="etapasComAtividades.includes(coluna.id)"
                                >
                                  <v-col cols="12" class="pt-0">
                                    <v-card outlined class="pa-3 mb-3">
                                      <h4 class="mb-2">
                                        Atividades da Etapa - {{ coluna.nome }}
                                      </h4>

                                      <!-- Formulário para adicionar nova atividade na etapa -->
                                      <v-row>
                                        <v-col cols="12">
                                          <v-card
                                            class="pa-3 mb-3"
                                            :id="`atividade-form-${coluna.id}`"
                                            elevation="0"
                                          >
                                            <v-row>
                                              <v-col cols="12" md="6">
                                                <!-- Modo de edição: mostrar campo de texto desabilitado com a atividade atual -->
                                                <template
                                                  v-if="modoEdicaoAtividade"
                                                >
                                                  <v-text-field
                                                    v-model="
                                                      novaAtividade.atividadeFunerariaDescricao
                                                    "
                                                    label="Atividade"
                                                    outlined
                                                    dense
                                                    readonly
                                                    persistent-hint
                                                  ></v-text-field>
                                                </template>
                                                <!-- Modo normal: mostrar select para escolher atividade -->
                                                <template v-else>
                                                  <v-select
                                                    v-model="
                                                      novaAtividade.atividadeFunerariaId
                                                    "
                                                    :items="
                                                      getAtividadesDisponiveisDaEtapa(
                                                        servicoEditando,
                                                        coluna.id,
                                                      )
                                                    "
                                                    item-text="descricao"
                                                    item-value="id"
                                                    label="Selecionar Atividade"
                                                    outlined
                                                    dense
                                                    :loading="
                                                      atividadesDisponiveis ==
                                                      null
                                                    "
                                                    :disabled="
                                                      !getAtividadesDisponiveisDaEtapa(
                                                        servicoEditando,
                                                        coluna.id,
                                                      ) ||
                                                      getAtividadesDisponiveisDaEtapa(
                                                        servicoEditando,
                                                        coluna.id,
                                                      ).length === 0
                                                    "
                                                  ></v-select>
                                                </template>
                                              </v-col>
                                              <v-col cols="12" md="6">
                                                <v-text-field
                                                  v-model="
                                                    novaAtividade.dtInicio
                                                  "
                                                  label="Data/Hora Início"
                                                  type="datetime-local"
                                                  outlined
                                                  dense
                                                ></v-text-field>
                                              </v-col>
                                              <v-col cols="12" md="6">
                                                <v-text-field
                                                  v-model="novaAtividade.dtFim"
                                                  label="Data/Hora Fim"
                                                  type="datetime-local"
                                                  outlined
                                                  dense
                                                ></v-text-field>
                                              </v-col>
                                              <v-col cols="12" md="6">
                                                <v-autocomplete
                                                  v-model="
                                                    novaAtividade.colaboradores
                                                  "
                                                  :items="listaColaboradores"
                                                  item-text="nome"
                                                  item-value="id"
                                                  label="Colaboradores"
                                                  multiple
                                                  clearable
                                                  chips
                                                  small-chips
                                                  deletable-chips
                                                  outlined
                                                  dense
                                                >
                                                  <template
                                                    v-slot:selection="{
                                                      item,
                                                      index,
                                                    }"
                                                  >
                                                    <v-chip
                                                      small
                                                      v-if="index < 2"
                                                      class="mr-1 mt-2"
                                                    >
                                                      {{ item.nome }}
                                                    </v-chip>
                                                    <span
                                                      v-if="
                                                        index === 2 &&
                                                        getNovaAtividadeEtapaColaboradores(
                                                          coluna.id,
                                                        ).length > 2
                                                      "
                                                      class="grey--text text-caption ml-1 mt-2 d-inline-block"
                                                    >
                                                      (+{{
                                                        getNovaAtividadeEtapaColaboradores(
                                                          coluna.id,
                                                        ).length - 2
                                                      }})
                                                    </span>
                                                  </template>
                                                </v-autocomplete>
                                              </v-col>
                                            </v-row>
                                            <!-- dialog etapas operacionais -->
                                            <v-row>
                                              <v-col
                                                cols="12"
                                                class="d-flex justify-end"
                                              >
                                                <v-btn
                                                  v-if="modoEdicaoAtividade"
                                                  color="red"
                                                  text
                                                  small
                                                  class="mr-2"
                                                  @click="
                                                    cancelarEdicaoAtividade
                                                  "
                                                  :disabled="
                                                    salvandoAtividadeEtapa ===
                                                    coluna.id
                                                  "
                                                >
                                                  Cancelar
                                                </v-btn>
                                                <v-btn
                                                  color="primary"
                                                  small
                                                  @click="
                                                    modoEdicaoAtividade
                                                      ? atualizarAtividade(
                                                          coluna.id,
                                                        )
                                                      : salvarAtividade(
                                                          coluna.id,
                                                          servicoEditando.id,
                                                        )
                                                  "
                                                  :loading="
                                                    salvandoAtividadeEtapa ===
                                                    coluna.id
                                                  "
                                                  :disabled="
                                                    !atividadeCompleta(
                                                      novaAtividade,
                                                    ) || !hasPermissionEdit
                                                  "
                                                >
                                                  <v-icon left>{{
                                                    modoEdicaoAtividade
                                                      ? "mdi-content-save"
                                                      : "mdi-plus"
                                                  }}</v-icon>
                                                  {{
                                                    modoEdicaoAtividade
                                                      ? "Atualizar Atividade"
                                                      : "Salvar Atividade"
                                                  }}
                                                </v-btn>
                                              </v-col>
                                            </v-row>
                                          </v-card>
                                        </v-col>
                                      </v-row>

                                      <!-- Tabela de atividades da etapa -->
                                      <v-data-table
                                        :headers="atividadesHeadersv2"
                                        :items="
                                          getAtividadesDaEtapa(
                                            servicoEditando,
                                            coluna.id,
                                          )
                                        "
                                        hide-default-footer
                                        dense
                                        class="elevation-0"
                                        :no-data-text="'Nenhuma atividade registrada nesta etapa'"
                                      >
                                        <template
                                          v-slot:item.detalhes="{ item }"
                                        >
                                          <div class="d-flex flex-column">
                                            <!-- Início -->
                                            <span
                                              class="text-caption grey--text"
                                            >
                                              Início
                                            </span>
                                            <span class="font-weight-medium">
                                              {{
                                                formatarDataHora(
                                                  item.dtInicio,
                                                ) || "-"
                                              }}
                                            </span>

                                            <!-- Fim -->
                                            <span
                                              class="text-caption grey--text mt-2"
                                            >
                                              Fim
                                            </span>
                                            <span class="font-weight-medium">
                                              {{
                                                formatarDataHora(item.dtFim) ||
                                                "-"
                                              }}
                                            </span>

                                            <!-- Colaboradores -->
                                            <span
                                              class="text-caption grey--text mt-2"
                                            >
                                              Colaboradores
                                            </span>

                                            <div
                                              v-if="item.colaboradores?.length"
                                            >
                                              <v-chip
                                                v-for="colaborador in item.colaboradores.slice(
                                                  0,
                                                  2,
                                                )"
                                                :key="colaborador.colaboradorId"
                                                x-small
                                                class="mr-1 mb-1"
                                              >
                                                {{
                                                  getNomeColaborador(
                                                    colaborador.colaboradorId,
                                                  )
                                                }}
                                              </v-chip>

                                              <span
                                                v-if="
                                                  item.colaboradores.length > 2
                                                "
                                                class="grey--text text-caption"
                                              >
                                                (+{{
                                                  item.colaboradores.length - 2
                                                }})
                                              </span>
                                            </div>

                                            <span
                                              v-else
                                              class="grey--text text-caption"
                                              >-</span
                                            >
                                          </div>
                                        </template>

                                        <template v-slot:item.acoes="{ item }">
                                          <div class="d-flex align-center">
                                            <v-btn
                                              text
                                              small
                                              color="primary"
                                              class="mr-1"
                                              @click="editarAtividade(item)"
                                              :disabled="
                                                editandoAtividade ||
                                                !hasPermissionEdit
                                              "
                                            >
                                              <v-icon x-small
                                                >mdi-pencil</v-icon
                                              >
                                            </v-btn>
                                            <v-btn
                                              text
                                              small
                                              color="error"
                                              @click="excluirAtividade(item.id)"
                                              :loading="
                                                excluindoAtividade === item.id
                                              "
                                              :disabled="!hasPermissionEdit"
                                            >
                                              <v-icon x-small
                                                >mdi-delete</v-icon
                                              >
                                            </v-btn>
                                          </div>
                                        </template>
                                      </v-data-table>
                                    </v-card>
                                  </v-col>
                                  <v-col cols="12">
                                    <!-- Checklist de atividades -->
                                    <v-row class="mt-0">
                                      <v-col cols="12">
                                        <v-card outlined class="pa-4">
                                          <h4 class="mb-3">
                                            Checklist de Atividades da Etapa
                                          </h4>

                                          <div
                                            v-if="
                                              getTodasAtividadesDisponiveis(
                                                coluna.id,
                                              ).length > 0
                                            "
                                          >
                                            <v-checkbox
                                              v-for="atividade in getTodasAtividadesDisponiveis(
                                                coluna.id,
                                              )"
                                              :key="atividade.id"
                                              :label="atividade.descricao"
                                              :input-value="
                                                isAtividadeCadastrada(
                                                  atividade.id,
                                                  coluna.id,
                                                )
                                              "
                                              disabled
                                              color="success"
                                              class="my-0"
                                            >
                                              <template v-slot:label>
                                                <span
                                                  :class="
                                                    isAtividadeCadastrada(
                                                      atividade.id,
                                                      coluna.id,
                                                    )
                                                      ? 'success--text font-weight-bold'
                                                      : 'grey--text'
                                                  "
                                                >
                                                  {{ atividade.descricao }}
                                                  <v-chip
                                                    v-if="
                                                      isAtividadeCadastrada(
                                                        atividade.id,
                                                        coluna.id,
                                                      )
                                                    "
                                                    x-small
                                                    color="success"
                                                    text-color="white"
                                                    class="ml-2"
                                                  >
                                                    ✓ Cadastrada
                                                  </v-chip>
                                                </span>
                                              </template>
                                            </v-checkbox>
                                          </div>
                                          <div
                                            v-else
                                            class="text-center grey--text"
                                          >
                                            Nenhuma atividade disponível para
                                            esta etapa
                                          </div>
                                        </v-card>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </template>

                                <v-row
                                  v-if="coluna.nome === 'Transporte familiar'"
                                  class="mt-4"
                                >
                                  <v-col cols="12" class="my-2 py-0">
                                    <h3 class="mb-2 primary--text">
                                      Transporte
                                    </h3>
                                    <v-divider></v-divider>
                                    <p class="text-caption grey--text mb-2">
                                      Informações sobre transporte.
                                    </p>
                                  </v-col>

                                  <!-- Solicitação de Transporte Familiar -->
                                  <v-col cols="12" md="6" class="py-0">
                                    <v-select
                                      v-model="
                                        servicoEditando.solicitacaoTransporteFamiliar
                                      "
                                      :items="[
                                        'A DEFINIR',
                                        'SOLICITADO',
                                        'SOLICITADO PARCIALMENTE',
                                        'DISPENSADO',
                                        'NÃO DISPONIBILIZADO FORA ÁREA DE COBERTURA',
                                      ]"
                                      label="Solicitação de Transporte Familiar"
                                      outlined
                                      dense
                                    ></v-select>
                                  </v-col>

                                  <!-- Tipo de Transporte Familiar -->
                                  <v-col cols="12" md="6" class="py-0">
                                    <v-select
                                      v-model="
                                        servicoEditando.tipoTransporteFamiliar
                                      "
                                      label="Tipo de Transporte Familiar"
                                      outlined
                                      dense
                                      :items="[
                                        'FROTA PRÓPRIA',
                                        'FROTA TERCEIRIZADA',
                                      ]"
                                      :disabled="
                                        !(
                                          servicoEditando.solicitacaoTransporteFamiliar ||
                                          ''
                                        ).includes('SOLICITADO')
                                      "
                                    ></v-select>
                                  </v-col>
                                  <v-col
                                    cols="6"
                                    md="6"
                                    class="py-0"
                                    v-if="
                                      servicoEditando.solicitacaoTransporteFamiliar ===
                                      'SOLICITADO PARCIALMENTE'
                                    "
                                  >
                                    <v-checkbox
                                      v-model="
                                        servicoEditando.idaTransporteFamiliar
                                      "
                                      label="Ida de Transporte Familiar"
                                      outlined
                                      dense
                                    ></v-checkbox>
                                  </v-col>
                                  <v-col
                                    cols="6"
                                    md="6"
                                    class="py-0"
                                    v-if="
                                      servicoEditando.solicitacaoTransporteFamiliar ===
                                      'SOLICITADO PARCIALMENTE'
                                    "
                                  >
                                    <v-checkbox
                                      v-model="
                                        servicoEditando.voltaTransporteFamiliar
                                      "
                                      label="Volta de Transporte Familiar"
                                      outlined
                                      dense
                                    ></v-checkbox>
                                  </v-col>

                                  <!-- Origem do Transporte Familiar -->
                                  <v-col cols="12" md="6" class="py-0">
                                    <v-text-field
                                      v-model="
                                        servicoEditando.origemTransporteFamiliar
                                      "
                                      label="Origem do Transporte Familiar"
                                      outlined
                                      dense
                                    ></v-text-field>
                                  </v-col>

                                  <!-- Destino do Transporte Familiar -->
                                  <v-col cols="12" md="6" class="py-0">
                                    <v-text-field
                                      v-model="
                                        servicoEditando.destinoTransporteFamiliar
                                      "
                                      label="Destino do Transporte Familiar"
                                      outlined
                                      dense
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="12" md="12" class="py-0">
                                    <v-textarea
                                      v-model="
                                        servicoEditando.observacoesTransporteFamiliar
                                      "
                                      rows="2"
                                      label="Observações do Transporte Familiar"
                                      outlined
                                      dense
                                    ></v-textarea>
                                  </v-col>
                                </v-row>
                              </v-row>
                              <v-row
                                v-if="coluna.nome === 'Velório'"
                                class="mt-4"
                              >
                                <v-col cols="12" class="my-2 pb-0">
                                  <h3 class="mb-2 primary--text">
                                    Velório e Sepultamento
                                  </h3>
                                  <v-divider></v-divider>
                                  <p class="text-caption grey--text mb-2">
                                    Informações sobre velório e sepultamento.
                                  </p>
                                </v-col>

                                <!-- Local do Velório -->
                                <v-col cols="12" md="6" class="py-0">
                                  <v-text-field
                                    v-model="servicoEditando.localVelorio"
                                    label="Local do Velório"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>

                                <!-- Local do Sepultamento -->
                                <v-col cols="12" md="6" class="py-0">
                                  <v-text-field
                                    v-model="servicoEditando.localSepultamento"
                                    label="Local do Sepultamento"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>

                                <!-- Data do Sepultamento -->
                                <v-col cols="12" md="6" class="py-0">
                                  <v-text-field
                                    v-model="servicoEditando.dataSepultamento"
                                    label="Data e Hora do Sepultamento"
                                    type="datetime-local"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" class="my-2 pb-0">
                      <h3 class="mb-2 primary--text">
                        Histórico de Alterações
                      </h3>
                      <v-divider></v-divider>
                      <p class="text-caption grey--text mb-2">
                        Registro de alterações realizadas neste atendimento.
                      </p>
                    </v-col>
                  </v-row>

                  <v-data-table
                    :headers="historicoHeaders"
                    :items="historico"
                    :items-per-page="10"
                    class="mt-2"
                    :footer-props="{
                      'items-per-page-options': [10, 25, 50, 100],
                      'items-per-page-text': 'Registros por página',
                    }"
                    fixed-header
                    :loading="historico == null"
                    loading-text="Carregando histórico..."
                    no-data-text="Nenhum registro de histórico encontrado"
                  >
                    <!-- Linha customizada com classes -->
                    <template v-slot:item="{ item, index }">
                      <tr :class="[index % 2 === 0 ? 'cor-row' : '']">
                        <td class="linha" style="font-size: 12px">
                          {{ item.campoAlterado }}
                        </td>
                        <td class="linha" style="width: 15%">
                          {{ item.valorAntigo }}
                        </td>
                        <td class="linha" style="width: 15%">
                          {{ item.valorNovo }}
                        </td>
                        <td class="linha">{{ item.dataAlteracao }}</td>
                        <td class="linha">
                          {{ truncateString(item.usuarioResponsavel, 20) }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>

        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text small @click="fecharDialog">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            small
            @click="salvarEdicao"
            v-if="hasPermissionEdit"
          >
            Salvar Alterações
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG DE ETAPA ESPECÍFICA (PLAY/CHECK) -->
    <v-dialog v-model="dialogEtapa" max-width="1000px" persistent>
      <v-card>
        <v-card-title class="text-h3">
          <h3
            class="mb-2"
            :class="etapaAcao === 'iniciar' ? 'primary--text' : 'success--text'"
          >
            {{ etapaAcao === "iniciar" ? "Iniciar" : "Finalizar" }} etapa <br />
          </h3>

          <v-divider></v-divider>

          <p class="text-caption grey--text mb-2">
            {{
              etapaAcao === "iniciar"
                ? "Registrar início"
                : "Registrar conclusão"
            }}
            da etapa
            <v-chip
              :color="etapaAtual?.cor"
              x-small
              class="ml-1"
              text-color="white"
              >{{ etapaAtual?.nome }}</v-chip
            >
          </p>
          <p>{{ servicoAtual?.nomeFalecido }}</p>
        </v-card-title>

        <v-card-text class="pt-0">
          <v-container>
            <v-row v-if="etapaAtual?.nome === 'Preparação'">
              <v-col cols="12" class="my-2 py-0">
                <h3 class="mb-2 primary--text">Somatoconservação</h3>
                <v-divider></v-divider>
                <p class="text-caption grey--text mb-2">
                  Informações sobre somatoconservação.
                </p>
              </v-col>

              <!-- Uso de Somatoconservação -->
              <v-col cols="12" md="6" class="py-0">
                <v-select
                  v-model="servicoAtual.usoSomatoConservacao"
                  :items="[
                    { text: 'Sim', value: true },
                    { text: 'Não', value: false },
                  ]"
                  item-text="text"
                  item-value="value"
                  label="Uso de Somatoconservação"
                  outlined
                  dense
                ></v-select>
              </v-col>

              <!-- Data de Início da Somatoconservação -->
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="servicoAtual.dataInicioSomato"
                  label="Data de Início da Somatoconservação"
                  type="datetime-local"
                  outlined
                  dense
                  :disabled="!servicoAtual.usoSomatoConservacao"
                ></v-text-field>
              </v-col>

              <!-- Data de Fim da Somatoconservação -->
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="servicoAtual.dataFimSomato"
                  label="Data de Fim da Somatoconservação"
                  type="datetime-local"
                  outlined
                  dense
                  :disabled="!servicoAtual.usoSomatoConservacao"
                ></v-text-field>
              </v-col>

              <v-col cols="6" md="6" class="py-0">
                <v-autocomplete
                  :disabled="!servicoAtual.usoSomatoConservacao"
                  v-model="colaboradoresTempSomato"
                  :items="listaColaboradores"
                  item-text="nome"
                  item-value="id"
                  :label="`Colaboradores`"
                  multiple
                  clearable
                  chips
                  small-chips
                  deletable-chips
                  outlined
                  dense
                  height="60px"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip small v-if="index < 2" class="mr-1 mt-2">
                      {{ item.nome }}
                    </v-chip>
                    <span
                      v-if="index === 2"
                      class="grey--text text-caption ml-1 mt-2 d-inline-block"
                    >
                      (+{{ colaboradoresTempSomato.length - 2 }})
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                class="my-2 py-0"
                v-if="etapaAtual?.nome === 'Preparação'"
              >
                <h3 class="mb-2 primary--text">Preparação</h3>
                <v-divider></v-divider>
                <p class="text-caption grey--text mb-2">
                  Informações sobre início e fim da etapa.
                </p>
              </v-col>
              <!-- Data e Hora -->
              <v-col cols="12">
                <v-text-field
                  v-model="etapaDadosTemp.dataHoraInicio"
                  label="Data/Hora de Início"
                  type="datetime-local"
                  dense
                  outlined
                  hide-details
                />
              </v-col>

              <!-- Data e Hora -->
              <v-col cols="12">
                <v-text-field
                  v-model="etapaDadosTemp.dataHoraFim"
                  label="Data/Hora de Conclusão"
                  type="datetime-local"
                  dense
                  outlined
                  hide-details
                />
              </v-col>

              <v-col
                cols="6"
                class="pt-0"
                v-if="etapaAtual?.nome === 'Preparação'"
              >
                <v-text-field
                  v-model="etapaDadosTemp.salaPreparacao"
                  label="Sala de Preparação"
                  dense
                  outlined
                  hide-details
                />
              </v-col>

              <!-- Colaboradores -->
              <v-col cols="10" md="10" class="pb-0">
                <v-autocomplete
                  v-model="etapaDadosTemp.colaboradores"
                  :items="listaColaboradores"
                  item-text="nome"
                  item-value="id"
                  :label="`Colaboradores`"
                  multiple
                  clearable
                  chips
                  small-chips
                  deletable-chips
                  hide-details
                  outlined
                  dense
                  height="60px"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip small v-if="index < 2" class="mr-1 mt-2">
                      {{ item.nome }}
                    </v-chip>
                    <span
                      v-if="index === 2"
                      class="grey--text text-caption ml-1 mt-2 d-inline-block"
                    >
                      (+{{ etapaDadosTemp.colaboradores.length - 2 }})
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="2" md="2">
                <v-btn color="primary" small @click="adicionarColaboradorInput">
                  <v-icon>mdi-account-group</v-icon>
                </v-btn>
              </v-col>

              <!-- Supervisores -->
              <v-col cols="12" class="pb-0">
                <v-autocomplete
                  v-model="etapaDadosTemp.supervisores"
                  :items="listaColaboradores"
                  item-text="nome"
                  item-value="id"
                  :label="`Supervisores`"
                  multiple
                  clearable
                  chips
                  hide-details
                  small-chips
                  deletable-chips
                  outlined
                  dense
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip small v-if="index < 2" class="mr-1 mt-2">
                      {{ item.nome }}
                    </v-chip>
                    <span
                      v-if="index === 2"
                      class="grey--text text-caption ml-1 mt-2 d-inline-block"
                    >
                      (+{{ etapaDadosTemp.supervisores.length - 2 }})
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>

              <!-- Observações -->
              <v-col cols="12">
                <v-textarea
                  v-model="etapaDadosTemp.observacoes"
                  label="Observações"
                  outlined
                  hide-details
                  dense
                  rows="3"
                  auto-grow
                ></v-textarea>
              </v-col>

              <!-- Toggle para Ocorrência -->
              <v-col cols="6">
                <v-btn
                  text
                  small
                  color="primary"
                  @click="toggleOcorrenciaEtapa"
                >
                  <v-icon left>
                    {{
                      etapasComOcorrencia.includes(etapaAtual?.id)
                        ? "mdi-chevron-up"
                        : "mdi-chevron-down"
                    }}
                  </v-icon>
                  {{
                    etapasComOcorrencia.includes(etapaAtual?.id)
                      ? "Ocultar"
                      : "Mostrar"
                  }}
                  Ocorrência
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  text
                  small
                  color="primary"
                  @click="toggleAtividades(etapaAtual?.id)"
                >
                  <v-icon left>
                    {{
                      etapasComAtividades.includes(etapaAtual?.id)
                        ? "mdi-chevron-up"
                        : "mdi-chevron-down"
                    }}
                  </v-icon>
                  {{
                    etapasComAtividades.includes(etapaAtual?.id)
                      ? "Ocultar"
                      : "Mostrar"
                  }}
                  atividades
                </v-btn>
              </v-col>

              <template v-if="etapasComAtividades.includes(etapaAtual?.id)">
                <v-col cols="12" class="pt-0">
                  <v-card flat class="pa-3 pt-0">
                    <!-- Formulário para adicionar nova atividade -->
                    <v-row class="mt-3">
                      <v-col cols="12" class="py-0">
                        <h4>
                          {{
                            modoEdicaoAtividade
                              ? "Editar Atividade"
                              : "Adicionar Nova Atividade"
                          }}
                        </h4>
                      </v-col>
                      <v-col cols="12" md="6">
                        <!-- Modo de edição: mostrar campo de texto desabilitado com a atividade atual -->
                        <template v-if="modoEdicaoAtividade">
                          <v-text-field
                            v-model="novaAtividade.atividadeFunerariaDescricao"
                            label="Atividade"
                            outlined
                            dense
                            readonly
                            persistent-hint
                            hide-details
                          ></v-text-field>
                        </template>
                        <!-- Modo normal: mostrar select para escolher atividade -->
                        <template v-else>
                          <v-select
                            v-model="novaAtividade.atividadeFunerariaId"
                            :items="
                              getAtividadesDisponiveisDaEtapa(
                                servicoAtual,
                                etapaAtual?.id,
                              )
                            "
                            item-text="descricao"
                            item-value="id"
                            label="Atividade"
                            outlined
                            dense
                            hide-details
                            :disabled="
                              !getAtividadesDisponiveisDaEtapa(
                                servicoAtual,
                                etapaAtual?.id,
                              ) ||
                              getAtividadesDisponiveisDaEtapa(
                                servicoAtual,
                                etapaAtual?.id,
                              ).length === 0
                            "
                          ></v-select>
                        </template>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-autocomplete
                          v-model="novaAtividade.colaboradores"
                          :items="listaColaboradores"
                          item-text="nome"
                          item-value="id"
                          label="Colaboradores"
                          multiple
                          clearable
                          chips
                          small-chips
                          deletable-chips
                          outlined
                          dense
                          hide-details
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="novaAtividade.dtInicio"
                          label="Data/Hora de Início"
                          type="datetime-local"
                          outlined
                          dense
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="novaAtividade.dtFim"
                          label="Data/Hora de Fim"
                          type="datetime-local"
                          outlined
                          dense
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <!-- dialog iniciar/finalizar etapa -->
                      <v-col cols="12" class="text-right">
                        <v-btn
                          v-if="modoEdicaoAtividade"
                          color="red"
                          text
                          small
                          class="mr-2"
                          @click="cancelarEdicaoAtividade"
                          :disabled="salvandoAtividadeEtapa === etapaAtual?.id"
                        >
                          Cancelar
                        </v-btn>
                        <v-btn
                          color="primary"
                          small
                          @click="
                            modoEdicaoAtividade
                              ? atualizarAtividade(etapaAtual?.id)
                              : salvarAtividade(etapaAtual?.id, servicoAtual.id)
                          "
                          :loading="salvandoAtividadeEtapa === etapaAtual?.id"
                          :disabled="
                            !atividadeCompleta(novaAtividade) ||
                            !hasPermissionEdit
                          "
                        >
                          <v-icon left small>{{
                            modoEdicaoAtividade
                              ? "mdi-content-save"
                              : "mdi-plus"
                          }}</v-icon>
                          {{
                            modoEdicaoAtividade
                              ? "Atualizar Atividade"
                              : "Salvar Atividade"
                          }}
                        </v-btn>
                      </v-col>
                    </v-row>
                    <h4 class="mb-2">Atividades da Etapa</h4>
                    <!-- Tabela de atividades da etapa -->
                    <v-data-table
                      :headers="atividadesHeaders"
                      :items="
                        getAtividadesDaEtapa(servicoAtual, etapaAtual?.id)
                      "
                      hide-default-footer
                      dense
                      class="elevation-0"
                      :no-data-text="'Nenhuma atividade registrada nesta etapa'"
                    >
                      <template v-slot:item.dtInicio="{ item }">
                        {{ formatarDataHora(item.dtInicio) }}
                      </template>
                      <template v-slot:item.dtFim="{ item }">
                        {{ formatarDataHora(item.dtFim) }}
                      </template>
                      <template v-slot:item.colaboradores="{ item }">
                        <div
                          v-if="
                            item.colaboradores && item.colaboradores.length > 0
                          "
                        >
                          <v-chip
                            v-for="colaborador in item.colaboradores.slice(
                              0,
                              2,
                            )"
                            :key="colaborador.colaboradorId"
                            x-small
                            class="mr-1 mb-1"
                          >
                            {{ getNomeColaborador(colaborador.colaboradorId) }}
                          </v-chip>
                          <span
                            v-if="item.colaboradores.length > 2"
                            class="grey--text text-caption"
                          >
                            (+{{ item.colaboradores.length - 2 }})
                          </span>
                        </div>
                        <span v-else class="grey--text text-caption">-</span>
                      </template>
                      <template v-slot:item.acoes="{ item }">
                        <div class="d-flex align-center">
                          <v-btn
                            text
                            small
                            color="primary"
                            class="mr-1"
                            @click="editarAtividade(item)"
                            :disabled="editandoAtividade || !hasPermissionEdit"
                          >
                            <v-icon x-small>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            text
                            small
                            color="error"
                            @click="excluirAtividade(item.id)"
                            :loading="excluindoAtividade === item.id"
                            :disabled="!hasPermissionEdit"
                          >
                            <v-icon x-small>mdi-delete</v-icon>
                          </v-btn>
                        </div>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-col>
              </template>

              <!-- Campos de Ocorrência (condicionais) -->
              <template v-if="etapasComOcorrencia.includes(etapaAtual?.id)">
                <!-- Ocorrência -->
                <v-col cols="12" md="8" class="pt-0">
                  <v-textarea
                    v-model="etapaDadosTemp.ocorrenciaJustificativa"
                    label="Ocorrência"
                    outlined
                    dense
                    rows="2"
                    auto-grow
                    placeholder="Descreva a ocorrência..."
                  ></v-textarea>
                </v-col>

                <!-- Tempo da Ocorrência -->
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="etapaDadosTemp.tempoOcorrenciaFormatted"
                    label="Tempo (hh:mm)"
                    outlined
                    dense
                    type="time"
                    step="60"
                    placeholder="00:00"
                    @input="updateTempoOcorrenciaEtapa"
                  ></v-text-field>
                </v-col>
              </template>
            </v-row>
            <v-row
              v-if="
                etapaAtual?.nome === 'Transporte familiar' ||
                etapaAtual?.nome === 'Acolhimento de óbito'
              "
            >
              <v-col cols="12" class="my-2 py-0">
                <h3 class="mb-2 primary--text">Transporte</h3>
                <v-divider></v-divider>
                <p class="text-caption grey--text mb-2">
                  Informações sobre transporte.
                </p>
              </v-col>

              <!-- Solicitação de Transporte Familiar -->
              <v-col cols="12" md="6" class="py-0">
                <v-select
                  v-model="servicoAtual.solicitacaoTransporteFamiliar"
                  :items="[
                    'A DEFINIR',
                    'SOLICITADO',
                    'SOLICITADO PARCIALMENTE',
                    'DISPENSADO',
                    'NÃO DISPONIBILIZADO FORA ÁREA DE COBERTURA',
                  ]"
                  label="Solicitação de Transporte Familiar"
                  outlined
                  dense
                ></v-select>
              </v-col>

              <!-- Tipo de Transporte Familiar -->
              <v-col cols="12" md="6" class="py-0">
                <v-select
                  v-model="servicoAtual.tipoTransporteFamiliar"
                  label="Tipo de Transporte Familiar"
                  outlined
                  dense
                  :items="['FROTA PRÓPRIA', 'FROTA TERCEIRIZADA']"
                  :disabled="
                    !(
                      servicoAtual.solicitacaoTransporteFamiliar || ''
                    ).includes('SOLICITADO')
                  "
                ></v-select>
              </v-col>
              <v-col
                cols="6"
                md="6"
                class="py-0"
                v-if="
                  servicoAtual.solicitacaoTransporteFamiliar ===
                  'SOLICITADO PARCIALMENTE'
                "
              >
                <v-checkbox
                  v-model="servicoAtual.idaTransporteFamiliar"
                  label="Ida de Transporte Familiar"
                  outlined
                  dense
                ></v-checkbox>
              </v-col>
              <v-col
                cols="6"
                md="6"
                class="py-0"
                v-if="
                  servicoAtual.solicitacaoTransporteFamiliar ===
                  'SOLICITADO PARCIALMENTE'
                "
              >
                <v-checkbox
                  v-model="servicoAtual.voltaTransporteFamiliar"
                  label="Volta de Transporte Familiar"
                  outlined
                  dense
                ></v-checkbox>
              </v-col>

              <!-- Origem do Transporte Familiar -->
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="servicoAtual.origemTransporteFamiliar"
                  label="Origem do Transporte Familiar"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <!-- Destino do Transporte Familiar -->
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="servicoAtual.destinoTransporteFamiliar"
                  label="Destino do Transporte Familiar"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-textarea
                  rows="2"
                  v-model="servicoAtual.observacoesTransporteFamiliar"
                  label="Observações do Transporte Familiar"
                  outlined
                  dense
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row v-if="servicoAtual?.etapa?.nome === 'Velório'">
              <v-col cols="12" class="my-2 pb-0">
                <h3 class="mb-2 primary--text">Velório e Sepultamento</h3>
                <v-divider></v-divider>
                <p class="text-caption grey--text mb-2">
                  Informações sobre velório e sepultamento.
                </p>
              </v-col>

              <!-- Local do Velório -->
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="servicoAtual.localVelorio"
                  label="Local do Velório"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <!-- Data do Velório -->
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="servicoAtual.dataVelorio"
                  label="Data e Hora do Velório"
                  type="datetime-local"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <!-- Local do Sepultamento -->
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="servicoAtual.localSepultamento"
                  label="Local do Sepultamento"
                  outlined
                  dense
                ></v-text-field>
              </v-col>

              <!-- Data do Sepultamento -->
              <v-col cols="12" md="6" class="py-0">
                <v-text-field
                  v-model="servicoAtual.dataSepultamento"
                  label="Data e Hora do Sepultamento"
                  type="datetime-local"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-checkbox
                  v-model="servicoAtual.cortejo"
                  label="Necessidade de Cortejo"
                  outlined
                  dense
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="grey darken-1" text small @click="fecharDialogEtapa"
            >Cancelar</v-btn
          >
          <v-btn
            :color="etapaAcao === 'iniciar' ? 'primary' : 'success'"
            @click="salvarEtapaEspecifica"
            small
            :disabled="!hasPermissionEdit"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container style="margin: 0px !important; padding: 0px !important">
      <filtro-component
        :modos="modos"
        :calendar="'dia'"
        :empresa="true"
        @filtrar="filterData"
        ref="filtro"
        :alternarVisibilidade.sync="exibicaoFiltroPai"
      ></filtro-component>
    </v-container>

    <v-container
      style="background-color: #eee"
      id="financeiro"
      fluid
      tag="section"
    >
      <base-material-card
        icon="mdi-cog-outline"
        title="Serviços Cemiteriais"
        color="green"
        style="margin-top: 20px !important; padding-top: 10px !important"
        class="px-5 py-0"
      >
        <v-row class="pt-4">
          <v-col
            cols="12"
            md="6"
            class="d-flex justify-space-between align-center pb-0"
          >
            <!-- Meus Tickets -->
            <v-chip
              :color="meusTickets ? 'primary' : '#4A4A4A'"
              :text-color="'white'"
              @click="
                meusTickets = !meusTickets;
                init();
              "
              link
              class="px-4 mr-2"
            >
              <v-icon class="mr-2" :color="meusTickets ? 'white' : 'white'">
                mdi-account
              </v-icon>
              Meus Tickets
            </v-chip>

            <!-- Detalhes -->
            <v-chip
              v-if="isMobile"
              class="px-4 mr-2"
              :color="detalhesCards ? 'primary' : '#4A4A4A'"
              text-color="white"
              @click="detalhesCards = !detalhesCards"
              link
            >
              <v-icon class="mr-2" :color="detalhesCards ? 'white' : 'white'">
                mdi-text-box-search
              </v-icon>
              Detalhes
            </v-chip>
          </v-col>

          <!-- <v-col cols="12" v-if="isMobile" class="py-0">
            <v-select
              @input="handleEtapaSelection"
              :items="colunasFiltros"
              item-text="nome"
              item-value="id"
              v-model="filtroEtapaSelecionado"
              append-outer-icon="mdi-filter"
              outlined
              hide-details
              dense
            ></v-select>
          </v-col> -->

          <v-col cols="12" md="6" class="pt-1 pb-4">
            <!-- Campo de busca para filtrar por nome do falecido, nome do cliente ou ID do atendimento -->
            <v-text-field
              v-model="buscaFunerários"
              label="Buscar por nome ou ID"
              prepend-inner-icon="mdi-magnify"
              clearable
              outlined
              dense
              class="mt-3"
              placeholder="Nome do falecido, cliente ou ID"
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <div v-if="!isMobile" class="fluxo-view-toolbar">
          <v-btn-toggle
            v-model="fluxoViewMode"
            mandatory
            class="fluxo-view-toggle"
          >
            <v-btn value="kanban">
              <v-icon size="18" left>mdi-view-dashboard-outline</v-icon>
              Kanban
            </v-btn>

            <v-btn value="table">
              <v-icon size="18" left>mdi-format-list-bulleted</v-icon>
              Lista
            </v-btn>
          </v-btn-toggle>
        </div>
        <div class="pt-3 pb-2">
          <fluxo-tipo-etapa-chips
            v-model="tiposEtapaFiltroSelecionados"
            :items="tiposEtapaFiltroItems"
          />
        </div>
        <template>
          <div v-if="deveExibirCards" class="px-0">
            <v-progress-linear
              v-if="isLoading"
              indeterminate
              color="green"
              class="mb-4"
            ></v-progress-linear>
            <!-- Título da coluna simulando Kanban com cards agrupados -->
            <v-card
              :color="getEtapaFiltrada.cor"
              class="mb-4"
              style="border-radius: 4px 4px 0 0"
            >
              <v-card-title class="d-flex justify-space-evenly py-3">
                <div
                  class="indicador-coluna"
                  :style="{ backgroundColor: getEtapaFiltrada.cor }"
                ></div>
                <h3
                  class="text-subtitle-1 font-weight-bold"
                  :class="{
                    'text-white': isColorDark(getEtapaFiltrada.cor),
                    'text-black': !isColorDark(getEtapaFiltrada.cor),
                  }"
                >
                  {{ getEtapaFiltrada.nome }}
                </h3>
                <v-chip color="white" x-small class="text-black ml-2">
                  {{ servicosCemiteriaisComFiltro.length }}
                </v-chip>
              </v-card-title>
              <v-card-text
                class="cards-container px-2"
                style="
                  background-color: #f5f5f5;
                  padding-top: 10px;
                  padding-bottom: 16px;
                  border-radius: 0 0 4px 4px;
                  margin-top: -4px;
                "
              >
                <v-card
                  v-for="item in servicosCemiteriaisComFiltro"
                  :key="item.id"
                  class="mb-4 mx-2 mt-0"
                  :style="`border-left: 6px solid ${item.etapa.cor}`"
                  elevation="1"
                >
                  <v-card-text class="pa-3">
                    <!-- Cabeçalho do Card -->
                    <div class="d-flex justify-space-between align-center mb-0">
                      <div class="text-subtitle-1 font-weight-bold">
                        #{{ item.idAtendimento }}
                      </div>
                      <v-chip
                        small
                        :color="item.etapa.cor"
                        text-color="white"
                        class="ml-2"
                      >
                        {{ item.etapa.nome }}
                      </v-chip>
                    </div>

                    <!-- Informações principais -->
                    <div class="mb-2">
                      <div class="text-body-2">
                        <strong>Falecido:</strong> {{ item.nomeFalecido }}
                      </div>
                      <div class="text-body-2">
                        <strong>Atendimento:</strong> {{ item.dataAtendimento }}
                      </div>
                      <div class="text-body-2" v-if="item.contrato">
                        <strong>Contrato:</strong> {{ item.contrato }}
                      </div>
                    </div>
                  </v-card-text>
                  <v-card-text
                    class="text-gray py-0"
                    v-if="item.etapa.tipo === 'Em andamento'"
                  >
                    <strong
                      >Responsável
                      {{ truncateString(item.etapa.nome, 18) }}</strong
                    ><br />
                    <div v-html="getResponsavel(item, item.etapa)"></div>
                    <strong
                      >Início {{ truncateString(item.etapa.nome, 22) }}</strong
                    ><br />
                    {{ getInicioAtividade(item, item.etapa) }}
                  </v-card-text>
                  <template v-if="detalhesCards">
                    <v-divider
                      class="my-2"
                      v-if="
                        item.etapa.id === 2 &&
                        getAcolhimentoInfo(item, item.etapa) &&
                        getAcolhimentoInfo(item, item.etapa).atividades &&
                        getAcolhimentoInfo(item, item.etapa).atividades.length >
                          0
                      "
                    ></v-divider>
                    <v-card-text
                      class="my-2 mx-2 py-1 px-2"
                      v-if="
                        item.etapa.id === 2 &&
                        getAcolhimentoInfo(item, item.etapa) &&
                        getAcolhimentoInfo(item, item.etapa).atividades &&
                        getAcolhimentoInfo(item, item.etapa).atividades.length >
                          0
                      "
                      :style="`border: 1px solid ${item.etapa.cor}; border-left: 6px solid ${item.etapa.cor}; background-color: ${item.etapa.cor}1A;`"
                      style="border-radius: 10px; width: 94%"
                    >
                      <template
                        v-for="atividade in getAcolhimentoInfo(item, item.etapa)
                          .atividades"
                      >
                        <template
                          v-if="
                            atividade.nome.toLowerCase().includes('entrada')
                          "
                        >
                          <strong class="text-purple-900">Entrada SVO</strong>
                          <p class="my-0">
                            <v-icon small :color="item.etapa.cor"
                              >mdi-account</v-icon
                            >
                            {{ truncateString(atividade.agente, 18) }}
                          </p>
                          <p class="mt-0 mb-2">
                            <v-icon small :color="item.etapa.cor"
                              >mdi-clock-outline</v-icon
                            >
                            {{ atividade.inicio }}
                          </p>
                        </template>
                      </template>

                      <template
                        v-for="atividade in getAcolhimentoInfo(item, item.etapa)
                          .atividades"
                      >
                        <template
                          v-if="atividade.nome.toLowerCase().includes('saída')"
                        >
                          <strong class="text-purple-900">Saída SVO</strong>
                          <p class="my-0">
                            <v-icon small :color="item.etapa.cor"
                              >mdi-account</v-icon
                            >
                            {{ truncateString(atividade.agente, 18) }}
                          </p>
                          <p class="mt-0 mb-2">
                            <v-icon small :color="item.etapa.cor"
                              >mdi-clock-outline</v-icon
                            >
                            {{ atividade.inicio }}
                          </p>
                        </template>
                      </template>
                    </v-card-text>

                    <v-divider
                      class="my-2"
                      v-if="
                        item.etapa.id === 3 &&
                        getSomatoInfo(item, item.etapa) &&
                        getSomatoInfo(item, item.etapa).nome
                      "
                    ></v-divider>
                    <v-card-text
                      class="my-2 mx-2 py-1 px-2"
                      v-if="
                        item.etapa.id === 3 &&
                        getSomatoInfo(item, item.etapa) &&
                        getSomatoInfo(item, item.etapa).nome
                      "
                      :style="`border: 1px solid ${item.etapa.cor}; border-left: 6px solid ${item.etapa.cor}; background-color: ${item.etapa.cor}1A;`"
                      style="border-radius: 10px; width: 94%"
                    >
                      <!-- Informações da Somatoconservação -->
                      <strong class="text-purple-900">{{
                        getSomatoInfo(item, item.etapa).nome
                      }}</strong>

                      <!-- Colaborador -->
                      <p class="my-0">
                        <v-icon small :color="item.etapa.cor"
                          >mdi-account</v-icon
                        >
                        {{
                          truncateString(
                            getSomatoInfo(item, item.etapa).colaborador,
                            18,
                          )
                        }}
                      </p>

                      <!-- Data/Hora Início -->
                      <p class="my-0">
                        <v-icon small :color="item.etapa.cor"
                          >mdi-clock-outline</v-icon
                        >
                        {{ getSomatoInfo(item, item.etapa).inicio }}
                      </p>

                      <!-- Data/Hora Fim (se disponível) -->
                      <p
                        class="mt-0 mb-2"
                        v-if="getSomatoInfo(item, item.etapa).fim"
                      >
                        <v-icon small :color="item.etapa.cor"
                          >mdi-clock-outline</v-icon
                        >
                        {{ getSomatoInfo(item, item.etapa).fim }}
                      </p>
                    </v-card-text>

                    <v-divider
                      class="my-2"
                      v-if="
                        item.etapa.id === 4 &&
                        item.etapa.id === 4 &&
                        item.localVelorio
                      "
                    ></v-divider>
                    <v-card-text
                      class="my-2 mx-2 py-1 px-2"
                      v-if="
                        item.etapa.id === 4 &&
                        item.etapa.id === 4 &&
                        item.localVelorio
                      "
                      :style="`border: 1px solid ${item.etapa.cor}; border-left: 6px solid ${item.etapa.cor}; background-color: ${item.etapa.cor}1A;`"
                      style="border-radius: 10px; width: 94%"
                    >
                      <!-- Informações do velório e sepultamento -->
                      <strong class="text-purple-900" v-if="item.localVelorio"
                        >Velório</strong
                      >
                      <p class="my-0" v-if="item.localVelorio">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-map-marker</v-icon
                        >{{ item.localVelorio }}
                      </p>
                      <p class="mt-0 mb-2" v-if="item.dataVelorio">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-calendar</v-icon
                        >{{ item.dataVelorio }}
                      </p>
                    </v-card-text>

                    <v-divider
                      class="my-2"
                      v-if="
                        item.etapa.id === 5 &&
                        item.etapa.id === 5 &&
                        ((getVelorioInfo(item, item.etapa) &&
                          getVelorioInfo(item, item.etapa).atividades &&
                          getVelorioInfo(item, item.etapa).atividades.length >
                            0) ||
                          item.localVelorio !== null ||
                          item.localSepultamento !== null ||
                          item.dataVelorio !== null ||
                          item.dataSepultamento !== null)
                      "
                    ></v-divider>
                    <v-card-text
                      class="my-2 mx-2 py-1 px-2"
                      v-if="
                        item.etapa.id === 5 &&
                        item.etapa.id === 5 &&
                        ((getVelorioInfo(item, item.etapa) &&
                          getVelorioInfo(item, item.etapa).atividades &&
                          getVelorioInfo(item, item.etapa).atividades.length >
                            0) ||
                          item.localVelorio !== null ||
                          item.localSepultamento !== null ||
                          item.dataVelorio !== null ||
                          item.dataSepultamento !== null)
                      "
                      :style="`border: 1px solid ${item.etapa.cor}; border-left: 6px solid ${item.etapa.cor}; background-color: ${item.etapa.cor}1A;`"
                      style="border-radius: 10px; width: 94%"
                    >
                      <!-- Informações das atividades do velório -->
                      <template
                        v-if="
                          getVelorioInfo(item, item.etapa) &&
                          getVelorioInfo(item, item.etapa).atividades &&
                          getVelorioInfo(item, item.etapa).atividades.length > 0
                        "
                      >
                        <!-- Montagem -->
                        <template
                          v-for="atividade in getVelorioInfo(item, item.etapa)
                            .atividades"
                        >
                          <template
                            v-if="
                              atividade.nome
                                .toLowerCase()
                                .includes('montagem') &&
                              !atividade.nome.toLowerCase().includes('des')
                            "
                          >
                            <strong class="text-purple-900">Montagem</strong>
                            <p class="my-0">
                              <v-icon small :color="item.etapa.cor"
                                >mdi-account</v-icon
                              >
                              {{ truncateString(atividade.agente, 18) }}
                            </p>
                            <p class="mt-0 mb-2">
                              <v-icon small :color="item.etapa.cor"
                                >mdi-clock-outline</v-icon
                              >
                              {{ atividade.inicio }}
                            </p>
                          </template>
                        </template>

                        <!-- Desmontagem -->
                        <template
                          v-for="atividade in getVelorioInfo(item, item.etapa)
                            .atividades"
                        >
                          <template
                            v-if="
                              atividade.nome
                                .toLowerCase()
                                .includes('desmontagem')
                            "
                          >
                            <strong class="text-purple-900">Desmontagem</strong>
                            <p class="my-0">
                              <v-icon small :color="item.etapa.cor"
                                >mdi-account</v-icon
                              >
                              {{ truncateString(atividade.agente, 18) }}
                            </p>
                            <p class="mt-0 mb-2">
                              <v-icon small :color="item.etapa.cor"
                                >mdi-clock-outline</v-icon
                              >
                              {{ atividade.inicio }}
                            </p>
                          </template>
                        </template>

                        <!-- Cortejo -->
                        <template
                          v-for="atividade in getVelorioInfo(item, item.etapa)
                            .atividades"
                        >
                          <template
                            v-if="
                              atividade.nome.toLowerCase().includes('cortejo')
                            "
                          >
                            <strong class="text-purple-900">Cortejo</strong>
                            <p class="my-0">
                              <v-icon small :color="item.etapa.cor"
                                >mdi-account</v-icon
                              >
                              {{ truncateString(atividade.agente, 18) }}
                            </p>
                            <p class="mt-0 mb-2">
                              <v-icon small :color="item.etapa.cor"
                                >mdi-clock-outline</v-icon
                              >
                              {{ atividade.inicio }}
                            </p>
                          </template>
                        </template>
                      </template>

                      <!-- Informações do velório e sepultamento -->
                      <strong class="text-purple-900" v-if="item.localVelorio"
                        >Velório</strong
                      >
                      <p class="my-0" v-if="item.localVelorio">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-map-marker</v-icon
                        >{{ item.localVelorio }}
                      </p>
                      <p class="mt-0 mb-2" v-if="item.dataVelorio">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-calendar</v-icon
                        >{{ item.dataVelorio }}
                      </p>
                      <strong
                        class="text-purple-900"
                        v-if="item.localSepultamento"
                      >
                        Sepultamento</strong
                      >
                      <p class="my-0" v-if="item.localSepultamento">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-map-marker</v-icon
                        >{{ item.localSepultamento }}
                      </p>
                      <p class="my-0" v-if="item.dataSepultamento">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-calendar</v-icon
                        >{{ item.dataSepultamento }}
                      </p>
                    </v-card-text>

                    <v-divider
                      class="my-2"
                      v-if="item.etapa.id === 6"
                    ></v-divider>
                    <v-card-text
                      class="my-2 mx-2 py-1 px-2"
                      v-if="item.etapa.id === 6"
                      :style="`border: 1px solid ${item.etapa.cor}; border-left: 6px solid ${item.etapa.cor}; background-color: ${item.etapa.cor}1A;`"
                      style="border-radius: 10px; width: 94%"
                    >
                      <!-- Transporte Familiar -->
                      <strong class="text-purple-900"
                        >Transporte Familiar</strong
                      >
                      <p class="my-0">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-car</v-icon
                        >
                        {{ item.tipoTransporteFamiliar || "Não informado" }}
                      </p>
                      <p class="my-0">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-map-marker</v-icon
                        >
                        Origem:
                        {{ item.origemTransporteFamiliar || "Não informado" }}
                      </p>
                      <p class="my-0">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-map-marker</v-icon
                        >
                        Destino:
                        {{ item.destinoTransporteFamiliar || "Não informado" }}
                      </p>
                      <p class="my-0">
                        <v-icon small class="mr-1" :color="item.etapa.cor"
                          >mdi-text</v-icon
                        >
                        Obs:
                        {{
                          item.observacoesTransporteFamiliar ||
                          "Sem observações"
                        }}
                      </p>
                      <template
                        v-for="atividade in getTransporteFamiliarInfo(
                          item,
                          item.etapa,
                        ) &&
                        getTransporteFamiliarInfo(item, item.etapa).atividades
                          ? getTransporteFamiliarInfo(item, item.etapa)
                              .atividades
                          : []"
                      >
                        <template
                          v-if="atividade.nome.toLowerCase().includes('ida')"
                        >
                          <p class="my-0">
                            <v-icon small class="mr-1" :color="item.etapa.cor"
                              >mdi-arrow-right</v-icon
                            >
                            Ida:
                          </p>
                          <span class="ml-6">
                            {{
                              truncateString(atividade.agente, 18) ||
                              "Não informado"
                            }}
                          </span>
                          <span class="ml-6">
                            {{ atividade.inicio || "Não informado" }}
                          </span>
                        </template>
                        <template
                          v-if="atividade.nome.toLowerCase().includes('volta')"
                        >
                          <p class="my-0">
                            <v-icon small class="mr-1" :color="item.etapa.cor"
                              >mdi-arrow-left</v-icon
                            >
                            Volta:
                          </p>
                          <span class="ml-6">
                            {{
                              truncateString(atividade.agente, 18) ||
                              "Não informado"
                            }}
                          </span>
                          <span class="ml-6">
                            {{ atividade.inicio || "Não informado" }}
                          </span>
                        </template>
                      </template>
                    </v-card-text>
                  </template>

                  <v-card-actions class="justify-center">
                    <v-btn
                      :color="item.etapa.cor"
                      small
                      @click="abrirDialog(item)"
                    >
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                    <v-btn
                      :color="item.etapa.cor"
                      small
                      :disabled="
                        item.etapa.tipo !== 'Em andamento' || !hasPermissionEdit
                      "
                      @click.stop="abrirDialogAtribuir(item, item.etapa)"
                    >
                      <v-icon>mdi-account-multiple-plus</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="playOrPause(item, item.etapa)"
                      small
                      :disabled="
                        item.etapa.tipo == 'Falha' ||
                        item.etapa.tipo == 'Finalizado' ||
                        !hasPermissionEdit
                      "
                      :color="item.etapa.cor"
                      @click.stop="handlePlayButton(item, item.etapa)"
                    >
                      <v-icon>mdi-play</v-icon>
                    </v-btn>
                    <v-btn
                      v-else
                      small
                      :disabled="
                        item.etapa.tipo !== 'Em andamento' ||
                        item.etapa.tipo == 'Falha' ||
                        item.etapa.tipo == 'Finalizado' ||
                        !hasPermissionEdit
                      "
                      :color="item.etapa.cor"
                      @click.stop="abrirDialogFinalizarEtapa(item, item.etapa)"
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
                <v-card
                  v-for="item in getItensTransporteFamiliarComFiltro"
                  :key="item.id"
                  class="mb-4 mx-2 mt-0"
                  :style="`border-left: 6px solid #3F51B5`"
                  elevation="1"
                >
                  <v-card-text class="pa-3">
                    <!-- Cabeçalho do Card -->
                    <div class="d-flex justify-space-between align-center mb-0">
                      <div class="text-subtitle-1 font-weight-bold">
                        #{{ item.idAtendimento }}
                      </div>
                      <v-chip
                        small
                        color="#3F51B5"
                        text-color="white"
                        class="ml-2"
                      >
                        Transporte familiar
                      </v-chip>
                    </div>

                    <!-- Informações principais -->
                    <div class="mb-2">
                      <div class="text-body-2">
                        <strong>Falecido:</strong> {{ item.nomeFalecido }}
                      </div>
                      <div class="text-body-2">
                        <strong>Atendimento:</strong> {{ item.dataAtendimento }}
                      </div>
                      <div class="text-body-2" v-if="item.contrato">
                        <strong>Contrato:</strong> {{ item.contrato }}
                      </div>
                    </div>
                  </v-card-text>
                  <v-card-text
                    class="text-gray py-0"
                    v-if="item.etapa.tipo === 'Agendado'"
                  >
                    <strong
                      >Responsável
                      {{ truncateString("Transporte familiar", 18) }}</strong
                    ><br />
                    <div
                      v-html="getResponsavel(item, etapaTransporteFamiliarFixa)"
                    ></div>
                    <strong
                      >Início
                      {{ truncateString("Transporte familiar", 22) }}</strong
                    ><br />
                    {{ getInicioAtividade(item, etapaTransporteFamiliarFixa) }}
                  </v-card-text>
                  <template v-if="detalhesCards">
                    <v-divider class="my-2"></v-divider>
                    <v-card-text
                      class="my-2 mx-2 py-1 px-2"
                      :style="`border: 1px solid #3F51B5; border-left: 6px solid #3F51B5; background-color: #3F51B51A;`"
                      style="border-radius: 10px; width: 94%"
                    >
                      <!-- Transporte Familiar -->
                      <strong class="text-purple-900"
                        >Transporte Familiar</strong
                      >
                      <p class="my-0">
                        <v-icon small class="mr-1" color="#3F51B5"
                          >mdi-car</v-icon
                        >
                        {{ item.tipoTransporteFamiliar || "Não informado" }}
                      </p>
                      <p class="my-0">
                        <v-icon small class="mr-1" color="#3F51B5"
                          >mdi-map-marker</v-icon
                        >
                        Origem:
                        {{ item.origemTransporteFamiliar || "Não informado" }}
                      </p>
                      <p class="my-0">
                        <v-icon small class="mr-1" color="#3F51B5"
                          >mdi-map-marker</v-icon
                        >
                        Destino:
                        {{ item.destinoTransporteFamiliar || "Não informado" }}
                      </p>
                      <p class="my-0">
                        <v-icon small class="mr-1" color="#3F51B5"
                          >mdi-text</v-icon
                        >
                        Obs:
                        {{
                          item.observacoesTransporteFamiliar ||
                          "Sem observações"
                        }}
                      </p>
                      <template
                        v-for="atividade in getTransporteFamiliarInfo(
                          item,
                          etapaTransporteFamiliarFixa,
                        ) &&
                        getTransporteFamiliarInfo(
                          item,
                          etapaTransporteFamiliarFixa,
                        ).atividades
                          ? getTransporteFamiliarInfo(
                              item,
                              etapaTransporteFamiliarFixa,
                            ).atividades
                          : []"
                      >
                        <template
                          v-if="atividade.nome.toLowerCase().includes('ida')"
                        >
                          <p class="my-0">
                            <v-icon small class="mr-1" color="#3F51B5"
                              >mdi-arrow-right</v-icon
                            >
                            Ida:
                          </p>
                          <span class="ml-6">
                            {{
                              truncateString(atividade.agente, 18) ||
                              "Não informado"
                            }}
                          </span>
                          <span class="ml-6">
                            {{ atividade.inicio || "Não informado" }}
                          </span>
                        </template>
                        <template
                          v-if="atividade.nome.toLowerCase().includes('volta')"
                        >
                          <p class="my-0">
                            <v-icon small class="mr-1" color="#3F51B5"
                              >mdi-arrow-left</v-icon
                            >
                            Volta:
                          </p>
                          <span class="ml-6">
                            {{
                              truncateString(atividade.agente, 18) ||
                              "Não informado"
                            }}
                          </span>
                          <span class="ml-6">
                            {{ atividade.inicio || "Não informado" }}
                          </span>
                        </template>
                      </template>
                    </v-card-text>
                  </template>
                  <v-card-actions class="justify-center">
                    <v-btn color="#3F51B5" small @click="abrirDialog(item)">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                    <v-btn
                      color="#3F51B5"
                      small
                      @click.stop="
                        abrirDialogAtribuir(item, etapaTransporteFamiliarFixa)
                      "
                      v-if="hasPermissionEdit"
                    >
                      <v-icon>mdi-account-multiple-plus</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="
                        playOrPause(item, etapaTransporteFamiliarFixa) &&
                        hasPermissionEdit
                      "
                      small
                      color="#3F51B5"
                      @click.stop="
                        handlePlayButton(item, etapaTransporteFamiliarFixa)
                      "
                    >
                      <v-icon>mdi-play</v-icon>
                    </v-btn>
                    <v-btn
                      v-else-if="hasPermissionEdit"
                      small
                      color="#3F51B5"
                      @click.stop="abrirDialogFinalizarEtapa(item, item.etapa)"
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-card-text>
            </v-card>
          </div>

          <div class="fixed-action-buttons-bottom" v-if="isMobile && !exibicao">
            <v-card
              class="py-2 px-2"
              style="background-color: #eef2f6; border-radius: 8px"
            >
              <div class="d-flex justify-center align-center">
                <v-btn
                  color="primary"
                  text
                  small
                  class="mx-2"
                  @click="navegarEtapa('anterior')"
                  :disabled="!temEtapaAnterior"
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>

                <span class="text-caption black--text">{{
                  getEtapaFiltrada ? getEtapaFiltrada.nome : "Todas"
                }}</span>

                <v-btn
                  color="primary"
                  text
                  small
                  class="mx-2"
                  @click="navegarEtapa('proxima')"
                  :disabled="!temEtapaProxima"
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </div>
            </v-card>
          </div>
        </template>
        <div v-if="deveExibirTabela" class="ticket-list-view mt-4">
          <v-data-table
            :headers="cemiterialListHeaders"
            :items="servicosCemiteriaisTabela"
            :items-per-page="25"
            class="ticket-list-table no-hover-effect"
            dense
          >
            <template v-slot:item="row">
              <tr
                :class="{ 'cor-row': row.index % 2 !== 0 }"
                class="pointer"
                @click="abrirDialog(row.item)"
              >
                <td class="linha">{{ row.item.idAtendimento || "-" }}</td>
                <td class="linha">
                  {{ row.item.nomeFalecido || "-" }}
                  <div class="lista-subtexto">
                    {{ row.item.nomeCliente || row.item.cliente || "-" }}
                  </div>
                </td>
                <td class="linha">{{ row.item.contrato || "-" }}</td>
                <td class="linha">{{ row.item.empresa || "-" }}</td>
                <td class="linha">
                  <v-chip
                    x-small
                    :color="row.item.etapa && row.item.etapa.cor"
                    :text-color="
                      row.item.etapa && isColorDark(row.item.etapa.cor)
                        ? 'white'
                        : 'black'
                    "
                  >
                    {{ row.item.etapa ? row.item.etapa.nome : "-" }}
                  </v-chip>
                </td>
                <td class="linha">{{ row.item.dataAtendimento || "-" }}</td>
                <td class="linha">{{ row.item.dataVelorio || "-" }}</td>
                <td class="linha">{{ row.item.localVelorio || "-" }}</td>
                <td class="linha">{{ row.item.dataSepultamento || "-" }}</td>
                <td class="linha">{{ row.item.localSepultamento || "-" }}</td>
              </tr>
            </template>
          </v-data-table>

          <div class="excel-export-row">
            <span
              class="excel-export-icon"
              :class="{ disabled: !servicosCemiteriaisTabela.length }"
              title="Exportar Excel"
              @click="exportarCemiterialXlsx"
            >
              <v-progress-circular
                v-if="exportandoCemiterial"
                indeterminate
                color="green"
                size="34"
                width="3"
              />
              <i v-else class="fas fa-file-excel"></i>
            </span>
          </div>
        </div>
        <v-row
          align="end"
          justify="center"
          class="mb-4 mt-2"
          v-if="deveExibirKanban"
        >
          <div class="kanban-board">
            <div class="kanban-colunas">
              <div
                v-for="(coluna, index) in getColunasFiltradas()"
                :key="index"
                class="kanban-coluna"
              >
                <v-card class="kanban-card" elevation="1">
                  <div
                    class="kanban-cabecalho pa-4"
                    :style="{ backgroundColor: coluna.cor, opacity: 0.9 }"
                  >
                    <div class="d-flex align-center ga-2">
                      <div
                        class="indicador-coluna"
                        :style="{ backgroundColor: coluna.cor }"
                      ></div>
                      <h3
                        class="text-subtitle-1 font-weight-bold"
                        :class="{
                          'text-white': isColorDark(coluna.cor),
                          'text-black': !isColorDark(coluna.cor),
                        }"
                      >
                        {{ coluna.nome }}
                      </h3>
                      <v-chip color="white" x-small class="text-black ml-2">
                        {{ getItensVisiveisPorColunaTotal(coluna.id).length }}
                      </v-chip>
                    </div>
                  </div>

                  <div class="tarefas-container px-3">
                    <VueDraggable
                      v-model="tarefasPorColuna[coluna.id]"
                      group="kanban"
                      item-key="id"
                      class="lista-tarefas"
                      :animation="200"
                      @change="(event) => aoArrastar(event, coluna)"
                      @start="iniciarArrastar"
                      @end="finalizarArrastar"
                    >
                      <transition-group type="transition" name="fade">
                        <v-card
                          v-for="element in getItensVisiveisPorColuna(
                            coluna.id,
                          )"
                          :key="element.id"
                          class="tarefa-card mb-3 mt-2"
                          elevation="1"
                          rounded="lg"
                          :style="`border-left: 6px solid ${coluna.cor}`"
                        >
                          <v-card-text class="text-gray pb-0">
                            <div
                              class="d-flex align-center justify-space-between"
                            >
                              <strong>#{{ element.idAtendimento }}</strong>
                              <v-chip
                                color="warning"
                                x-small
                                v-if="
                                  coluna.tipo === 'Agendado' && isNew(element)
                                "
                              >
                                Novo
                              </v-chip>
                              <v-chip
                                :class="{
                                  'text-white': isColorDark(coluna.cor),
                                  'text-black': !isColorDark(coluna.cor),
                                }"
                                small
                                :color="
                                  diferencaTempo(element, coluna)?.statusSLA
                                    ? 'red'
                                    : coluna.cor
                                "
                                v-if="
                                  coluna.tipo === 'Em andamento' &&
                                  !diferencaTempo(element, coluna)?.statusSLA &&
                                  diferencaTempo(element, coluna)
                                "
                              >
                                {{ diferencaTempo(element, coluna)?.tempo }}
                              </v-chip>

                              <v-chip
                                class="text-white"
                                color="red"
                                small
                                v-if="
                                  coluna.tipo === 'Em andamento' &&
                                  diferencaTempo(element, coluna)?.statusSLA &&
                                  diferencaTempo(element, coluna)
                                "
                              >
                                SLA Expirado ({{
                                  diferencaTempo(element, coluna)?.tempo
                                }})
                              </v-chip>
                            </div>
                            <div
                              v-if="
                                element.etapa.id === 3 &&
                                element.usoSomatoConservacao
                              "
                              class="d-flex align-center justify-center mt-2"
                            >
                              <v-chip color="warning" x-small>
                                SOMATOCONSERVAÇÃO
                              </v-chip>
                            </div>
                            <p
                              class="mb-0 mt-2"
                              style="
                                font-size: 18px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                              "
                            >
                              <strong>
                                {{ element.nomeFalecido }}
                              </strong>
                            </p>
                            <p class="mb-0 mt-0" v-if="element?.contrato">
                              Contrato:
                              {{ element?.contrato }}
                            </p>
                            <p class="mb-0">
                              Atendimento: {{ element.dataAtendimento }}
                            </p>
                          </v-card-text>
                          <v-divider class="my-2"></v-divider>
                          <v-card-text
                            class="text-gray py-0"
                            v-if="element.etapa.tipo === 'Em andamento'"
                          >
                            <strong
                              >Responsável
                              {{ truncateString(coluna.nome, 18) }}</strong
                            >
                            <div
                              class="mb-2"
                              v-html="getResponsavel(element, coluna)"
                            ></div>

                            <strong
                              >Início
                              {{ truncateString(coluna.nome, 22) }}</strong
                            ><br />
                            {{ getInicioAtividade(element, coluna) }} <br />
                            <strong
                              >{{ coluna.id === 3 ? "Sala" : "VTR" }}
                              {{ truncateString(coluna.nome, 22) }}</strong
                            ><br />
                            {{ getVtrAtividade(element, coluna) }}
                          </v-card-text>

                          <v-divider
                            class="my-2"
                            v-if="
                              coluna.id === 2 &&
                              getAcolhimentoInfo(element, coluna) &&
                              getAcolhimentoInfo(element, coluna).atividades &&
                              getAcolhimentoInfo(element, coluna).atividades
                                .length > 0
                            "
                          ></v-divider>
                          <v-card-text
                            class="my-2 mx-2 py-1 px-2"
                            v-if="
                              coluna.id === 2 &&
                              getAcolhimentoInfo(element, coluna) &&
                              getAcolhimentoInfo(element, coluna).atividades &&
                              getAcolhimentoInfo(element, coluna).atividades
                                .length > 0
                            "
                            :style="`border: 1px solid ${coluna.cor}; border-left: 6px solid ${coluna.cor}; background-color: ${coluna.cor}1A;`"
                            style="border-radius: 10px; width: 94%"
                          >
                            <template
                              v-for="atividade in getAcolhimentoInfo(
                                element,
                                coluna,
                              ).atividades"
                            >
                              <template
                                v-if="
                                  atividade.nome
                                    .toLowerCase()
                                    .includes('entrada')
                                "
                              >
                                <strong class="text-purple-900"
                                  >Entrada SVO</strong
                                >
                                <p class="my-0">
                                  <v-icon small :color="coluna.cor"
                                    >mdi-account</v-icon
                                  >
                                  {{ truncateString(atividade.agente, 18) }}
                                </p>
                                <p class="mt-0 mb-2">
                                  <v-icon small :color="coluna.cor"
                                    >mdi-clock-outline</v-icon
                                  >
                                  {{ atividade.inicio }}
                                </p>
                              </template>
                            </template>

                            <template
                              v-for="atividade in getAcolhimentoInfo(
                                element,
                                coluna,
                              ).atividades"
                            >
                              <template
                                v-if="
                                  atividade.nome.toLowerCase().includes('saída')
                                "
                              >
                                <strong class="text-purple-900"
                                  >Saída SVO</strong
                                >
                                <p class="my-0">
                                  <v-icon small :color="coluna.cor"
                                    >mdi-account</v-icon
                                  >
                                  {{ truncateString(atividade.agente, 18) }}
                                </p>
                                <p class="mt-0 mb-2">
                                  <v-icon small :color="coluna.cor"
                                    >mdi-clock-outline</v-icon
                                  >
                                  {{ atividade.inicio }}
                                </p>
                              </template>
                            </template>
                          </v-card-text>

                          <v-divider
                            class="my-2"
                            v-if="
                              coluna.id === 3 &&
                              getSomatoInfo(element, coluna) &&
                              getSomatoInfo(element, coluna).nome
                            "
                          ></v-divider>
                          <v-card-text
                            class="my-2 mx-2 py-1 px-2"
                            v-if="
                              coluna.id === 3 &&
                              getSomatoInfo(element, coluna) &&
                              getSomatoInfo(element, coluna).nome
                            "
                            :style="`border: 1px solid ${coluna.cor}; border-left: 6px solid ${coluna.cor}; background-color: ${coluna.cor}1A;`"
                            style="border-radius: 10px; width: 94%"
                          >
                            <!-- Informações da Somatoconservação -->
                            <strong class="text-purple-900">{{
                              getSomatoInfo(element, coluna).nome
                            }}</strong>

                            <!-- Colaborador -->
                            <p class="my-0">
                              <v-icon small :color="coluna.cor"
                                >mdi-account</v-icon
                              >
                              {{
                                truncateString(
                                  getSomatoInfo(element, coluna).colaborador,
                                  18,
                                )
                              }}
                            </p>

                            <!-- Data/Hora Início -->
                            <p class="my-0">
                              <v-icon small :color="coluna.cor"
                                >mdi-clock-outline</v-icon
                              >
                              {{ getSomatoInfo(element, coluna).inicio }}
                            </p>

                            <!-- Data/Hora Fim (se disponível) -->
                            <p
                              class="mt-0 mb-2"
                              v-if="getSomatoInfo(element, coluna).fim"
                            >
                              <v-icon small :color="coluna.cor"
                                >mdi-clock-outline</v-icon
                              >
                              {{ getSomatoInfo(element, coluna).fim }}
                            </p>
                          </v-card-text>

                          <v-divider
                            class="my-2"
                            v-if="
                              element.etapa.id === 4 &&
                              coluna.id === 4 &&
                              element.localVelorio
                            "
                          ></v-divider>
                          <v-card-text
                            class="my-2 mx-2 py-1 px-2"
                            v-if="
                              element.etapa.id === 4 &&
                              coluna.id === 4 &&
                              element.localVelorio
                            "
                            :style="`border: 1px solid ${coluna.cor}; border-left: 6px solid ${coluna.cor}; background-color: ${coluna.cor}1A;`"
                            style="border-radius: 10px; width: 94%"
                          >
                            <!-- Informações do velório e sepultamento -->
                            <strong
                              class="text-purple-900"
                              v-if="element.localVelorio"
                              >Velório</strong
                            >
                            <p class="my-0" v-if="element.localVelorio">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-map-marker</v-icon
                              >{{ element.localVelorio }}
                            </p>
                            <p class="mt-0 mb-2" v-if="element.dataVelorio">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-calendar</v-icon
                              >{{ element.dataVelorio }}
                            </p>
                          </v-card-text>

                          <v-divider
                            class="my-2"
                            v-if="
                              element.etapa.id === 5 &&
                              coluna.id === 5 &&
                              ((getVelorioInfo(element, coluna) &&
                                getVelorioInfo(element, coluna).atividades &&
                                getVelorioInfo(element, coluna).atividades
                                  .length > 0) ||
                                element.localVelorio !== null ||
                                element.localSepultamento !== null ||
                                element.dataVelorio !== null ||
                                element.dataSepultamento !== null)
                            "
                          ></v-divider>
                          <v-card-text
                            class="my-2 mx-2 py-1 px-2"
                            v-if="
                              element.etapa.id === 5 &&
                              coluna.id === 5 &&
                              ((getVelorioInfo(element, coluna) &&
                                getVelorioInfo(element, coluna).atividades &&
                                getVelorioInfo(element, coluna).atividades
                                  .length > 0) ||
                                element.localVelorio !== null ||
                                element.localSepultamento !== null ||
                                element.dataVelorio !== null ||
                                element.dataSepultamento !== null)
                            "
                            :style="`border: 1px solid ${coluna.cor}; border-left: 6px solid ${coluna.cor}; background-color: ${coluna.cor}1A;`"
                            style="border-radius: 10px; width: 94%"
                          >
                            <!-- Informações das atividades do velório -->
                            <template
                              v-if="
                                getVelorioInfo(element, coluna) &&
                                getVelorioInfo(element, coluna).atividades &&
                                getVelorioInfo(element, coluna).atividades
                                  .length > 0
                              "
                            >
                              <!-- Montagem -->
                              <template
                                v-for="atividade in getVelorioInfo(
                                  element,
                                  coluna,
                                ).atividades"
                              >
                                <template
                                  v-if="
                                    atividade.nome
                                      .toLowerCase()
                                      .includes('montagem') &&
                                    !atividade.nome
                                      .toLowerCase()
                                      .includes('des')
                                  "
                                >
                                  <strong class="text-purple-900"
                                    >Montagem</strong
                                  >
                                  <p class="my-0">
                                    <v-icon small :color="coluna.cor"
                                      >mdi-account</v-icon
                                    >
                                    {{ truncateString(atividade.agente, 18) }}
                                  </p>
                                  <p class="mt-0 mb-2">
                                    <v-icon small :color="coluna.cor"
                                      >mdi-clock-outline</v-icon
                                    >
                                    {{ atividade.inicio }}
                                  </p>
                                </template>
                              </template>

                              <!-- Desmontagem -->
                              <template
                                v-for="atividade in getVelorioInfo(
                                  element,
                                  coluna,
                                ).atividades"
                              >
                                <template
                                  v-if="
                                    atividade.nome
                                      .toLowerCase()
                                      .includes('desmontagem')
                                  "
                                >
                                  <strong class="text-purple-900"
                                    >Desmontagem</strong
                                  >
                                  <p class="my-0">
                                    <v-icon small :color="coluna.cor"
                                      >mdi-account</v-icon
                                    >
                                    {{ truncateString(atividade.agente, 18) }}
                                  </p>
                                  <p class="mt-0 mb-2">
                                    <v-icon small :color="coluna.cor"
                                      >mdi-clock-outline</v-icon
                                    >
                                    {{ atividade.inicio }}
                                  </p>
                                </template>
                              </template>

                              <!-- Cortejo -->
                              <template
                                v-for="atividade in getVelorioInfo(
                                  element,
                                  coluna,
                                ).atividades"
                              >
                                <template
                                  v-if="
                                    atividade.nome
                                      .toLowerCase()
                                      .includes('cortejo')
                                  "
                                >
                                  <strong class="text-purple-900"
                                    >Cortejo</strong
                                  >
                                  <p class="my-0">
                                    <v-icon small :color="coluna.cor"
                                      >mdi-account</v-icon
                                    >
                                    {{ truncateString(atividade.agente, 18) }}
                                  </p>
                                  <p class="mt-0 mb-2">
                                    <v-icon small :color="coluna.cor"
                                      >mdi-clock-outline</v-icon
                                    >
                                    {{ atividade.inicio }}
                                  </p>
                                </template>
                              </template>
                            </template>

                            <!-- Informações do velório e sepultamento -->
                            <strong
                              class="text-purple-900"
                              v-if="element.localVelorio"
                              >Velório</strong
                            >
                            <p class="my-0" v-if="element.localVelorio">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-map-marker</v-icon
                              >{{ element.localVelorio }}
                            </p>
                            <p class="mt-0 mb-2" v-if="element.dataVelorio">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-calendar</v-icon
                              >{{ element.dataVelorio }}
                            </p>
                            <strong
                              class="text-purple-900"
                              v-if="element.localSepultamento"
                            >
                              Sepultamento</strong
                            >
                            <p class="my-0" v-if="element.localSepultamento">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-map-marker</v-icon
                              >{{ element.localSepultamento }}
                            </p>
                            <p class="my-0" v-if="element.dataSepultamento">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-calendar</v-icon
                              >{{ element.dataSepultamento }}
                            </p>
                          </v-card-text>

                          <v-divider
                            class="my-2"
                            v-if="coluna.id === 6"
                          ></v-divider>
                          <v-card-text
                            class="my-2 mx-2 py-1 px-2"
                            v-if="coluna.id === 6"
                            :style="`border: 1px solid ${coluna.cor}; border-left: 6px solid ${coluna.cor}; background-color: ${coluna.cor}1A;`"
                            style="border-radius: 10px; width: 94%"
                          >
                            <!-- Transporte Familiar -->
                            <strong class="text-purple-900"
                              >Transporte Familiar</strong
                            >
                            <p class="my-0">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-car</v-icon
                              >
                              {{
                                element.tipoTransporteFamiliar ||
                                "Não informado"
                              }}
                            </p>
                            <p class="my-0">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-map-marker</v-icon
                              >
                              Origem:
                              {{
                                element.origemTransporteFamiliar ||
                                "Não informado"
                              }}
                            </p>
                            <p class="my-0">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-map-marker</v-icon
                              >
                              Destino:
                              {{
                                element.destinoTransporteFamiliar ||
                                "Não informado"
                              }}
                            </p>
                            <p class="my-0">
                              <v-icon small class="mr-1" :color="coluna.cor"
                                >mdi-text</v-icon
                              >
                              Obs:
                              {{
                                element.observacoesTransporteFamiliar ||
                                "Sem observações"
                              }}
                            </p>
                            <template
                              v-for="atividade in getTransporteFamiliarInfo(
                                element,
                                coluna,
                              ) &&
                              getTransporteFamiliarInfo(element, coluna)
                                .atividades
                                ? getTransporteFamiliarInfo(element, coluna)
                                    .atividades
                                : []"
                            >
                              <template
                                v-if="
                                  atividade.nome.toLowerCase().includes('ida')
                                "
                              >
                                <p class="my-0">
                                  <v-icon small class="mr-1" :color="coluna.cor"
                                    >mdi-arrow-right</v-icon
                                  >
                                  Ida:
                                </p>
                                <span class="ml-6">
                                  {{
                                    truncateString(atividade.agente, 18) ||
                                    "Não informado"
                                  }}
                                </span>
                                <span class="ml-6">
                                  {{ atividade.inicio || "Não informado" }}
                                </span>
                              </template>
                              <template
                                v-if="
                                  atividade.nome.toLowerCase().includes('volta')
                                "
                              >
                                <p class="my-0">
                                  <v-icon small class="mr-1" :color="coluna.cor"
                                    >mdi-arrow-left</v-icon
                                  >
                                  Volta:
                                </p>
                                <span class="ml-6">
                                  {{
                                    truncateString(atividade.agente, 18) ||
                                    "Não informado"
                                  }}
                                </span>
                                <span class="ml-6">
                                  {{ atividade.inicio || "Não informado" }}
                                </span>
                              </template>
                            </template>
                          </v-card-text>

                          <v-card-actions class="justify-center">
                            <v-btn
                              :color="coluna.cor"
                              small
                              @click="abrirDialog(element)"
                            >
                              <v-icon>mdi-eye</v-icon>
                            </v-btn>
                            <v-btn
                              :color="coluna.cor"
                              small
                              :disabled="
                                element.etapa.tipo !== 'Em andamento' ||
                                !hasPermissionEdit
                              "
                              @click.stop="abrirDialogAtribuir(element, coluna)"
                            >
                              <v-icon>mdi-account-multiple-plus</v-icon>
                            </v-btn>
                            <v-btn
                              v-if="playOrPause(element, coluna)"
                              small
                              :color="coluna.cor"
                              :disabled="
                                element.etapa.tipo == 'Falha' ||
                                element.etapa.tipo == 'Finalizado' ||
                                !hasPermissionEdit
                              "
                              @click.stop="handlePlayButton(element, coluna)"
                            >
                              <v-icon>mdi-play</v-icon>
                            </v-btn>
                            <v-btn
                              v-else
                              small
                              :color="coluna.cor"
                              :disabled="
                                element.etapa.tipo !== 'Em andamento' ||
                                element.etapa.tipo == 'Falha' ||
                                element.etapa.tipo == 'Finalizado' ||
                                !hasPermissionEdit
                              "
                              @click.stop="
                                abrirDialogFinalizarEtapa(element, coluna)
                              "
                            >
                              <v-icon>mdi-check</v-icon>
                            </v-btn>
                          </v-card-actions>
                        </v-card>

                        <!-- Botão Carregar Mais para kanban -->
                        <div
                          v-if="temMaisItensColuna(coluna.id)"
                          :key="`load-more-${coluna.id}`"
                          class="text-center my-2"
                        >
                          <v-btn
                            text
                            small
                            :color="coluna.cor"
                            @click="carregarMaisItensColuna(coluna.id)"
                          >
                            <v-icon small left>mdi-chevron-down</v-icon>
                            Carregar mais
                          </v-btn>
                        </div>

                        <v-card
                          v-if="
                            getItensVisiveisPorColuna(coluna.id).length === 0
                          "
                          key="empty"
                          class="text-center"
                          elevation="0"
                          style="background-color: #fafafa"
                        >
                          <v-card-text>Nenhum serviço encontrado</v-card-text>
                        </v-card>
                      </transition-group>
                    </VueDraggable>
                  </div>
                </v-card>
              </div>
            </div>
          </div>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex justify-end align-center mt-4">
            <v-btn color="primary" small @click="init">
              <v-icon>mdi-reload</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </base-material-card>
    </v-container>
  </v-app>
</template>

<script>
import VueDraggable from "vuedraggable";
import FiltroComponent from "./components/FiltroFuneraria.vue";
import FluxoTipoEtapaChips from "./components/FluxoTipoEtapaChips.vue";
import fluxoCemiteriaisService from "../../services/fluxocemiteriais.js";

import rh from "../../services/rh.js";
export default {
  name: "Obitos",
  components: {
    FiltroComponent,
    VueDraggable,
    FluxoTipoEtapaChips,
  },
  watch: {
    panel: function (newVal) {
      // Se o painel foi aberto (newVal não é vazio)
      if (newVal && newVal.length > 0) {
        // Obter o ID da coluna correspondente ao índice do painel aberto
        const colunasFiltradas = this.colunas.filter(
          (c) => c.tipo === "Em andamento",
        );
        const panelIndex = newVal[0]; // Pega o primeiro painel aberto
        if (colunasFiltradas[panelIndex]) {
          const colunaId = colunasFiltradas[panelIndex].id;
          this.alterarExpansionPanel(colunaId);
        }
      }
    },
  },
  mounted() {
    this.carregarUserLogado();
    this.selectedOpcao = "Falecimento";

    const fim = new Date();
    const inicio = new Date(fim);
    inicio.setDate(fim.getDate() - 7);
    this.selectedStartDate = this.formatDateBR(inicio);
    this.selectedEndDate = this.formatDateBR(fim);

    this.checkIfMobile();
    this.init(false);

    setTimeout(() => {
      this.verificarDialogos();
    }, 300000);

    this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile);
    const isMobile = window.innerWidth <= 768;

    if (isMobile && this.$refs.filtro?.alternarVisibilidade) {
      this.$refs.filtro.alternarVisibilidade(false);
    }
  },

  data() {
    return {
      isMobile: false,
      detalhesCards: false,
      buscaFunerários: "",
      servicosCemiteriaisOriginal: [],
      itensTransporteFamiliarOriginal: [],
      etapaTransporteFamiliarFixa: {
        id: 6,
        nome: "Transporte familiar",
        cor: "#3F51B5",
        tipo: "Em andamento",
        sla: 60,
        etapaSuporte: false,
      },
      // Auto-scroll variables
      autoScrollInterval: null,
      scrollSpeed: 10,
      scrollThreshold: 100, // Distance from edge to trigger scrolling
      alertDialog: {
        show: false,
        title: "",
        message: "",
      },
      userLogado: null,
      hasPermissionEdit: null,
      tab: 0,
      panel: [],
      // Controle de paginação para o kanban
      paginacaoKanban: {
        itensVisiveisPorColuna: 5, // Número inicial de itens visíveis por coluna
        incremento: 5, // Quantidade de itens a mais ao clicar em "Carregar mais"
      },
      // Controle de paginação para a lista de cards
      paginacaoLista: {
        itensVisiveis: 10, // Número inicial de itens visíveis na lista
        incremento: 10, // Quantidade de itens a mais ao clicar em "Carregar mais"
      },
      // Dados para o diálogo de etapa específica
      dialogEtapa: false,
      etapaAcao: "iniciar", // 'iniciar' ou 'finalizar'
      etapaAtual: null, // Coluna atual selecionada
      servicoAtual: null, // Serviço atual selecionado
      historico: null,
      atividades: null,
      atividadesDisponiveis: [],
      atividadesDisponiveisPorEtapa: {},
      etapaDadosTemp: {
        dataHoraInicio: null,
        dataHoraFim: null,
        colaboradores: [],
        supervisores: [],
        observacoes: null,
        ocorrenciaJustificativa: null,
        tempoOcorrencia: 0,
        tempoOcorrenciaFormatted: "00:00",
        vtr: null,
        salaPreparacao: null,
      },
      // Variável para controlar etapas com campos de ocorrência expandidos
      etapasComOcorrencia: [],
      etapasComAtividades: [],
      colaboradoresTempSomato: [],
      novaAtividadeEtapa: {},
      salvandoAtividadeEtapa: null,
      excluindoAtividade: null,
      atualizandoAtividade: null,
      // Controle do diálogo de atribuição
      dialogAtribuir: false,
      atribuirTicketId: null,
      atribuirEtapaId: null,
      atribuirNomeFalecido: "",
      atribuirNomeEtapa: "",
      headers: [
        { text: "Atend.", value: "idAtendimento" },
        { text: "Falecido", value: "nomeFalecido" },
        { text: "Data Atendimento", value: "dataAtendimento" },
        { text: "Etapa", value: "etapa.nome" },
        { text: "ações", value: "acoes" },
      ],
      historicoHeaders: [
        { text: "Campo Alterado", value: "campoAlterado" },
        { text: "Valor Anterior", value: "valorAntigo" },
        { text: "Valor Novo", value: "valorNovo" },
        { text: "Data da Alteração", value: "dataAlteracao" },
        { text: "Responsável", value: "usuarioResponsavel" },
      ],
      atividadesHeaders: [
        { text: "Atividade", value: "atividadeFunerariaDescricao" },
        { text: "Data Início", value: "dtInicio" },
        { text: "Data Fim", value: "dtFim" },
        { text: "Colaboradores", value: "colaboradores" },
        { text: "Ações", value: "acoes", sortable: false, width: "100px" },
      ],
      atividadesHeadersv2: [
        {
          text: "Detalhes",
          value: "detalhes",
        },
        {
          text: "Ações",
          value: "acoes",
          sortable: false,
        },
      ],
      headersItens: [
        { text: "Item", value: "nomeItem", width: "300px" },
        { text: "Grade", value: "nomeGradeItem" },
        { text: "Valor Original", value: "valorOriginal" },
        { text: "Quantidade", value: "quantidade" },
        { text: "Valor Unitário", value: "valorUnitario" },
        { text: "Desconto Aplicado", value: "descontoAplicado" },
        { text: "Valor Total", value: "valorTotal" },
      ],
      servicosfemiteriais: [],
      selectedStartDate: "",
      selectedEndDate: "",
      selectedCompany: null,
      isLoading: false,
      exibicaoFiltroPai: null,
      modos: ["Atendimento"],
      showFilter: false,
      showProgress: false,
      empresas: [
        "CEMITERIO PREVIDA",
        "CEMITERIO PREVIDA SÃO MIGUEL",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DAS FLORES",
        "PARQUE DO AGRESTE",
      ],
      exibicao: true,
      fluxoViewMode: "kanban",
      exportandoCemiterial: false,
      meusTickets: false,
      filtroEtapaSelecionado: 0,
      colunas: [],
      tiposEtapaFiltroSelecionados: [],
      tiposEtapaFiltroInicializado: false,
      colunasFiltros: [],
      colunasSuporte: [],
      tarefasPorColuna: [],
      listaColaboradores: [],
      listaColaboradoresSAC: [],
      dialogEdicao: false,
      servicoEditando: {
        id: null,
        etapa: {
          id: null,
          nome: "",
          cor: "",
        },
        idAtendimento: null,
        dataAtendimento: "",
        origem: "",
        destino: "",
        obs: "",
        atendente: "",
        cpfAtendente: "",
        contrato: null,
        tipoContrato: null,
        empresa: null,
        idDeclarante: null,
        declarante: null,
        cpfDeclarante: null,
        parentescoDeclarante: "",
        idCliente: null,
        cliente: "",
        cpfCliente: "",
        idFalecido: null,
        nomeFalecido: "",
        cpfFalecido: "",
        alturaFalecido: 0,
        pesoFalecido: 0,
        item: "",
        dtFalecido: "",
        valorAtendimento: 0,
        nascimentoFalecido: "",
        etapas: [],
        donoAtendimento: 0,
      },
      dialogConcluir: false,
      novaAtividade: {
        atividadeFunerariaId: null,
        atividadeFunerariaDescricao: "",
        dtInicio: null,
        dtFim: null,
        tempoOcorrencia: null,
        colaboradores: [],
      },
      salvandoAtividade: false,
      excluindoAtividade: null,
      modoEdicaoAtividade: false,
      atividadeEditandoId: null,
      editandoAtividade: false,
      cemiterialListHeaders: [
        { text: "Atendimento", value: "idAtendimento" },
        { text: "Falecido", value: "nomeFalecido" },
        { text: "Contrato", value: "contrato" },
        { text: "Empresa", value: "empresa" },
        { text: "Etapa", value: "etapa.nome" },
        { text: "Atendimento", value: "dataAtendimento" },
        { text: "Velorio", value: "dataVelorio" },
        { text: "Local Velorio", value: "localVelorio" },
        { text: "Sepultamento", value: "dataSepultamento" },
        { text: "Local Sepultamento", value: "localSepultamento" },
      ],
    };
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkIfMobile);

    // Clean up auto-scroll event listeners
    document.removeEventListener("mousemove", this.checkAutoScroll);
    if (this.autoScrollInterval) {
      clearInterval(this.autoScrollInterval);
      this.autoScrollInterval = null;
    }
  },
  computed: {
    getEtapaFiltrada() {
      return (
        this.colunasFiltros.find(
          (coluna) => coluna.id === this.filtroEtapaSelecionado,
        ) || this.colunasFiltros[0]
      ); // Retorna a primeira coluna (Todas) se não encontrar
    },
    temEtapaAnterior() {
      if (!this.colunasFiltros || this.colunasFiltros.length === 0)
        return false;
      const indiceAtual = this.colunasFiltros.findIndex(
        (coluna) => coluna.id === this.filtroEtapaSelecionado,
      );
      return indiceAtual > 0;
    },
    temEtapaProxima() {
      if (!this.colunasFiltros || this.colunasFiltros.length === 0)
        return false;
      const indiceAtual = this.colunasFiltros.findIndex(
        (coluna) => coluna.id === this.filtroEtapaSelecionado,
      );
      return indiceAtual < this.colunasFiltros.length - 1 && indiceAtual !== -1;
    },
    // Filtra os serviços funerários com base na seleção do filtro
    servicosCemiteriaisComFiltro() {
      // Primeiro, aplica o filtro de etapas
      let itens = [];

      // Se o filtro for 0 (todas) ou não houver filtro, usa todos os itens
      if (this.filtroEtapaSelecionado === 0 || !this.filtroEtapaSelecionado) {
        itens = this.servicosfemiteriais;
      } else {
        // Caso contrário, filtra pelos IDs de etapa selecionados
        itens = this.servicosfemiteriais.filter(
          (item) => this.filtroEtapaSelecionado === item.etapa.id,
        );
      }

      const tiposAtivos = this.getTiposEtapaFiltroAtivos();
      if (tiposAtivos.length) {
        itens = itens.filter((item) => tiposAtivos.includes(item.etapa?.tipo));
      }

      // Se não houver termo de busca, retorna os itens filtrados apenas por etapa
      if (!this.buscaFunerários || this.buscaFunerários.trim() === "") {
        return itens;
      }

      // Aplica o filtro de busca por texto (case insensitive)
      const termoBusca = this.buscaFunerários.toLowerCase().trim();
      return itens.filter((item) => {
        const idAtendimento = item.idAtendimento
          ? item.idAtendimento.toString().toLowerCase()
          : "";
        const nomeFalecido = item.nomeFalecido
          ? item.nomeFalecido.toLowerCase()
          : "";
        const nomeCliente = item.nomeCliente
          ? item.nomeCliente.toLowerCase()
          : "";

        return (
          idAtendimento.includes(termoBusca) ||
          nomeFalecido.includes(termoBusca) ||
          nomeCliente.includes(termoBusca)
        );
      });
    },

    // Filtra os itens de transporte familiar com base na seleção do filtro
    deveExibirCards() {
      return this.isMobile || this.fluxoViewMode === "cards";
    },

    deveExibirKanban() {
      return !this.isMobile && this.fluxoViewMode === "kanban";
    },

    deveExibirTabela() {
      return !this.isMobile && this.fluxoViewMode === "table";
    },

    servicosCemiteriaisTabela() {
      const itens = [
        ...this.servicosCemiteriaisComFiltro,
        ...this.getItensTransporteFamiliarComFiltro,
      ];
      return this.removerDuplicadosPorAtendimento(itens);
    },

    tiposEtapaFiltroItems() {
      return this.getTiposEtapaDisponiveis().map((tipo) => ({
        label: tipo,
        color: this.getCorTipoEtapa(tipo),
        count: this.getQuantidadeColunasPorTipo(tipo),
      }));
    },

    getItensTransporteFamiliarComFiltro() {
      // Primeiro verifica se deve exibir com base no filtro de etapas
      let itens = [];

      if (
        this.filtroEtapaSelecionado === 0 ||
        this.filtroEtapaSelecionado === 6
      ) {
        itens = this.getItensTransporteFamiliar;
      } else {
        return [];
      }

      const tiposAtivos = this.getTiposEtapaFiltroAtivos();
      if (tiposAtivos.length && !tiposAtivos.includes("Em andamento")) {
        return [];
      }

      // Se não houver termo de busca, retorna os itens filtrados apenas por etapa
      if (!this.buscaFunerários || this.buscaFunerários.trim() === "") {
        return itens;
      }

      // Aplica o filtro de busca por texto (case insensitive)
      const termoBusca = this.buscaFunerários.toLowerCase().trim();
      return itens.filter((item) => {
        const idAtendimento = item.idAtendimento
          ? item.idAtendimento.toString().toLowerCase()
          : "";
        const nomeFalecido = item.nomeFalecido
          ? item.nomeFalecido.toLowerCase()
          : "";
        const nomeCliente = item.nomeCliente
          ? item.nomeCliente.toLowerCase()
          : "";

        return (
          idAtendimento.includes(termoBusca) ||
          nomeFalecido.includes(termoBusca) ||
          nomeCliente.includes(termoBusca)
        );
      });
    },

    handleEtapaSelection() {
      if (this.filtroEtapaSelecionado === 0) {
        this.filtroEtapaSelecionado = 0;
      }
    },

    getItensTransporteFamiliar() {
      // Filtrar serviços funerários que não estão na etapa 6 (transporte familiar)
      // e que têm solicitação de transporte familiar como "SOLICITADO" ou "A DEFINIR"
      return this.servicosfemiteriais.filter((item) => {
        const etapaTransporte = item.etapas.find((e) => e.etapaId === 6);
        const transporteNaoConcluido =
          !etapaTransporte || !etapaTransporte.dtFim;

        return (
          item.solicitacaoTransporteFamiliar &&
          (item.solicitacaoTransporteFamiliar.includes("SOLICITADO") ||
            item.solicitacaoTransporteFamiliar.includes("A DEFINIR")) &&
          transporteNaoConcluido &&
          item.etapa.id !== 6 &&
          item.etapa.tipo === "Em andamento"
        );
      });
    },
    todosColaboradoresOrdenados() {
      // Combina as duas listas de colaboradores
      const todosColaboradores = [
        ...this.listaColaboradores,
        ...this.listaColaboradoresSAC,
      ];

      // Remove possíveis duplicatas (caso algum colaborador esteja nas duas listas)
      const colaboradoresUnicos = todosColaboradores.filter(
        (colaborador, index, self) =>
          index === self.findIndex((c) => c.id === colaborador.id),
      );

      // Ordena por nome em ordem alfabética
      return colaboradoresUnicos.sort((a, b) => {
        if (a.nome && b.nome) {
          return a.nome.localeCompare(b.nome);
        }
        return 0;
      });
    },
    duracaoSomatoConservacao() {
      if (
        !this.servicoEditando.dataInicioSomato ||
        !this.servicoEditando.dataFimSomato
      ) {
        return "";
      }

      const dataInicio = new Date(this.servicoEditando.dataInicioSomato);
      const dataFim = new Date(this.servicoEditando.dataFimSomato);
      const diferencaMs = dataFim.getTime() - dataInicio.getTime();

      const horasTotais = Math.floor(diferencaMs / (1000 * 60 * 60));

      return `${horasTotais} horas`;
    },
  },
  methods: {
    navegarEtapa(direcao) {
      if (!this.colunasFiltros || this.colunasFiltros.length === 0) return;

      const indiceAtual = this.filtroEtapaSelecionado;
      let novoIndice = indiceAtual;

      if (direcao === "anterior" && indiceAtual > 0) {
        novoIndice = indiceAtual - 1;
      } else if (
        direcao === "proxima" &&
        indiceAtual < this.colunasFiltros.length - 1
      ) {
        novoIndice = indiceAtual + 1;
      }

      if (novoIndice !== indiceAtual) {
        this.filtroEtapaSelecionado = novoIndice;
      }
    },
    getVtr(element, coluna) {
      return (
        element.etapas.find((e) => e.etapaId === coluna.id)?.vtr ||
        "Não informado"
      );
    },

    getSomatoInfo(element, coluna) {
      // Verificar se é a etapa de Preparação
      if (coluna.nome !== "Preparação")
        return { nome: "", inicio: "", fim: null, colaborador: "" };
      if (!element.usoSomatoConservacao)
        return { nome: "", inicio: "", fim: null, colaborador: "" };

      // Encontrar a etapa de Somato nos dados do serviço
      const etapa = element.etapas?.find((e) => e.etapaId === 9);
      if (!etapa) return { nome: "", inicio: "", fim: null, colaborador: "" };

      // Verificar se existem colaboradores
      if (!etapa.colaboradores || etapa.colaboradores.length === 0) {
        return {
          nome: "Somatoconservação",
          inicio: element.dataInicioSomato,
          fim: null,
          colaborador: "Não informado",
        };
      }

      // Obter o nome do primeiro colaborador
      let nomeColaborador = "Não informado";
      const colaboradorId = etapa.colaboradores[0];
      if (colaboradorId) {
        const colaboradorObj = this.listaColaboradores.find(
          (c) => c.id === colaboradorId,
        );
        if (colaboradorObj) {
          nomeColaborador = colaboradorObj.nome;
        }
      }

      // Criar objeto simplificado com os dados da somatoconservação
      const result = {
        nome: "Somatoconservação",
        inicio: element.dataInicioSomato,
        fim: etapa.dataFimSomato ? element.dataFimSomato : null,
        colaborador: nomeColaborador,
      };

      return result;
    },

    getAcolhimentoInfo(element, coluna) {
      // Verificar se é a etapa de Acolhimento
      if (coluna.nome !== "Acolhimento de óbito") return { atividades: [] };

      // Encontrar a etapa de acolhimento nos dados do serviço
      const etapa = element.etapas?.find((e) => e.etapaId === coluna.id);
      if (!etapa) return { atividades: [] };

      // Informações básicas
      const result = {
        atividades: [],
        vtr: etapa.vtr || "Não informado",
      };

      // Se não tiver atividades, retorna objeto vazio
      if (!etapa.atividades || etapa.atividades.length === 0) {
        return result;
      }

      if (etapa.atividades.length === 0) return result;

      // Processar cada atividade
      etapa.atividades.forEach((atividade) => {
        if (!atividade.atividadeFunerariaDescricao) return;

        // Obter informações do colaborador
        let nomeColaborador = "Não informado";
        if (atividade.colaboradores && atividade.colaboradores.length > 0) {
          const colaboradorId = atividade.colaboradores[0].colaboradorId;
          if (colaboradorId) {
            const colaboradorObj = this.listaColaboradores.find(
              (c) => c.id === colaboradorId,
            );
            if (colaboradorObj) {
              nomeColaborador = colaboradorObj.nome;
            }
          }
        }

        // Adicionar atividade processada ao resultado
        result.atividades.push({
          nome: atividade.atividadeFunerariaDescricao,
          agente: nomeColaborador,
          inicio: this.formatarDataHora(atividade.dtInicio),
        });
      });

      return result;
    },

    getTransporteFamiliarInfo(element, coluna) {
      // Verificar se é a etapa de Transporte familiar
      if (coluna.nome !== "Transporte familiar") return { atividades: [] };

      // Encontrar a etapa de velório nos dados do serviço
      const etapa = element.etapas?.find((e) => e.etapaId === coluna.id);
      if (!etapa) return { atividades: [] };

      // Informações básicas
      const result = {
        atividades: [],
        vtr: etapa.vtr || "Não informado",
      };

      // Se não tiver atividades, retorna objeto vazio
      if (!etapa.atividades || etapa.atividades.length === 0) {
        return result;
      }

      // Processar cada atividade
      etapa.atividades.forEach((atividade) => {
        if (!atividade.atividadeFunerariaDescricao) return;

        // Obter informações do colaborador
        let nomeColaborador = "Não informado";
        if (atividade.colaboradores && atividade.colaboradores.length > 0) {
          const colaboradorId = atividade.colaboradores[0].colaboradorId;
          if (colaboradorId) {
            const colaboradorObj = this.listaColaboradores.find(
              (c) => c.id === colaboradorId,
            );
            if (colaboradorObj) {
              nomeColaborador = colaboradorObj.nome;
            }
          }
        }

        // Adicionar atividade processada ao resultado
        result.atividades.push({
          nome: atividade.atividadeFunerariaDescricao,
          agente: nomeColaborador,
          inicio: this.formatarDataHora(atividade.dtInicio),
        });
      });

      return result;
    },

    getVelorioInfo(element, coluna) {
      // Verificar se é a etapa de Velório
      if (coluna.nome !== "Velório") return { atividades: [] };

      // Encontrar a etapa de velório nos dados do serviço
      const etapa = element.etapas?.find((e) => e.etapaId === coluna.id);
      if (!etapa) return { atividades: [] };

      // Informações básicas
      const result = {
        atividades: [],
        vtr: etapa.vtr || "Não informado",
      };

      // Se não tiver atividades, retorna objeto vazio
      if (!etapa.atividades || etapa.atividades.length === 0) {
        return result;
      }

      // Processar cada atividade
      etapa.atividades.forEach((atividade) => {
        if (!atividade.atividadeFunerariaDescricao) return;

        // Obter informações do colaborador
        let nomeColaborador = "Não informado";
        if (atividade.colaboradores && atividade.colaboradores.length > 0) {
          const colaboradorId = atividade.colaboradores[0].colaboradorId;
          if (colaboradorId) {
            const colaboradorObj = this.listaColaboradores.find(
              (c) => c.id === colaboradorId,
            );
            if (colaboradorObj) {
              nomeColaborador = colaboradorObj.nome;
            }
          }
        }

        // Adicionar atividade processada ao resultado
        result.atividades.push({
          nome: atividade.atividadeFunerariaDescricao,
          agente: nomeColaborador,
          inicio: this.formatarDataHora(atividade.dtInicio),
        });
      });

      return result;
    },
    // Auto-scroll methods
    iniciarArrastar(event) {
      // Start monitoring mouse position for auto-scrolling
      document.addEventListener("mousemove", this.checkAutoScroll);
    },

    finalizarArrastar() {
      // Stop auto-scrolling when drag ends
      document.removeEventListener("mousemove", this.checkAutoScroll);
      if (this.autoScrollInterval) {
        clearInterval(this.autoScrollInterval);
        this.autoScrollInterval = null;
      }
    },

    checkAutoScroll(event) {
      const kanbanBoard = document.querySelector(".kanban-board");
      if (!kanbanBoard) return;

      const rect = kanbanBoard.getBoundingClientRect();
      const mouseX = event.clientX;

      // Clear any existing interval
      if (this.autoScrollInterval) {
        clearInterval(this.autoScrollInterval);
        this.autoScrollInterval = null;
      }

      // Check if mouse is near the left edge
      if (mouseX < rect.left + this.scrollThreshold) {
        this.autoScrollInterval = setInterval(() => {
          kanbanBoard.scrollLeft -= this.scrollSpeed;
        }, 16); // ~60fps
      }
      // Check if mouse is near the right edge
      else if (mouseX > rect.right - this.scrollThreshold) {
        this.autoScrollInterval = setInterval(() => {
          kanbanBoard.scrollLeft += this.scrollSpeed;
        }, 16); // ~60fps
      }
    },
    alterarExpansionPanel(colunaId) {
      this.consultarAtividadesDisponiveis(colunaId);
      this.novaAtividade = {
        atividadeFunerariaId: null,
        atividadeFunerariaDescricao: "",
        dtInicio: null,
        dtFim: null,
        tempoOcorrencia: null,
        colaboradores: [],
      };
    },

    // Método para carregar atividades disponíveis para uma etapa
    toggleAtividadesDisponiveis(etapaId) {
      if (!etapaId) return;

      // Carregar atividades disponíveis para esta etapa
      this.consultarAtividadesDisponiveis(etapaId);

      // Inicializar o objeto de nova atividade para esta etapa se necessário
      this.initNovaAtividadeEtapa(etapaId);
    },
    // Método para exibir o dialog de alerta
    showAlert(title, message) {
      this.alertDialog.title = title;
      this.alertDialog.message = message;
      this.alertDialog.show = true;
    },

    async carregarUserLogado() {
      const userLogado = await fluxoCemiteriaisService.usuario_logado();

      this.userLogado = userLogado.data;

      const userString = sessionStorage.getItem("user");

      this.hasPermissionEdit = false; // valor padrão

      if (userString) {
        const user = JSON.parse(userString);
        const roles = user.roles || [];

        this.hasPermissionEdit =
          roles.includes("ROLE_SERVICO_FUNERARIO_EDICAO") ||
          roles.includes("ROLE_ADMIN");
      }
    },
    async sincronizarItens(ticketId) {
      await fluxoCemiteriaisService
        .sincronizar_itens(ticketId)
        .then((response) => {
          this.servicoEditando = response.data;
        });
      this.consultarHistorico(ticketId);
    },
    parseBRDate(str) {
      if (!str || str === "") return null;
      // "17/08/2025 13:46:47"
      const [data, hora] = str.split(" ");
      const [dia, mes, ano] = data.split("/").map(Number);
      const [h, m, s] = hora.split(":").map(Number);
      return new Date(ano, mes - 1, dia, h, m, s);
    },

    markViewed(card) {
      const viewed = this.getViewedCards();

      const createdAt = this.parseBRDate(card.dataAtendimento);
      const now = Date.now();
      const diffHoras = (now - createdAt.getTime()) / (1000 * 60 * 60);

      // só marca se card tiver sido criado nas últimas 24h
      if (diffHoras <= 24) {
        if (!viewed.find((v) => v.cardId === card.id)) {
          viewed.push({
            cardId: card.id,
            createdAt: card.dataAtendimento, // ainda string BR
            viewedAt: now,
          });
          localStorage.setItem("viewedCards", JSON.stringify(viewed));
        }
      }

      this.$forceUpdate();
    },

    getViewedCards() {
      const viewed = JSON.parse(localStorage.getItem("viewedCards") || "[]");
      const now = Date.now();

      // mantém apenas os cards criados nas últimas 24h
      const filtered = viewed.filter((v) => {
        const createdAt = this.parseBRDate(v.createdAt).getTime();
        const diffHoras = (now - createdAt) / (1000 * 60 * 60);
        return diffHoras < 24;
      });

      if (filtered.length !== viewed.length) {
        localStorage.setItem("viewedCards", JSON.stringify(filtered));
      }

      return filtered;
    },

    isNew(card) {
      const agora = new Date();
      const dataAtendimento = this.parseBRDate(card.dataAtendimento);
      const diffHoras =
        (agora.getTime() - dataAtendimento.getTime()) / (1000 * 60 * 60);

      // não é novo se já foi visto
      const viewed = this.getViewedCards();
      const jaVisto = viewed.some((v) => v.cardId === card.id);

      // retorna true se estiver nas últimas 24h e ainda não tiver sido visto
      return diffHoras <= 24 && diffHoras >= 0 && !jaVisto;
    },

    async filtrarTickets() {
      if (this.meusTickets) {
        this.servicosfemiteriais = this.servicosfemiteriais.filter(
          (servico) =>
            servico.etapas.find(
              (etapa) =>
                etapa.colaboradores.find(
                  (colaborador) => colaborador == this.userLogado,
                ) && etapa.etapaId == servico.etapa.id,
            ) ||
            servico.etapas.find(
              (etapa) =>
                etapa.supervisores.find(
                  (supervisor) => supervisor == this.userLogado,
                ) && etapa.etapaId == servico.etapa.id,
            ) ||
            servico.donoAtendimento == this.userLogado,
        );
      } else {
        this.servicosfemiteriais = this.servicosfemiteriais;
      }
    },
    async concluirTicket(status, item) {
      if (status === "com-pedencia") {
        item.etapa.id = 7;
      } else {
        item.etapa.id = 8;
      }

      // Enviar para o servidor
      await fluxoCemiteriaisService.atualizar_servico(item.id, item);
      this.init();
      this.dialogConcluir = false;
      this.fecharDialogEtapa();
    },
    adicionarColaboradorInput() {
      if (
        this.etapaDadosTemp.colaboradores.find(
          (colaborador) => colaborador == this.userLogado,
        )
      ) {
        return;
      }
      this.etapaDadosTemp.colaboradores.push(this.userLogado);
    },
    validacoesProsseguirEtapa() {
      if (
        this.etapaDadosTemp.dataHoraInicio &&
        !this.etapaDadosTemp.dataHoraFim
      ) {
        // Iniciando somente
        if (
          !this.etapaAtual?.nome === "Preparação" &&
          (this.etapaDadosTemp?.colaboradores?.length == 0 ||
            this.etapaDadosTemp.colaboradores == undefined)
        ) {
          return {
            message:
              "É necessário atribuir pelo menos um colaborador para esta etapa antes de prosseguir.",
            valid: false,
          };
        }

        // Uma condição separada para preparação, pois podem estar querendo iniciar somente a somatoconservação.
        // Primeiro valida se foi preenchido o campo de colaboradores da etapa preparação
        if (
          this.etapaAtual?.nome === "Preparação" &&
          (this.etapaDadosTemp?.colaboradores?.length == 0 ||
            this.etapaDadosTemp.colaboradores == undefined) &&
          (this.colaboradoresTempSomato.length == 0 ||
            this.colaboradoresTempSomato == undefined)
        ) {
          return {
            message:
              "É necessário atribuir pelo menos um colaborador para esta etapa antes de prosseguir.",
            valid: false,
          };
        }
        // Se estiver iniciando somente a somatoconservação, limpa a data de inicio para não iniciar a etapa preparação
        if (
          this.etapaAtual?.nome === "Preparação" &&
          (this.etapaDadosTemp?.colaboradores?.length == 0 ||
            this.etapaDadosTemp.colaboradores == undefined) &&
          this.colaboradoresTempSomato.length > 0
        ) {
          this.etapaDadosTemp.dataHoraInicio = null;
        }
      }

      if (
        this.etapaDadosTemp.dataHoraInicio &&
        this.etapaDadosTemp.dataHoraFim
      ) {
        // Finalizando e iniciando
        if (
          this.etapaDadosTemp?.colaboradores?.length == 0 ||
          this.etapaDadosTemp?.colaboradores == undefined
        ) {
          return {
            message:
              "É necessário atribuir pelo menos um colaborador para esta etapa antes de prosseguir.",
            valid: false,
          };
        }
        if (
          this.etapaDadosTemp.dataHoraInicio > this.etapaDadosTemp.dataHoraFim
        ) {
          return {
            message:
              "A data de início não pode ser posterior à data de fim. Por favor, corrija as datas informadas.",
            valid: false,
          };
        }

        if (this.etapaAtual?.nome === "Acolhimento de óbito") {
          if (
            this.servicoAtual.solicitacaoTransporteFamiliar === null ||
            this.servicoAtual.solicitacaoTransporteFamiliar === undefined
          ) {
            return {
              message:
                "Pendente informação de solicitação de transporte familiar",
              valid: false,
            };
          }
        }

        if (this.etapaAtual?.nome === "Preparação") {
          if (
            this.servicoAtual.usoSomatoConservacao === undefined ||
            this.servicoAtual.usoSomatoConservacao === null
          ) {
            return {
              message: "Informe se houve 'Uso de Somatoconservação'.",
              valid: false,
            };
          }
          if (this.servicoAtual.usoSomatoConservacao) {
            if (
              this.servicoAtual.dataInicioSomato >
              this.servicoAtual.dataFimSomato
            ) {
              return {
                message:
                  "A data de início da Somatoconservação não pode ser posterior à data de fim. Por favor, corrija as datas informadas.",
                valid: false,
              };
            }
          }
        }
        if (this.etapaAtual?.nome === "Transporte familiar") {
          if (this.servicoAtual.solicitacaoTransporteFamiliar === null) {
            return {
              message:
                "Pendente informação de solicitação de transporte familiar",
              valid: false,
            };
          }

          if (this.servicoAtual.solicitacaoTransporteFamiliar === "A DEFINIR") {
            return {
              message:
                "Pendente selecionar uma opção válida para 'Solicitação de Transporte Familiar'.",
              valid: false,
            };
          }

          if (
            (this.servicoAtual.solicitacaoTransporteFamiliar || "").includes(
              "SOLICITADO",
            )
          ) {
            if (
              this.servicoAtual.tipoTransporteFamiliar === undefined ||
              this.servicoAtual.tipoTransporteFamiliar === null
            ) {
              return {
                message: "Pendente informação de tipo de transporte familiar",
                valid: false,
              };
            }

            if (
              this.servicoAtual.origemTransporteFamiliar === undefined ||
              this.servicoAtual.origemTransporteFamiliar === null
            ) {
              return {
                message: "Pendente informação de origem",
                valid: false,
              };
            }
            if (
              this.servicoAtual.destinoTransporteFamiliar === undefined ||
              this.servicoAtual.destinoTransporteFamiliar === null
            ) {
              return {
                message: "Pendente informação de destino",
                valid: false,
              };
            }
          }
        }
      }

      return { message: "", valid: true };
    },
    // Métodos de paginação
    carregarMaisItensColuna(colunaId) {
      this.paginacaoKanban.itensVisiveisPorColuna +=
        this.paginacaoKanban.incremento;
    },

    carregarMaisItensLista() {
      this.paginacaoLista.itensVisiveis += this.paginacaoLista.incremento;
    },

    // Computed para filtrar itens visíveis por coluna
    getItensVisiveisPorColuna(colunaId) {
      let itens = [];

      if (colunaId === 6) {
        // Para a coluna 6, buscar todos os itens que tenham solicitacaoTransporteFamiliar como "SOLICITADO" ou "A DEFINIR"
        // e verificar se a etapa de transporte familiar (ID 6) não está concluída
        const itensFiltrados = this.servicosfemiteriais.filter((item) => {
          const etapaTransporte = item.etapas.find((e) => e.etapaId === 6);
          const transporteNaoConcluido =
            !etapaTransporte || !etapaTransporte.dtFim;

          return (
            (item.solicitacaoTransporteFamiliar &&
              (item.solicitacaoTransporteFamiliar.includes("SOLICITADO") ||
                item.solicitacaoTransporteFamiliar.includes("A DEFINIR")) &&
              transporteNaoConcluido &&
              item.etapa.id !== 6 &&
              item.etapa.tipo === "Em andamento") ||
            (item.solicitacaoTransporteFamiliar &&
              !item.solicitacaoTransporteFamiliar.includes("SOLICITADO") &&
              item.etapa.id == 6)
          );
        });

        // Combinar com itens da coluna, removendo duplicatas baseado no idAtendimento
        const todosItens = [
          ...itensFiltrados,
          ...(this.tarefasPorColuna[colunaId] || []),
        ];
        const idsUnicos = new Set();
        itens = todosItens.filter((item) => {
          if (idsUnicos.has(item.idAtendimento)) {
            return false;
          }
          idsUnicos.add(item.idAtendimento);
          return true;
        });
      } else {
        // Para outras colunas, usar os itens normalmente organizados por coluna
        itens = this.tarefasPorColuna[colunaId] || [];
      }

      const itensOrdenados = [...itens].sort(
        (a, b) => a.idAtendimento - b.idAtendimento,
      );

      // Aplica o filtro de busca ANTES de limitar a quantidade
      let itensFiltrados = itensOrdenados;

      if (this.buscaFunerários && this.buscaFunerários.trim() !== "") {
        const termoBusca = this.buscaFunerários.toLowerCase().trim();
        itensFiltrados = itensOrdenados.filter((item) => {
          const idAtendimento = item.idAtendimento
            ? item.idAtendimento.toString().toLowerCase()
            : "";
          const nomeFalecido = item.nomeFalecido
            ? item.nomeFalecido.toLowerCase()
            : "";
          const nomeCliente = item.nomeCliente
            ? item.nomeCliente.toLowerCase()
            : "";

          return (
            idAtendimento.includes(termoBusca) ||
            nomeFalecido.includes(termoBusca) ||
            nomeCliente.includes(termoBusca)
          );
        });
      }

      // Aplica o limite de itens visíveis DEPOIS da busca
      const itensVisiveis = itensFiltrados.filter(
        (_, index) => index < this.paginacaoKanban.itensVisiveisPorColuna,
      );

      return itensVisiveis;
    },
    getItensVisiveisPorColunaTotal(colunaId) {
      let itens = [];

      if (colunaId === 6) {
        // Para a coluna 6, buscar todos os itens que tenham solicitacaoTransporteFamiliar como "SOLICITADO" ou "A DEFINIR"
        // e verificar se a etapa de transporte familiar (ID 6) não está concluída
        const itensFiltrados = this.servicosfemiteriais.filter((item) => {
          const etapaTransporte = item.etapas.find((e) => e.etapaId === 6);
          const transporteNaoConcluido =
            !etapaTransporte || !etapaTransporte.dtFim;

          return (
            (item.solicitacaoTransporteFamiliar &&
              (item.solicitacaoTransporteFamiliar.includes("SOLICITADO") ||
                item.solicitacaoTransporteFamiliar.includes("A DEFINIR")) &&
              transporteNaoConcluido &&
              item.etapa.id !== 6 &&
              item.etapa.tipo === "Em andamento") ||
            (item.solicitacaoTransporteFamiliar &&
              !item.solicitacaoTransporteFamiliar.includes("SOLICITADO") &&
              item.etapa.id == 6)
          );
        });

        // Combinar com itens da coluna, removendo duplicatas baseado no idAtendimento
        const todosItens = [
          ...itensFiltrados,
          ...(this.tarefasPorColuna[colunaId] || []),
        ];
        const idsUnicos = new Set();
        itens = todosItens.filter((item) => {
          if (idsUnicos.has(item.idAtendimento)) {
            return false;
          }
          idsUnicos.add(item.idAtendimento);
          return true;
        });
      } else {
        // Para outras colunas, usar os itens normalmente organizados por coluna
        itens = this.tarefasPorColuna[colunaId] || [];
      }

      return itens;
    },
    temMaisItensColuna(colunaId) {
      let total = 0;

      if (colunaId === 6) {
        // Para a coluna 6, contar todos os itens que tenham solicitacaoTransporteFamiliar como "SOLICITADO"
        // independentemente da etapa atual, desde que não estejam na etapa 6
        total = this.servicosfemiteriais.filter((item) => {
          return (
            item.solicitacaoTransporteFamiliar &&
            item.solicitacaoTransporteFamiliar.includes("SOLICITADO") &&
            item.etapa.id !== 6
          );
        }).length;
        total += (this.tarefasPorColuna[colunaId] || []).length;
      } else {
        // Para outras colunas, usar o total normalmente organizado por coluna
        total = (this.tarefasPorColuna[colunaId] || []).length;
      }

      return total > this.paginacaoKanban.itensVisiveisPorColuna;
    },

    temMaisItensLista() {
      return (
        this.servicosfemiteriais.length > this.paginacaoLista.itensVisiveis
      );
    },

    getInicioAtividade(element, coluna) {
      if (!element.etapas || !element.etapas.length) return "Não iniciado";

      const etapa = element.etapas.find((e) => e.etapaId === coluna.id);
      if (!etapa || !etapa.dtInicio) return "Não iniciado";

      // Se quiser formatar a data (supondo que está como string "dd/MM/yyyy hh:mm:ss" ou ISO)
      return etapa.dtInicio; // ou formate aqui conforme precisar
    },
    getVtrAtividade(element, coluna) {
      if (!element.etapas || !element.etapas.length) return "Não iniciado";

      const etapa = element.etapas.find((e) => e.etapaId === coluna.id);
      if (coluna.id === 3) {
        return !etapa || !etapa.salaPreparacao
          ? "Não iniciado"
          : etapa.salaPreparacao;
      } else {
        return !etapa || !etapa.vtr ? "Não iniciado" : etapa.vtr;
      }
    },
    getResponsavel(element, coluna) {
      if (!this.listaColaboradores || !this.listaColaboradores.length)
        return "";

      const colaboradoresEtapaIds = [];

      element.etapas.forEach((etapa) => {
        if (etapa.etapaId === coluna.id) {
          colaboradoresEtapaIds.push(...etapa.colaboradores);
        }
      });

      const nomes = this.listaColaboradores
        .filter((colaborador) => colaboradoresEtapaIds.includes(colaborador.id))
        .map((colaborador) => colaborador.nome);

      if (nomes.length === 0) return "Nenhum responsável";

      const listaHtml =
        "<ol>" + nomes.map((nome) => `<li>${nome}</li>`).join("") + "</ol>";
      return listaHtml;
    },
    checkIfMobile() {
      const mobileQuery = window.matchMedia("(max-width: 599px)");
      this.isMobile = mobileQuery.matches;
      if (mobileQuery.matches) {
        this.exibicao = false;
        this.fluxoViewMode = "cards";
      } else if (this.fluxoViewMode === "cards") {
        this.exibicao = true;
        this.fluxoViewMode = "kanban";
      }
    },
    // Abrir diálogo para iniciar uma etapa
    removerDuplicadosPorAtendimento(itens) {
      const ids = new Set();
      return (itens || []).filter((item) => {
        const id = item.idAtendimento ?? item.id;
        if (id === null || id === undefined) return true;
        if (ids.has(id)) return false;
        ids.add(id);
        return true;
      });
    },
    montarParametrosExportacaoCemiterial() {
      return {
        dataInicio: converteDataParaFormatoISO(this.selectedStartDate),
        dataFim: converteDataParaFormatoISO(this.selectedEndDate),
        empresa: this.selectedCompany,
        search: this["buscaFuner\u00e1rios"] || "",
        etapaId: this.filtroEtapaSelecionado || 0,
      };
    },
    async exportarCemiterialXlsx() {
      if (this.exportandoCemiterial || !this.servicosCemiteriaisTabela.length) {
        return;
      }

      this.exportandoCemiterial = true;
      try {
        const response =
          await fluxoCemiteriaisService.exportar_fluxo_cemiterial_xls(
            this.montarParametrosExportacaoCemiterial(),
          );
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `fluxo_cemiterial_${Date.now()}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Erro ao exportar fluxo cemiterial:", error);
        this.showAlert("Erro", "Erro ao exportar a lista do fluxo cemiterial.");
      } finally {
        this.exportandoCemiterial = false;
      }
    },
    async abrirDialogIniciarEtapa(servico, coluna) {
      this.etapaAcao = "iniciar";
      this.etapaAtual = coluna;
      this.servicoAtual = JSON.parse(JSON.stringify(servico));

      if (this.etapaAtual.nome === "Preparação") {
        this.servicoAtual.usoSomatoConservacao = this.servicoAtual
          .usoSomatoConservacao
          ? this.servicoAtual.usoSomatoConservacao
          : false;
      }

      if (this.servicoAtual.dataInicioSomato != null) {
        this.servicoAtual.dataInicioSomato = converteDataHoraBRParaInputISO(
          this.servicoAtual.dataInicioSomato,
        );
      }
      if (this.servicoAtual.dataFimSomato != null) {
        this.servicoAtual.dataFimSomato = converteDataHoraBRParaInputISO(
          this.servicoAtual.dataFimSomato,
        );
      }
      if (this.servicoAtual.dataVelorio != null) {
        this.servicoAtual.dataVelorio = converteDataHoraBRParaInputISO(
          this.servicoAtual.dataVelorio,
        );
      }
      if (this.servicoAtual.dataSepultamento != null) {
        this.servicoAtual.dataSepultamento = converteDataHoraBRParaInputISO(
          this.servicoAtual.dataSepultamento,
        );
      }

      // Recuperar colaboradores existentes se houver
      const etapaExistente = servico.etapas?.find(
        (e) => e.etapaId === coluna.id,
      );
      this.etapaDadosTemp.colaboradores = etapaExistente?.colaboradores || [];
      this.etapaDadosTemp.supervisores = etapaExistente?.supervisores || [];
      this.etapaDadosTemp.observacoes = etapaExistente?.observacoes || null;

      const etapaExistenteSomato = servico.etapas?.find((e) => e.etapaId === 9);
      this.colaboradoresTempSomato = etapaExistenteSomato?.colaboradores || [];

      // Sempre converter datas do backend para ISO para os inputs
      const dtInicioISO = converteDataHoraBRParaInputISO(
        etapaExistente?.dtInicio,
      );

      const agora = new Date();
      const pad = (n) => n.toString().padStart(2, "0");
      const dataHoraLocal = `${agora.getFullYear()}-${pad(
        agora.getMonth() + 1,
      )}-${pad(agora.getDate())}T${pad(agora.getHours())}:${pad(
        agora.getMinutes(),
      )}`;
      this.etapaDadosTemp.dataHoraInicio = dtInicioISO || dataHoraLocal;

      // Inicializar campos de ocorrência
      this.etapaDadosTemp.ocorrenciaJustificativa = null;
      this.etapaDadosTemp.tempoOcorrencia = 0;
      this.etapaDadosTemp.tempoOcorrenciaFormatted = "00:00";
      this.etapaDadosTemp.vtr = null;
      this.etapaDadosTemp.salaPreparacao = null;

      // Carregar atividades e inicializar formulário de nova atividade
      await this.consultarAtividadesDisponiveis(coluna.id);

      // Inicializar o objeto para nova atividade
      this.initNovaAtividadeEtapa(coluna.id);

      // Mostrar a seção de atividades por padrão
      if (!this.etapasComAtividades.includes(coluna.id)) {
        this.etapasComAtividades.push(coluna.id);
      }

      this.dialogEtapa = true;
    },

    // Abrir diálogo para finalizar uma etapa
    async abrirDialogFinalizarEtapa(servico, coluna) {
      this.servicoAtual = JSON.parse(JSON.stringify(servico));
      this.etapaAtual = coluna;
      this.etapaAcao = "finalizar";

      // Garantir que os painéis de atividades e ocorrências estejam fechados por padrão
      // Limpar os arrays que controlam quais etapas têm painéis abertos
      this.etapasComAtividades = [];
      this.etapasComOcorrencia = [];

      // Inicializar dados temporários da etapa
      this.etapaDadosTemp = {
        dataHoraInicio: null,
        dataHoraFim: null,
        colaboradores: [],
        supervisores: [],
        observacoes: null,
        ocorrenciaJustificativa: null,
        tempoOcorrencia: 0,
        tempoOcorrenciaFormatted: "00:00",
        vtr: null,
        salaPreparacao: null,
      };
      // Carregar dados existentes da etapa, se houver
      const etapaExistente = servico.etapas?.find(
        (e) => e.etapaId === coluna.id,
      );
      if (etapaExistente) {
        this.etapaDadosTemp.dataHoraInicio = converteDataHoraBRParaInputISO(
          etapaExistente.dtInicio,
        );
        this.etapaDadosTemp.dataHoraFim = converteDataHoraBRParaInputISO(
          etapaExistente.dtFim,
        );
        this.etapaDadosTemp.colaboradores = etapaExistente.colaboradores || [];
        this.etapaDadosTemp.supervisores = etapaExistente.supervisores || [];
        this.etapaDadosTemp.observacoes = etapaExistente.observacoes || null;
        this.etapaDadosTemp.ocorrenciaJustificativa =
          etapaExistente.ocorrenciaJustificativa || null;
        this.etapaDadosTemp.tempoOcorrencia =
          etapaExistente.tempoOcorrencia || 0;
        this.etapaDadosTemp.tempoOcorrenciaFormatted = this.minutosParaTempo(
          etapaExistente.tempoOcorrencia,
        );
        this.etapaDadosTemp.vtr = etapaExistente.vtr || null;
        this.etapaDadosTemp.salaPreparacao =
          etapaExistente.salaPreparacao || null;
      } else {
        // Se não existir, inicializar com valores padrão
        this.etapaDadosTemp.dataHoraInicio = converteDataHoraBRParaInputISO();
        this.etapaDadosTemp.dataHoraFim = converteDataHoraBRParaInputISO();
      }

      // Sempre converter datas do backend para ISO para os inputs
      const dtFimISO = converteDataHoraBRParaInputISO(etapaExistente?.dtFim);

      const agora = new Date();
      const pad = (n) => n.toString().padStart(2, "0");
      const dataHoraLocal = `${agora.getFullYear()}-${pad(
        agora.getMonth() + 1,
      )}-${pad(agora.getDate())}T${pad(agora.getHours())}:${pad(
        agora.getMinutes(),
      )}`;
      this.etapaDadosTemp.dataHoraFim = dtFimISO || dataHoraLocal;

      if (this.servicoAtual.dataInicioSomato != null) {
        this.servicoAtual.dataInicioSomato = converteDataHoraBRParaInputISO(
          this.servicoAtual.dataInicioSomato,
        );
      }
      if (this.servicoAtual.dataFimSomato != null) {
        this.servicoAtual.dataFimSomato = converteDataHoraBRParaInputISO(
          this.servicoAtual.dataFimSomato,
        );
      }
      if (this.servicoAtual.dataVelorio != null) {
        this.servicoAtual.dataVelorio = converteDataHoraBRParaInputISO(
          this.servicoAtual.dataVelorio,
        );
      }
      if (this.servicoAtual.dataSepultamento != null) {
        this.servicoAtual.dataSepultamento = converteDataHoraBRParaInputISO(
          this.servicoAtual.dataSepultamento,
        );
      }

      const etapaExistenteSomato = servico.etapas?.find((e) => e.etapaId === 9);
      this.colaboradoresTempSomato = etapaExistenteSomato?.colaboradores || [];

      // Inicializar objeto para nova atividade
      this.novaAtividade = {
        atividadeFunerariaId: null,
        atividadeFunerariaDescricao: "",
        dtInicio: null,
        dtFim: null,
        tempoOcorrencia: null,
        colaboradores: [],
        vtr: null,
        salaPreparacao: null,
      };

      // Carregar atividades disponíveis
      await this.consultarAtividadesDisponiveis(coluna.id);

      this.dialogEtapa = true;
    },

    // Fechar diálogo de etapa
    async fecharDialogEtapa() {
      this.dialogEtapa = false;
      this.servicoAtual = null;
      this.etapaAtual = null;
      this.etapaDadosTemp.dataHoraInicio = null;
      this.etapaDadosTemp.dataHoraFim = null;
      this.etapaDadosTemp.usoSomatoConservacao = null;
      this.etapaDadosTemp.dataInicioSomato = null;
      this.etapaDadosTemp.dataFimSomato = null;
      this.etapaDadosTemp.solicitacaoTransporteFamiliar = null;
      this.etapaDadosTemp.tipoTransporteFamiliar = null;
      this.etapaDadosTemp.origemTransporteFamiliar = null;
      this.etapaDadosTemp.destinoTransporteFamiliar = null;
      this.etapaDadosTemp.vtr = null;
      this.etapaDadosTemp.salaPreparacao = null;
      this.etapaDadosTemp.colaboradores = [];
      this.etapaDadosTemp.supervisores = [];
      this.etapaDadosTemp.observacoes = null;
      this.etapaDadosTemp.ocorrenciaJustificativa = null;
      this.etapaDadosTemp.tempoOcorrencia = 0;
      this.etapaDadosTemp.tempoOcorrenciaFormatted = "00:00";
      this.colaboradoresTempSomato = [];

      // Limpar etapas com ocorrência
      this.etapasComOcorrencia = [];
      this.etapasComAtividades = [];

      await this.init();
    },
    parseDataBR(dataStr) {
      if (!dataStr) return null;

      // ✅ Se já for Date
      if (dataStr instanceof Date) return dataStr;

      // ✅ Se for formato ISO (YYYY-MM-DDTHH:mm)
      if (dataStr.includes("T")) {
        return new Date(dataStr);
      }

      // ✅ Se for formato BR (dd/MM/yyyy HH:mm:ss)
      if (dataStr.includes("/")) {
        const [data, hora] = dataStr.split(" ");
        const [dia, mes, ano] = data.split("/");

        return new Date(`${ano}-${mes}-${dia}T${hora || "00:00:00"}`);
      }

      // fallback
      return new Date(dataStr);
    },
    // Salvar etapa específica
    async salvarEtapaEspecifica() {
      if (!this.servicoAtual) return;

      const validacoes = this.validacoesProsseguirEtapa();
      if (!validacoes.valid) {
        this.showAlert("Aviso", validacoes.message);
        return;
      }

      // Validar data de sepultamento vs data de atendimento
      if (
        this.servicoAtual.dataAtendimento &&
        this.servicoAtual.dataSepultamento
      ) {
        const dataAtendimento = this.parseDataBR(
          this.servicoAtual.dataAtendimento,
        );
        const dataSepultamento = this.parseDataBR(
          this.servicoAtual.dataSepultamento,
        );

        if (dataSepultamento < dataAtendimento) {
          this.showAlert(
            "Aviso",
            `A data do sepultamento não pode ser menor que a data do atendimento. Atendimento: ${this.servicoAtual.dataAtendimento}`,
          );
          return;
        }
      }

      try {
        // Criar cópia do serviço para edição
        const servicoParaEnvio = JSON.parse(JSON.stringify(this.servicoAtual));

        // Garantir que etapas existe
        if (!servicoParaEnvio.etapas) {
          servicoParaEnvio.etapas = [];
        }

        // Remover duplicatas de etapaId antes de continuar
        servicoParaEnvio.etapas = servicoParaEnvio.etapas.filter(
          (etapa, idx, arr) =>
            arr.findIndex((e) => e.etapaId === etapa.etapaId) === idx,
        );
        // Encontrar ou criar a etapa
        let etapa = servicoParaEnvio.etapas.find(
          (e) => e.etapaId === this.etapaAtual.id,
        );
        if (!etapa) {
          etapa = {
            ticketId: servicoParaEnvio.id,
            etapaId: this.etapaAtual.id,
            dtInicio: null,
            dtFim: null,
            colaboradores: [],
            supervisores: [],
            observacoes: null,
            ocorrenciaJustificativa: null,
            tempoOcorrencia: 0,
            vtr: null,
            salaPreparacao: null,
          };
          servicoParaEnvio.etapas.push(etapa);
          servicoParaEnvio.etapa = this.etapaAtual;
        }
        // Encontrar ou criar a etapa
        let etapaSomato = servicoParaEnvio.etapas.find((e) => e.etapaId === 9);
        if (!etapaSomato) {
          etapaSomato = {
            ticketId: servicoParaEnvio.id,
            etapaId: 9,
            dtInicio: await converteDataHoraInputISOParaBR(
              this.etapaDadosTemp.dataInicioSomato,
            ),
            dtFim: await converteDataHoraInputISOParaBR(
              this.etapaDadosTemp.dataFimSomato,
            ),
            colaboradores: this.colaboradoresTempSomato,
            supervisores: [],
            observacoes: null,
            ocorrenciaJustificativa: null,
            tempoOcorrencia: 0,
            vtr: null,
            salaPreparacao: null,
          };
          servicoParaEnvio.etapas.push(etapaSomato);
        } else {
          // se já existe, atualiza campos
          etapaSomato.dtInicio = await converteDataHoraInputISOParaBR(
            this.etapaDadosTemp.dataInicioSomato,
          );
          etapaSomato.dtFim = await converteDataHoraInputISOParaBR(
            this.etapaDadosTemp.dataFimSomato,
          );
          etapaSomato.colaboradores = [...this.colaboradoresTempSomato];
          etapaSomato.supervisores = [];
          etapaSomato.observacoes = null;
          etapaSomato.ocorrenciaJustificativa = null;
          etapaSomato.tempoOcorrencia = 0;
          etapaSomato.vtr = null;
          etapaSomato.salaPreparacao = null;
          servicoParaEnvio.etapas.push(etapaSomato);
        }

        if (this.etapaDadosTemp.dataHoraFim != null) {
          etapa.dtFim = converteDataHoraInputISOParaBR(
            this.etapaDadosTemp.dataHoraFim,
          );
        }
        if (this.etapaDadosTemp.dataHoraInicio != null) {
          etapa.dtInicio = converteDataHoraInputISOParaBR(
            this.etapaDadosTemp.dataHoraInicio,
          );
        }

        if (servicoParaEnvio.dataInicioSomato != null) {
          servicoParaEnvio.dataInicioSomato = converteDataHoraInputISOParaBR(
            servicoParaEnvio.dataInicioSomato,
          );
        }
        if (servicoParaEnvio.dataFimSomato != null) {
          servicoParaEnvio.dataFimSomato = converteDataHoraInputISOParaBR(
            servicoParaEnvio.dataFimSomato,
          );
        }
        if (servicoParaEnvio.dataVelorio != null) {
          servicoParaEnvio.dataVelorio = converteDataHoraInputISOParaBR(
            servicoParaEnvio.dataVelorio,
          );
        }
        if (servicoParaEnvio.dataSepultamento != null) {
          servicoParaEnvio.dataSepultamento = converteDataHoraInputISOParaBR(
            servicoParaEnvio.dataSepultamento,
          );
        }

        // Verificar se a etapa atual está sendo finalizada
        if (
          this.etapaDadosTemp.dataHoraFim &&
          !isNaN(new Date(this.etapaDadosTemp.dataHoraFim))
        ) {
          // Verificar se deve avançar para a próxima etapa
          if (this.deveAvancarEtapa(servicoParaEnvio)) {
            servicoParaEnvio.etapa.id++;
          }
        }

        // Atualizar colaboradores, supervisores e observações
        etapa.colaboradores = this.etapaDadosTemp.colaboradores;
        etapa.supervisores = this.etapaDadosTemp.supervisores;
        etapa.observacoes = this.etapaDadosTemp.observacoes;
        etapa.vtr = this.etapaDadosTemp.vtr;
        etapa.salaPreparacao = this.etapaDadosTemp.salaPreparacao;

        // Atualizar campos de ocorrência
        if (etapa) {
          etapa.ocorrenciaJustificativa =
            this.etapaDadosTemp.ocorrenciaJustificativa;
          etapa.tempoOcorrencia = this.etapaDadosTemp.tempoOcorrencia;
        }
        // Formatar etapas para envio ao servidor
        servicoParaEnvio.etapas = servicoParaEnvio.etapas
          .filter(
            (e) =>
              e.ticketId &&
              e.etapaId &&
              (e.dtInicio ||
                e.dtFim ||
                e.colaboradores.length > 0 ||
                e.supervisores.length > 0 ||
                e.observacoes ||
                e.ocorrenciaJustificativa ||
                e.tempoOcorrencia > 0),
          )
          .map((e) => ({
            id: e.id,
            ticketId: e.ticketId,
            etapaId: e.etapaId,
            dtInicio: e.dtInicio ? e.dtInicio : null,
            dtFim: e.dtFim ? e.dtFim : null,
            colaboradores: e.colaboradores || [],
            supervisores: e.supervisores || [],
            observacoes: e.observacoes || null,
            ocorrenciaJustificativa: e.ocorrenciaJustificativa || null,
            tempoOcorrencia: e.tempoOcorrencia || 0,
            vtr: e.vtr || null,
            salaPreparacao: e.salaPreparacao || null,
          }));

        console.log("this.servicoatual", this.servicoAtual);
        console.log("this.etapaAtual", this.etapaAtual);
        if (
          this.etapaDadosTemp.dataHoraFim != null &&
          !isNaN(new Date(this.etapaDadosTemp.dataHoraFim))
        ) {
          // Verificar se deve mostrar o diálogo de conclusão
          if (this.deveExibirDialogConclusao(servicoParaEnvio)) {
            this.servicoAtual = JSON.parse(JSON.stringify(servicoParaEnvio));
            this.dialogConcluir = true;
            return;
          }
        }

        // Enviar para o servidor
        await fluxoCemiteriaisService.atualizar_servico(
          servicoParaEnvio.id,
          servicoParaEnvio,
        );

        // Fechar diálogo e atualizar dados
        this.init();
        this.fecharDialogEtapa();
      } catch (error) {
        console.error("Erro ao salvar etapa:", error);
      }
    },

    playOrPause(element, coluna) {
      const etapa = element.etapas?.find(
        (etapa) => etapa.etapaId === coluna.id,
      );

      if (etapa && etapa.dtInicio) {
        return false;
      }
      return true;
    },

    // Abrir diálogo de atribuição
    abrirDialogAtribuir(element, coluna) {
      this.dialogAtribuir = true;
      this.atribuirTicketId = element.id;
      this.atribuirEtapaId = coluna.id;
      this.atribuirNomeFalecido = element.nomeFalecido;
      this.atribuirNomeEtapa = coluna.nome;
    },

    // Fechar diálogo de atribuição
    fecharDialogAtribuir() {
      this.dialogAtribuir = false;
      this.atribuirTicketId = null;
      this.atribuirEtapaId = null;
      this.atribuirNomeFalecido = "";
      this.atribuirNomeEtapa = "";
    },

    // Confirmar atribuição
    async confirmarAtribuicao() {
      try {
        await fluxoCemiteriaisService.atribuir_responsavel(
          this.atribuirTicketId,
          this.atribuirEtapaId,
        );

        this.fecharDialogAtribuir();
        this.init();
      } catch (error) {
        console.error("Erro ao atribuir responsável:", error);
      }
    },
    async handlePlayButton(element, coluna) {
      // Se for do tipo "Agendado", incrementar para a próxima etapa
      if (element.etapa.tipo === "Agendado") {
        await this.alterarEtapa(element, 2);
        await this.init();
      } else {
        // Se for "Em andamento", abrir o diálogo para iniciar a etapa
        this.abrirDialogIniciarEtapa(element, coluna);
      }
    },

    // Método para incrementar a etapa (para etapas do tipo "Agendado")
    async alterarEtapa(servico, etapaNova) {
      try {
        // Criar cópia do serviço para edição (deep clone)
        let servicoParaEnvio = JSON.parse(JSON.stringify(servico));

        servicoParaEnvio.etapa.id = etapaNova;

        // Enviar para o servidor
        await fluxoCemiteriaisService.atualizar_servico(
          servicoParaEnvio.id,
          servicoParaEnvio,
        );

        // Atualizar dados
        this.init();
      } catch (error) {
        console.error("Erro ao alterar etapa:", error);
      }
    },
    updateEtapa(etapaId, novaListaColaboradores = null) {
      // Atualiza apenas a lista de colaboradores se fornecido
      if (novaListaColaboradores !== null) {
        const etapa = this.getEtapaRef(this.servicoEditando, etapaId);
        etapa.colaboradores = novaListaColaboradores;
      }
    },

    updateEtapaSupervisores(etapaId, novaListaSupervisores = null) {
      // Atualiza apenas a lista de supervisores se fornecido
      if (novaListaSupervisores !== null) {
        const etapa = this.getEtapaRef(this.servicoEditando, etapaId);
        etapa.supervisores = novaListaSupervisores;
      }
    },

    updateEtapaObservacoes(etapaId, novasObservacoes = null) {
      // Atualiza apenas as observações se fornecido
      if (novasObservacoes !== null) {
        const etapa = this.getEtapaRef(this.servicoEditando, etapaId);
        etapa.observacoes = novasObservacoes;
      }
    },

    // Converte tempo de hh:mm para minutos
    tempoParaMinutos(tempoString) {
      if (!tempoString) return 0;
      const [horas, minutos] = tempoString.split(":").map(Number);
      return horas * 60 + minutos;
    },

    // Converte minutos para formato hh:mm
    minutosParaTempo(minutos) {
      if (!minutos || minutos === 0) return "00:00";
      const horas = Math.floor(minutos / 60);
      const mins = minutos % 60;
      return `${horas.toString().padStart(2, "0")}:${mins
        .toString()
        .padStart(2, "0")}`;
    },

    // Atualiza o tempo da ocorrência convertendo de hh:mm para minutos
    updateTempoOcorrencia(etapaId, tempoString) {
      const etapa = this.getEtapaRef(this.servicoEditando, etapaId);
      etapa.tempoOcorrencia = this.tempoParaMinutos(tempoString);
    },

    // Toggle para mostrar/ocultar campos de ocorrência no dialogEtapa
    toggleOcorrenciaEtapa() {
      const etapaId = this.etapaAtual?.id;
      if (!etapaId) return;

      if (this.etapasComOcorrencia.includes(etapaId)) {
        this.etapasComOcorrencia = this.etapasComOcorrencia.filter(
          (id) => id !== etapaId,
        );
      } else {
        this.etapasComOcorrencia.push(etapaId);
      }
    },

    // Toggle para mostrar/ocultar campos de ocorrência no dialogEdicao
    toggleOcorrenciaEdicao(etapaId) {
      if (!etapaId) return;

      const index = this.etapasComOcorrencia.indexOf(etapaId);
      if (index > -1) {
        this.etapasComOcorrencia.splice(index, 1);
      } else {
        this.etapasComOcorrencia.push(etapaId);
      }
    },

    // Toggle para mostrar/ocultar campos de atividades no dialogEdicao
    toggleAtividades(etapaId) {
      if (!etapaId) return;

      const index = this.etapasComAtividades.indexOf(etapaId);
      if (index > -1) {
        this.etapasComAtividades.splice(index, 1);
      } else {
        this.etapasComAtividades.push(etapaId);
        // Inicializar o objeto de nova atividade para esta etapa
        this.initNovaAtividadeEtapa(etapaId);
        // Carregar atividades disponíveis para esta etapa
        this.consultarAtividadesDisponiveis(etapaId);
      }
    },

    // Inicializar o objeto de nova atividade para uma etapa
    initNovaAtividadeEtapa(etapaId) {
      if (!etapaId) return;

      this.$set(this.novaAtividadeEtapa, etapaId, {
        atividadeFunerariaId: null,
        atividadeFunerariaDescricao: null,
        dtInicio: null,
        dtFim: null,
        colaboradores: [],
        editando: false,
        id: null,
      });
    },

    // Obter o valor de um campo do objeto novaAtividadeEtapa
    getNovaAtividadeEtapaField(etapaId, field) {
      if (!this.novaAtividadeEtapa[etapaId]) {
        this.initNovaAtividadeEtapa(etapaId);
      }
      return this.novaAtividadeEtapa[etapaId][field];
    },

    // Obter os colaboradores de uma atividade de etapa
    getNovaAtividadeEtapaColaboradores(etapaId) {
      if (
        !this.novaAtividadeEtapa[etapaId] ||
        !this.novaAtividadeEtapa[etapaId].colaboradores
      ) {
        return [];
      }
      return this.novaAtividadeEtapa[etapaId].colaboradores;
    },

    // Obter atividades de uma etapa específica
    getAtividadesDaEtapa(servico, etapaId) {
      if (!servico || !etapaId || !servico.etapas) return [];

      // Encontrar a etapa específica
      const etapa = servico.etapas.find((e) => e.etapaId === etapaId);
      if (!etapa) return [];

      // Retornar as atividades dessa etapa (ou array vazio)
      return etapa.atividades || [];
    },

    // Obter atividades disponíveis que ainda não foram usadas em uma etapa
    getAtividadesDisponiveisDaEtapa(servico, etapaId) {
      if (!servico || !etapaId || !servico.etapas) return [];

      // Verificar se já temos atividades carregadas para esta etapa
      if (!this.atividadesDisponiveisPorEtapa[etapaId]) {
        // Se não temos, forçar a consulta de atividades disponíveis para esta etapa
        this.consultarAtividadesDisponiveis(etapaId);
        return []; // Retornar array vazio enquanto carrega
      }

      // Encontrar a etapa específica
      const etapa = servico.etapas.find((e) => e.etapaId === etapaId);
      if (!etapa) return this.atividadesDisponiveisPorEtapa[etapaId] || []; // Se não encontrar a etapa, retorna todas as atividades disponíveis

      // Obter IDs das atividades já usadas nesta etapa
      const atividadesUsadas = etapa.atividades
        ? etapa.atividades.map((a) => a.atividadeFunerariaId)
        : [];

      // Filtrar apenas as atividades que não estão sendo usadas nesta etapa
      return (this.atividadesDisponiveisPorEtapa[etapaId] || []).filter(
        (atividade) => !atividadesUsadas.includes(atividade.id),
      );
    },

    // Obter todas as atividades disponíveis para uma etapa (incluindo as já cadastradas)
    getTodasAtividadesDisponiveis(etapaId) {
      if (!etapaId) return [];

      // Verificar se já temos atividades carregadas para esta etapa
      if (!this.atividadesDisponiveisPorEtapa[etapaId]) {
        // Se não temos, forçar a consulta de atividades disponíveis para esta etapa
        this.consultarAtividadesDisponiveis(etapaId);
        return []; // Retornar array vazio enquanto carrega
      }

      // Retornar as atividades específicas para esta etapa
      return this.atividadesDisponiveisPorEtapa[etapaId] || [];
    },

    // Atualiza o tempo da ocorrência no dialogEtapa
    updateTempoOcorrenciaEtapa(tempoString) {
      this.etapaDadosTemp.tempoOcorrencia = this.tempoParaMinutos(tempoString);
    },

    getEtapaRef(servico, etapaId) {
      // Garante que a lista de etapas existe
      if (!servico) return {};
      if (!servico.etapas) {
        this.$set(servico, "etapas", []);
      }

      // Procura a etapa existente
      let etapa = servico.etapas.find((e) => e.etapaId === etapaId);

      // Se não existir, cria uma nova etapa com valores padrão
      if (!etapa) {
        etapa = {
          id: null,
          ticketId: servico.id,
          etapaId: etapaId,
          dtInicio: null,
          dtFim: null,
          colaboradores: [],
          supervisores: [],
          observacoes: null,
          ocorrenciaJustificativa: null,
          tempoOcorrencia: 0,
          vtr: null,
          salaPreparacao: null,
          atividades: [],
        };
        servico.etapas.push(etapa);
      }

      return etapa;
    },

    getEtapaAtividadeId(servico, etapaId) {
      const etapa = this.getEtapaRef(servico, etapaId);
      // Verificar se a etapa tem atividades
      if (etapa && etapa.atividades && etapa.atividades.length > 0) {
        // Retornar o ID da primeira atividade (ou você pode implementar uma lógica diferente aqui)
        return etapa.atividades[0].atividadeFunerariaId;
      }
      // Se não houver atividades, retornar null ou um valor padrão
      return null;
    },

    truncateString(str, maxLength) {
      if (str.length > maxLength) {
        return str.substring(0, maxLength) + "...";
      }
      return str;
    },
    diferencaTempo(element, coluna) {
      const etapaAtual = element.etapas.find(
        (etapa) => etapa.etapaId === coluna.id,
      );
      if (!etapaAtual || etapaAtual.dtInicio === null) {
        return null;
      }

      const dtInicio = this.parseBRDate(etapaAtual.dtInicio);
      const agora = new Date();
      const diferencaMs = agora - dtInicio;

      // converter tudo em minutos
      const minutosPassados = Math.floor(diferencaMs / (1000 * 60));

      // SLA já está em minutos
      const SLAmin = coluna.sla;
      const statusSLA = minutosPassados > SLAmin;

      // formatar em h/m só para exibir
      const horas = Math.floor(minutosPassados / 60);
      const minutos = minutosPassados % 60;
      const tempo = `${horas}h ${minutos}m`;

      return {
        tempo,
        statusSLA,
      };
    },
    async abrirDialog(servico) {
      this.markViewed(servico);

      const servicoOri = await this.consultarId(servico.id);

      // Criar uma cópia do serviço para edição
      this.servicoEditando = JSON.parse(JSON.stringify(servicoOri));
      this.servicoEditando.dataAtendimento = converteDataHoraBRParaInputISO(
        this.servicoEditando.dataAtendimento,
      );

      // Garantir que etapas existe antes de tentar iterar
      if (!this.servicoEditando.etapas) {
        this.servicoEditando.etapas = [];
      }
      // Converter datas das etapas existentes do formato BR para ISO (para inputs datetime-local)
      this.servicoEditando.etapas.forEach((etapa) => {
        etapa.dtInicio = converteDataHoraBRParaInputISO(etapa.dtInicio);
        etapa.dtFim = converteDataHoraBRParaInputISO(etapa.dtFim);

        // Garantir que colaboradores existe como array
        if (!etapa.colaboradores) {
          etapa.colaboradores = [];
        }

        // Garantir que supervisores existe como array
        if (!etapa.supervisores) {
          etapa.supervisores = [];
        }

        // Garantir que observacoes existe
        if (!etapa.observacoes) {
          etapa.observacoes = null;
        }

        // Garantir que ocorrenciaJustificativa existe
        if (!etapa.ocorrenciaJustificativa) {
          etapa.ocorrenciaJustificativa = null;
        }

        // Garantir que tempoOcorrencia existe e converter para formato hh:mm
        if (!etapa.tempoOcorrencia) {
          etapa.tempoOcorrencia = 0;
        }
        etapa.tempoOcorrenciaFormatted = this.minutosParaTempo(
          etapa.tempoOcorrencia,
        );

        // Garantir que ticketId e etapaId existem
        if (!etapa.ticketId) {
          etapa.ticketId = servicoOri.id;
        }
      });

      const etapaExistenteSomato = servicoOri.etapas?.find(
        (e) => e.etapaId === 9,
      );
      this.servicoEditando.colaboradoresSomato =
        etapaExistenteSomato?.colaboradores || [];

      // Limpar o objeto novaAtividadeEtapa
      this.novaAtividadeEtapa = {};

      // Inicializar novaAtividadeEtapa para etapas que estão com atividades expandidas
      this.etapasComAtividades.forEach((etapaId) => {
        this.initNovaAtividadeEtapa(etapaId);
        this.consultarAtividadesDisponiveis(etapaId);
      });

      this.servicoEditando.nascimentoFalecido = converteDataParaFormatoISO(
        this.servicoEditando.nascimentoFalecido,
      );
      this.servicoEditando.dtFalecido = converteDataHoraBRParaInputISO(
        this.servicoEditando.dtFalecido,
      );

      this.servicoEditando.dataInicioSomato = converteDataHoraBRParaInputISO(
        this.servicoEditando.dataInicioSomato,
      );
      this.servicoEditando.dataFimSomato = converteDataHoraBRParaInputISO(
        this.servicoEditando.dataFimSomato,
      );
      this.servicoEditando.dataVelorio = converteDataHoraBRParaInputISO(
        this.servicoEditando.dataVelorio,
      );

      this.servicoEditando.dataSepultamento = converteDataHoraBRParaInputISO(
        this.servicoEditando.dataSepultamento,
      );
      this.consultarHistorico(this.servicoEditando.id);

      this.panel = [this.servicoEditando.etapa.id - 2];
      this.dialogEdicao = true;
    },
    fecharDialog() {
      this.servicoEditando = {
        id: null,
        etapa: {
          id: null,
          nome: "",
          cor: "",
        },
        idAtendimento: null,
        dataAtendimento: "",
        origem: "",
        destino: "",
        obs: "",
        atendente: "",
        cpfAtendente: "",
        contrato: "",
        tipoContrato: "",
        empresa: "",
        idDeclarante: null,
        declarante: "",
        cpfDeclarante: "",
        parentescoDeclarante: "",
        contatoDeclarante: "",
        idCliente: null,
        cliente: "",
        cpfCliente: "",
        idFalecido: null,
        nomeFalecido: "",
        cpfFalecido: "",
        alturaFalecido: 0,
        pesoFalecido: 0,
        dtFalecido: "",
        valorAtendimento: 0,
        nascimentoFalecido: "",
        causaMorte: null,
        causaPrincipal: null,
        localVelorio: null,
        dataVelorio: null,
        localSepultamento: null,
        dataSepultamento: null,
        solicitacaoTransporteFamiliar: null,
        tipoTransporteFamiliar: null,
        origemTransporteFamiliar: null,
        destinoTransporteFamiliar: null,
        usoSomatoConservacao: null,
        dataInicioSomato: null,
        dataFimSomato: null,
        etapas: [],
        itens: [],
      };
      this.historico = [];
      this.etapasComOcorrencia = [];
      this.etapasComAtividades = [];
      this.novaAtividadeEtapa = {};
      this.dialogEdicao = false;
    },

    inicializarFiltroEtapasPadrao() {
      const tiposValidos = this.getTiposEtapaDisponiveis();

      this.tiposEtapaFiltroSelecionados =
        this.tiposEtapaFiltroSelecionados.filter((tipo) =>
          tiposValidos.includes(tipo),
        );

      if (this.tiposEtapaFiltroInicializado) return;

      this.tiposEtapaFiltroSelecionados = tiposValidos.filter((tipo) =>
        ["Agendado", "Em andamento"].includes(tipo),
      );
      this.tiposEtapaFiltroInicializado = true;
    },

    getTiposEtapaDisponiveis() {
      return [
        ...new Set(this.colunas.map((coluna) => coluna.tipo).filter(Boolean)),
      ];
    },

    getTiposEtapaFiltroAtivos() {
      return Array.isArray(this.tiposEtapaFiltroSelecionados)
        ? this.tiposEtapaFiltroSelecionados
        : [];
    },

    getQuantidadeColunasPorTipo(tipo) {
      return this.colunas.filter((coluna) => coluna.tipo === tipo).length;
    },

    getCorTipoEtapa(tipo) {
      const coluna = this.colunas.find((item) => item.tipo === tipo);
      return coluna?.cor || "#607d8b";
    },

    getColunasFiltradas() {
      const tiposAtivos = this.getTiposEtapaFiltroAtivos();
      if (!tiposAtivos.length) return this.colunas;

      return this.colunas.filter((coluna) => tiposAtivos.includes(coluna.tipo));
    },

    async salvarEdicao() {
      if (!this.servicoEditando) return;

      try {
        // Validar data de sepultamento vs data de atendimento
        if (
          this.servicoEditando.dataAtendimento &&
          this.servicoEditando.dataSepultamento
        ) {
          const dataAtendimento = new Date(
            this.servicoEditando.dataAtendimento,
          );
          const dataSepultamento = new Date(
            this.servicoEditando.dataSepultamento,
          );

          if (dataSepultamento < dataAtendimento) {
            this.showAlert(
              "Aviso",
              "A data do sepultamento não pode ser menor que a data do atendimento.",
            );
            return;
          }
        }

        // Garantir que etapas existe
        if (!this.servicoEditando.etapas) {
          this.servicoEditando.etapas = [];
        }

        // Formatar etapas para envio ao servidor
        this.servicoEditando.etapas = this.servicoEditando.etapas
          .filter(
            (etapa) =>
              etapa.ticketId &&
              etapa.etapaId &&
              (etapa.dtInicio ||
                etapa.dtFim ||
                etapa.colaboradores.length > 0 ||
                etapa.supervisores.length > 0 ||
                etapa.observacoes ||
                etapa.ocorrenciaJustificativa ||
                etapa.tempoOcorrencia > 0) &&
              etapa.etapaId !== 9,
          ) // Filtrar apenas etapas válidas
          .map((etapa) => {
            return {
              id: etapa.id,
              ticketId: etapa.ticketId,
              etapaId: etapa.etapaId,
              dtInicio: etapa.dtInicio
                ? converteDataHoraInputISOParaBR(etapa.dtInicio)
                : null,
              dtFim: etapa.dtFim
                ? converteDataHoraInputISOParaBR(etapa.dtFim)
                : null,
              colaboradores: etapa.colaboradores || [],
              supervisores: etapa.supervisores || [],
              observacoes: etapa.observacoes || null,
              ocorrenciaJustificativa: etapa.ocorrenciaJustificativa || null,
              tempoOcorrencia: etapa.tempoOcorrencia || 0,
              vtr: etapa.vtr || null,
              salaPreparacao: etapa.salaPreparacao || null,
            };
          });
        // Encontrar ou criar a etapa
        let etapaSomato = this.servicoEditando.etapas.find(
          (e) => e.etapaId === 9,
        );
        if (!etapaSomato) {
          etapaSomato = {
            ticketId: this.servicoEditando.id,
            etapaId: 9,
            dtInicio: converteDataHoraInputISOParaBR(
              this.servicoEditando.dataInicioSomato,
            ),
            dtFim: converteDataHoraInputISOParaBR(
              this.servicoEditando.dataFimSomato,
            ),
            colaboradores: this.servicoEditando.colaboradoresSomato,
            supervisores: [],
            observacoes: null,
            ocorrenciaJustificativa: null,
            tempoOcorrencia: 0,
          };
          this.servicoEditando.etapas.push(etapaSomato);
        }

        this.servicoEditando.dataAtendimento = converteDataHoraInputISOParaBR(
          this.servicoEditando.dataAtendimento,
        );
        this.servicoEditando.dtFalecido = converteDataHoraInputISOParaBR(
          this.servicoEditando.dtFalecido,
        );

        this.servicoEditando.nascimentoFalecido = converteDataParaFormatoBR(
          this.servicoEditando.nascimentoFalecido,
        );
        this.servicoEditando.dataSepultamento = converteDataHoraInputISOParaBR(
          this.servicoEditando.dataSepultamento,
        );
        this.servicoEditando.dataVelorio = converteDataHoraInputISOParaBR(
          this.servicoEditando.dataVelorio,
        );

        this.servicoEditando.dataInicioSomato = converteDataHoraInputISOParaBR(
          this.servicoEditando.dataInicioSomato,
        );

        this.servicoEditando.dataFimSomato = converteDataHoraInputISOParaBR(
          this.servicoEditando.dataFimSomato,
        );

        this.servicoEditando.etapas.forEach((etapa) => {
          if (etapa) {
            etapa.ocorrenciaJustificativa =
              etapa.ocorrenciaJustificativa || null;
            etapa.tempoOcorrencia = etapa.tempoOcorrencia || 0;
          }
        });

        await fluxoCemiteriaisService.atualizar_servico(
          this.servicoEditando.id,
          this.servicoEditando,
        );
        this.init();

        this.fecharDialog();
      } catch (error) {
        console.error("Erro ao salvar edição:", error);
      }
    },
    async consultar_colaboradores(alerta = true) {
      try {
        if (!this.selectedCompany) {
          if (alerta) {
            this.showAlert(
              "Atenção",
              "Por favor, selecione uma empresa antes de continuar.",
            );
          }
          return;
        }
        const response = await rh.lista_colaboradores_por_empresa(
          this.selectedCompany,
        );
        this.listaColaboradores = response.data;
      } catch (e) {
        console.log(e);
      }
    },
    async carregarColunas() {
      try {
        const response = await fluxoCemiteriaisService.listar_etapas();
        if (response.status === 200) {
          this.colunas = response.data;
          this.colunasFiltros = [
            {
              id: 0,
              nome: "Todas",
              cor: "#4782b4",
              tipo: "Finalizado",
              etapaSuporte: false,
              sla: 60,
            },
            ...this.colunas,
          ].sort((a, b) => a.id - b.id);
          this.inicializarFiltroEtapasPadrao();
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },
    async carregarTarefas(servicosCemiteriais) {
      this.tarefasPorColuna = [];

      const mapa = {};
      this.colunas.forEach((coluna) => {
        mapa[coluna.id] = [];
      });

      servicosCemiteriais.forEach((item) => {
        if (mapa[item.etapa.id]) {
          mapa[item.etapa.id].push(item);
        }
      });

      this.tarefasPorColuna = mapa;
    },
    isColorDark(hexColor) {
      if (!hexColor) {
        return false;
      }
      if (!hexColor.startsWith("#")) {
        hexColor = "#" + hexColor;
      }
      const hex = hexColor.replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      const yiq = (r * 299 + g * 587 + b * 114) / 1000;
      return yiq < 128;
    },
    async aoArrastar(event, novaEtapa) {
      if (!this.hasPermissionEdit) {
        this.init();
        return;
      }

      const servicoArrastado = event.added?.element;
      const etapaAtual = event.added?.element.etapa;

      if (
        servicoArrastado &&
        servicoArrastado.solicitacaoTransporteFamiliar &&
        !servicoArrastado.solicitacaoTransporteFamiliar.includes(
          "SOLICITADO",
        ) &&
        novaEtapa.id === 6
      ) {
        this.showAlert(
          "Erro",
          "Serviço não pode ser arrastado para a etapa de transporte familiar, pois não foi solicitado.",
        );
        this.init();
        return;
      }

      if (!servicoArrastado) {
        return;
      }
      if (etapaAtual.id > novaEtapa.id) {
        await this.alterarEtapa(servicoArrastado, novaEtapa.id);
        return;
      }
      if (etapaAtual.tipo === "Agendado" || etapaAtual.tipo === "Falha") {
        await this.alterarEtapa(servicoArrastado, novaEtapa.id);
        return;
      }

      const etapaEncontrada = servicoArrastado.etapas.find(
        (etapa) => etapa.etapaId === etapaAtual.id,
      );
      if (
        !etapaEncontrada ||
        etapaEncontrada.dtInicio === null ||
        etapaEncontrada.dtFim === null ||
        etapaEncontrada.colaboradores.length === 0
      ) {
        if (etapaAtual.nome === "Preparação") {
          servicoArrastado.usoSomatoConservacao =
            servicoArrastado.usoSomatoConservacao
              ? servicoArrastado.usoSomatoConservacao
              : false;
        }
        this.abrirDialogFinalizarEtapa(servicoArrastado, etapaAtual);
        return;
      }

      await this.alterarEtapa(servicoArrastado, novaEtapa.id);
    },
    obterAgendaPorColuna(colunaId) {
      return this.servicosfemiteriais.filter(
        (servico) => servico.etapa.id === colunaId.id,
      );
    },
    isDateValid(dateString) {
      const date = new Date(dateString);
      return !isNaN(date.getTime());
    },

    filterData(valores) {
      this.isLoading = true;
      this.selectedStartDate = valores.selectedStartDate;
      this.selectedEndDate = valores.selectedEndDate;
      this.selectedCompany = valores.selectedCompany;

      if (
        this.calcularDiferencaEntreDatas(
          this.selectedStartDate,
          this.selectedEndDate,
        ) > 30
      ) {
        this.showFilter = true;
        return;
      }
      this.init();
    },

    getFirstDayOfMonth() {
      const dataAtual = new Date();
      const primeiroDiaDoMes = new Date(
        dataAtual.getFullYear(),
        dataAtual.getMonth(),
        1,
      );
      return this.formatDateBR(primeiroDiaDoMes);
    },

    formatDateBR(date) {
      if (!date) return "";
      const parsedDate = new Date(date);
      const day = String(parsedDate.getDate()).padStart(2, "0");
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
      const year = parsedDate.getFullYear();
      return `${day}/${month}/${year}`;
    },

    async dashboard(alerta = true) {
      this.servicosfemiteriais = [];
      this.isLoading = true;
      const formattedStartDate = converteDataParaFormatoISO(
        this.selectedStartDate,
      );
      const formattedEndDate = converteDataParaFormatoISO(this.selectedEndDate);
      if (!this.selectedCompany) {
        if (alerta) {
          this.showAlert(
            "Atenção",
            "Por favor, selecione uma empresa antes de continuar.",
          );
        }
        this.isLoading = false;
        return;
      }
      try {
        const response = await fluxoCemiteriaisService.listar({
          dataInicio: formattedStartDate,
          dataFim: formattedEndDate,
          empresa: this.selectedCompany,
        });
        if (response.status === 200) {
          this.servicosfemiteriais = response.data;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },
    verificarDialogos() {
      if (
        !this.dialogEtapa &&
        !this.dialogAtribuir &&
        !this.dialogConcluir &&
        !this.dialogEdicao &&
        !this.isMobile
      ) {
        this.init();
      }

      setTimeout(() => {
        this.verificarDialogos(); // vai rodar SEMPRE de novo
      }, 300000);
    },
    async init(alerta) {
      await this.carregarColunas();
      await this.dashboard(alerta);
      await this.filtrarTickets();
      await this.consultar_colaboradores(alerta);

      await this.carregarTarefas(this.servicosfemiteriais);
    },

    async consultarId(ticketId) {
      try {
        const response = await fluxoCemiteriaisService.buscar_por_id(ticketId);
        if (response.status === 200) {
          return response.data;
        }
      } catch (e) {
        console.error(e);
      }
    },

    async consultarHistorico(ticketId) {
      try {
        const response = await fluxoCemiteriaisService.buscar_historico(
          ticketId,
        );
        if (response.status === 200) {
          this.historico = response.data;
        }
      } catch (e) {
        console.error(e);
      }
    },

    async consultarAtividadesDisponiveis(etapaId) {
      try {
        const response = await fluxoCemiteriaisService.atividades_etapa(
          etapaId,
        );
        if (response.status === 200) {
          // Armazenar as atividades no objeto por etapa
          this.$set(this.atividadesDisponiveisPorEtapa, etapaId, response.data);

          // Manter a compatibilidade com o código existente
          this.atividadesDisponiveis = response.data;
        }
      } catch (e) {
        console.error(
          "Erro ao consultar atividades disponíveis para etapa " +
            etapaId +
            ":",
          e,
        );
        this.$set(this.atividadesDisponiveisPorEtapa, etapaId, []);
        this.atividadesDisponiveis = [];
      }
    },
    formatarMoeda(valor) {
      if (isNaN(valor)) {
        return "Valor inválido";
      }
      return valor.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    convertToBR(dateString) {
      const [year, month, day] = dateString.split("-");
      return `${day}/${month}/${year}`;
    },
    getStatus(status) {
      switch (status) {
        case "PARQUE DAS FLORES":
          return "orange darken-2";
        case "CEMITERIO PREVIDA":
          return "blue lighten-1";
        case "MEMORIAL PARQUE MACEIÓ":
          return "green lighten-1";
        case "PARQUE DO AGRESTE":
          return "cyan lighten-1";
        case "PREVIDA":
          return "blue lighten-1";

        default:
          "success";
      }
    },

    calcularDiferencaEntreDatas(dataInicial, dataFinal) {
      const [dia1, mes1, ano1] = dataInicial.split("/");
      const [dia2, mes2, ano2] = dataFinal.split("/");

      const data1 = new Date(`${ano1}-${mes1}-${dia1}`);
      const data2 = new Date(`${ano2}-${mes2}-${dia2}`);

      if (isNaN(data1) || isNaN(data2)) {
        return NaN;
      }

      const diferencaEmMilissegundos = data2 - data1;
      const diferencaEmDias = diferencaEmMilissegundos / (1000 * 60 * 60 * 24);

      return diferencaEmDias;
    },

    clear() {
      this.$refs.form.reset();
    },

    formatarDataHora(dataHoraISO) {
      if (!dataHoraISO) return "-";
      // Converte "2025-08-28T20:06:00" para "28/08/2025 20:06"
      const data = new Date(dataHoraISO);
      const dia = data.getDate().toString().padStart(2, "0");
      const mes = (data.getMonth() + 1).toString().padStart(2, "0");
      const ano = data.getFullYear();
      const hora = data.getHours().toString().padStart(2, "0");
      const minuto = data.getMinutes().toString().padStart(2, "0");
      return `${dia}/${mes}/${ano} ${hora}:${minuto}`;
    },

    async excluirAtividade(id) {
      if (!confirm("Tem certeza que deseja excluir esta atividade?")) {
        return;
      }

      this.excluindoAtividade = id;
      try {
        const response = await fluxoCemiteriaisService.excluir_atividade(id);
        if (response.status === 200) {
          // Recarregar as atividades
          await this.init();
          this.showAlert("Sucesso", "Atividade excluída com sucesso!");
        }
      } catch (error) {
        console.error("Erro ao excluir atividade:", error);
        this.showAlert("Erro", "Ocorreu um erro ao excluir a atividade.");
      } finally {
        this.excluindoAtividade = null;
        this.fecharDialog();
        this.fecharDialogEtapa();
      }
    },
    parseDateEtapa(dateStr) {
      if (!dateStr) return null;
      // Formato esperado: "dd/MM/yyyy HH:mm:ss"
      const [datePart, timePart] = dateStr.split(" ");
      const [day, month, year] = datePart.split("/");
      return new Date(`${year}-${month}-${day}T${timePart}`);
    },
    atividadeCompleta(atividade) {
      return (
        atividade.atividadeFunerariaId &&
        atividade.colaboradores &&
        atividade.colaboradores.length > 0 &&
        atividade.dtInicio
      );
    },
    async salvarAtividade(idEtapa, idServico) {
      this.salvandoAtividade = true;
      try {
        const servico = this.servicosfemiteriais.find(
          (s) => s.id === idServico,
        );

        // Encontrar a etapa específica do ticket
        if (!idEtapa) {
          this.showAlert(
            "Erro",
            "Não foi possível identificar a etapa do ticket.",
          );
          return;
        }
        const etapaTicket = servico.etapas.find((e) => e.etapaId === idEtapa);

        if (!etapaTicket) {
          this.showAlert(
            "Erro",
            "Não foi possível identificar a etapa do ticket. Inicie a etapa primeiro",
          );
          return;
        }
        const inicioAtividade = new Date(this.novaAtividade.dtInicio); // já está em ISO
        const fimAtividade = new Date(this.novaAtividade.dtFim);

        const inicioEtapa = this.parseDateEtapa(etapaTicket.dtInicio);
        const fimEtapa = this.parseDateEtapa(etapaTicket.dtFim);

        if (inicioAtividade < inicioEtapa) {
          this.showAlert(
            "Erro",
            "A data de início da atividade deve ser maior que a data de início da etapa",
          );
          return;
        }

        if (fimEtapa && fimAtividade > fimEtapa) {
          this.showAlert(
            "Erro",
            "A data de fim da atividade deve ser menor que a data de fim da etapa",
          );
          return;
        }

        const dto = {
          ticketFunerarioEtapaId: etapaTicket.id,
          atividadeFunerariaId: this.novaAtividade.atividadeFunerariaId,
          atividadeFunerariaDescricao:
            this.novaAtividade.atividadeFunerariaDescricao,
          dtInicio: this.novaAtividade.dtInicio,
          dtFim: this.novaAtividade.dtFim,
          tempoOcorrencia: this.novaAtividade.tempoOcorrencia,
          colaboradores: this.novaAtividade.colaboradores.map(
            (colaboradorId) => ({
              colaboradorId: colaboradorId,
            }),
          ),
        };

        const response = await fluxoCemiteriaisService.adicionar_atividade(dto);
        if (response.status === 200) {
          // Limpar o formulário
          this.novaAtividade = {
            atividadeFunerariaId: null,
            atividadeFunerariaDescricao: "",
            dtInicio: null,
            dtFim: null,
            tempoOcorrencia: null,
            colaboradores: [],
          };

          this.showAlert("Sucesso", "Atividade adicionada com sucesso!");
        }
        this.fecharDialog();
        this.fecharDialogEtapa();
        this.init();
      } catch (error) {
        console.error("Erro ao salvar atividade:", error);
        this.showAlert("Erro", "Ocorreu um erro ao salvar a atividade.");
      } finally {
        this.salvandoAtividade = false;
      }
    },

    getNomeColaborador(colaboradorId) {
      const colaborador = this.listaColaboradores.find(
        (c) => c.id === colaboradorId,
      );
      return colaborador ? colaborador.nome : "-";
    },

    // Método para verificar se deve avançar para a próxima etapa
    deveAvancarEtapa(servico) {
      // Obter referências às etapas relevantes usando IDs
      const etapaVelorio = servico.etapas.find((e) => e.etapaId === 5); // ID 5 = Velório
      const etapaTransporteFamiliar = servico.etapas.find(
        (e) => e.etapaId === 6,
      ); // ID 6 = Transporte familiar
      const isVelorioFinalizado = etapaVelorio && etapaVelorio.dtFim;

      // Caso 5: Na etapa de Transporte familiar (ID 6), se Velório não estiver concluído, não avança
      if (this.etapaAtual.id === 6 && !isVelorioFinalizado) {
        // Não avança a etapa e não abre dialog
        return false;
      }

      // Em todos os outros casos, avança para a próxima etapa
      return true;
    },

    // Método para verificar se deve exibir o diálogo de conclusão
    deveExibirDialogConclusao(servico) {
      // Obter referências às etapas relevantes usando IDs
      const etapaVelorio = this.servicoAtual.etapas.find(
        (e) => e.etapaId === 5,
      ); // ID 5 = Velório
      const etapaTransporteFamiliar = this.servicoAtual.etapas.find(
        (e) => e.etapaId === 6,
      ); // ID 6 = Transporte familiar
      const isVelorioFinalizado = etapaVelorio && etapaVelorio.dtFim;
      const isTransporteFinalizado =
        etapaTransporteFamiliar && etapaTransporteFamiliar.dtFim;

      // Caso 1: SOMENTE VELÓRIO - Na etapa de Velório (ID 5), abre dialog para concluir caso não tenha transporte familiar
      if (
        this.servicoAtual.etapa.id === 5 &&
        this.etapaAtual.id === 5 &&
        this.servicoAtual.solicitacaoTransporteFamiliar &&
        (this.servicoAtual.solicitacaoTransporteFamiliar.includes(
          "DISPENSADO",
        ) ||
          this.servicoAtual.solicitacaoTransporteFamiliar.includes(
            "NÃO DISPONIBILIZADO",
          ))
      ) {
        return true;
      }
      console.log(this.servicoAtual.etapa.id);
      console.log(this.etapaAtual.id);
      console.log(this.servicoAtual.solicitacaoTransporteFamiliar);

      // Caso 2: VELÓRIO E TRANSPORTE FAMILIAR - Na etapa de Velório (ID 5), caso Transporte familiar já esteja concluído
      if (
        this.servicoAtual.etapa.id === 5 &&
        this.etapaAtual.id === 5 &&
        isTransporteFinalizado
      ) {
        return true;
      }

      // Caso 4: VELÓRIO E TRANSPORTE FAMILIAR - Na etapa de Transporte familiar (ID 6), caso Velório já esteja concluído
      if (
        this.servicoAtual.etapa.id === 6 &&
        this.etapaAtual.id === 6 &&
        isVelorioFinalizado
      ) {
        return true;
      }

      // Caso 3: AMBOS FINALIZADOS - Quando ambas as etapas estão finalizadas
      if (isVelorioFinalizado && isTransporteFinalizado) {
        return true;
      }

      // Nos demais casos, não exibe o diálogo
      return false;
    },

    // Método para editar uma atividade existente
    editarAtividade(atividade) {
      this.modoEdicaoAtividade = true;
      this.atividadeEditandoId = atividade.id;
      this.editandoAtividade = true;

      // Preencher o formulário com os dados da atividade selecionada
      this.novaAtividade = {
        atividadeFunerariaId: atividade.atividadeFunerariaId,
        atividadeFunerariaDescricao: atividade.atividadeFunerariaDescricao,
        dtInicio: atividade.dtInicio,
        dtFim: atividade.dtFim,
        tempoOcorrencia: atividade.tempoOcorrencia,
        colaboradores: atividade.colaboradores.map((c) => c.colaboradorId),
        ticketFunerarioEtapaId: atividade.ticketFunerarioEtapaId,
      };

      // Rolar até o formulário de edição
      const formElement = document.getElementById(
        `atividade-form-${atividade.ticketFunerarioEtapa.etapaId}`,
      );
      if (formElement) {
        formElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },

    // Método para cancelar a edição de uma atividade
    cancelarEdicaoAtividade() {
      // Limpar o formulário
      this.novaAtividade = {
        atividadeFunerariaId: null,
        atividadeFunerariaDescricao: "",
        dtInicio: null,
        dtFim: null,
        tempoOcorrencia: null,
        colaboradores: [],
      };

      // Resetar o estado de edição
      this.modoEdicaoAtividade = false;
      this.atividadeEditandoId = null;
      this.editandoAtividade = false;
    },

    // Método para atualizar uma atividade existente
    async atualizarAtividade(idEtapa) {
      this.salvandoAtividadeEtapa = idEtapa;
      try {
        // Verificar se está em modo de edição e se tem um ID de atividade válido
        if (!this.modoEdicaoAtividade || !this.atividadeEditandoId) {
          this.showAlert("Erro", "Nenhuma atividade selecionada para edição.");
          return;
        }

        // Preparar o DTO para atualização
        const dto = {
          atividadeFunerariaId: this.novaAtividade.atividadeFunerariaId,
          atividadeFunerariaDescricao:
            this.novaAtividade.atividadeFunerariaDescricao,
          dtInicio: this.novaAtividade.dtInicio,
          dtFim: this.novaAtividade.dtFim,
          tempoOcorrencia: this.novaAtividade.tempoOcorrencia,
          colaboradores: this.novaAtividade.colaboradores.map(
            (colaboradorId) => ({
              colaboradorId: colaboradorId,
            }),
          ),
          ticketFunerarioEtapaId: this.novaAtividade.ticketFunerarioEtapaId,
        };

        // Chamar a API para atualizar a atividade
        const response = await fluxoCemiteriaisService.editar_atividade(
          dto,
          this.atividadeEditandoId,
        );

        if (response.status === 200) {
          // Limpar o formulário e resetar o estado
          this.cancelarEdicaoAtividade();
          this.showAlert("Sucesso", "Atividade adicionada com sucesso!");
        }

        this.fecharDialog();
        this.fecharDialogEtapa();
        this.init();
      } catch (error) {
        console.error("Erro ao atualizar atividade:", error);
        this.showAlert("Erro", "Ocorreu um erro ao atualizar a atividade.");
      } finally {
        this.salvandoAtividadeEtapa = null;
      }
    },

    isAtividadeCadastrada(atividadeId, etapaId) {
      // Verificar se a atividade está na lista de atividades da etapa especificada
      if (!this.servicoEditando || !this.servicoEditando.etapas) return false;

      // Obter a etapa especificada
      const etapa = this.servicoEditando.etapas.find(
        (e) => e.etapaId === etapaId,
      );
      if (!etapa || !etapa.atividades || !etapa.atividades.length) return false;

      // Verificar se a atividade já está cadastrada nesta etapa
      return etapa.atividades.some(
        (atividade) => atividade.atividadeFunerariaId === atividadeId,
      );
    },
  },
};

function converteDataParaFormatoISO(dataNoFormatoBR) {
  if (!dataNoFormatoBR) return null;
  const partes = dataNoFormatoBR.split("/");
  if (partes.length === 3) {
    const [dia, mes, ano] = partes;
    return `${ano}-${mes}-${dia}`;
  }
  return null;
}

function converteDataParaFormatoBR(dataNoFormatoISO) {
  if (!dataNoFormatoISO) return "";
  const [year, month, day] = dataNoFormatoISO.split("-");
  return `${day}/${month}/${year}`;
}

function converteDataHoraBRParaInputISO(dataHoraBR) {
  if (!dataHoraBR) return null;
  // Ex: "25/07/2025 02:42:50" → "2025-07-25T02:42"
  const [data, hora] = dataHoraBR.split(" ");
  const [dia, mes, ano] = data.split("/");

  const [horaStr, minutoStr] = hora.split(":");
  return `${ano}-${mes.padStart(2, "0")}-${dia.padStart(
    2,
    "0",
  )}T${horaStr}:${minutoStr}`;
}

function converteDataHoraInputISOParaBR(dataHoraISO) {
  // Ex: "2025-07-25T02:42" → "25/07/2025 02:42:00"
  if (!dataHoraISO) return "";
  if (!dataHoraISO.includes("T")) return dataHoraISO;
  const [data, hora] = dataHoraISO.split("T");
  const [ano, mes, dia] = data.split("-");
  const [hh, mm] = hora.split(":");
  return `${dia}/${mes}/${ano} ${hh}:${mm}:00`;
}

function dateToInputISO(date) {
  const pad = (n) => n.toString().padStart(2, "0");
  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate()) +
    "T" +
    pad(date.getHours()) +
    ":" +
    pad(date.getMinutes())
  );
}
</script>

<style scoped>
.custom-tabs {
  background-color: #fafafa;
  margin-top: 1rem;
}

.cards-container {
  background-color: #f5f5f5;
  border-radius: 0 0 4px 4px;
  margin-top: -4px;
}

/* Ajuste para mobile */
@media (max-width: 600px) {
  .custom-tabs .v-tab {
    font-size: 0.8rem;
    padding: 0 8px;
    min-width: auto; /* deixa o botão mais estreito */
  }
}
.v-progress-circular {
  margin: 1rem;
}

.custom-gray-background {
  height: 90px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex: 0 1 auto !important;
  margin: -12px;
}

/* Defina uma classe para preencher a largura horizontalmente e centralizar verticalmente */
.fill-width {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  display: flex;
}

.v-menu__content {
  box-shadow: none !important;
  top: 4px !important;
}

.gray-row {
  background-color: #e7f1ff; /* ou qualquer outra cor cinza que você preferir */
}
.cor-row {
  background-color: #f8ded4;
  transition: none !important; /* Desativa a transição de cor */
}

.linha {
  font-size: 11px !important;
  font-weight: normal;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.no-hover-effect.v-data-table tbody tr:hover {
  color: #3055a4;
}

.fluxo-view-toolbar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 8px;
  width: 100%;
}

.fluxo-view-toggle {
  display: inline-flex;
  padding: 0;
  background: #f8fafc;
  overflow: hidden;
}

.fluxo-view-toggle .v-btn {
  box-shadow: none !important;
  border-radius: 0 !important;
  min-width: 86px !important;
  height: 34px !important;
  text-transform: none;
  letter-spacing: 0;
  font-size: 12px;
  font-weight: 600;
  color: #475569 !important;
  background: transparent !important;
  transition: 0.18s;
}

.fluxo-view-toggle .v-btn:first-child {
  border-radius: 5px 0 0 5px !important;
}

.fluxo-view-toggle .v-btn:last-child {
  border-radius: 0 5px 5px 0 !important;
}

.fluxo-view-toggle .v-btn--active {
  background: #111827 !important;
  color: #fff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18) !important;
}

.fluxo-view-toggle .v-btn--active .v-icon {
  color: white !important;
}

.fluxo-view-toggle .v-btn .v-icon {
  margin-right: 6px;
}

.excel-export-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.excel-export-icon {
  color: green;
  font-size: 48px;
  line-height: 1;
  margin-right: 12px;
  cursor: pointer;
  min-width: 48px;
  min-height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.excel-export-icon.disabled {
  color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.65;
}

.ticket-list-view {
  overflow: visible;
}

.ticket-list-table {
  background: #fff;
}

.ticket-list-table >>> th {
  font-size: 11px !important;
  font-weight: bold !important;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.pointer {
  cursor: pointer;
}

.lista-subtexto {
  color: #64748b;
  font-size: 11px;
  margin-top: 2px;
}
.card-container {
  display: flex;
  justify-content: space-around; /* ou outro alinhamento que desejar */
}

.primeira-linha-estilo {
  font-size: 5px !important;
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.kanban-container {
  background-color: #f5f5f5;
  min-height: 100vh;
  padding: 0;
}

.kanban-board {
  padding: 16px;
  overflow-x: auto;
  padding-top: 0;
}

.kanban-colunas {
  display: flex;
  gap: 16px;
  min-height: calc(100vh - 30vh);
}

.kanban-coluna {
  min-width: 280px;
  max-width: 320px;
  flex-shrink: 0;
}

.kanban-card {
  display: flex;
  flex-direction: column;
  background: #fafafa;
}

.kanban-cabecalho {
  border-bottom: 1px solid #e0e0e0;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.indicador-coluna {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.tarefas-container {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.tarefa-card {
  cursor: pointer;
  transition: 0.2s ease;
  background: white;
  border: 1px solid #e0e0e0;
}

.tarefa-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.btn-adicionar {
  margin-top: 8px;
  min-height: 32px !important;
  font-size: 0.8rem !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.text-gray {
  color: #616161 !important;
}

.text-white {
  color: white;
}
.text-black {
  color: black;
}
.card-placeholder {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.4;
  border: 2px dashed #ccc;
}

.fixed-action-buttons-bottom {
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
}
</style>
